import React, { useState } from 'react';
import style from './../../Css/Courses.module.css'

function Bootstrapcourse() {
  // State to keep track of the selected chapter
  const [selectedChapter, setSelectedChapter] = useState('chapter1')

  // Function to handle chapter selection
  const handleChapterClick = (chapter) => {
    setSelectedChapter(chapter)
  }

  // State to track the active chapter
  const [activeChapter, setActiveChapter] = useState('chapter1');

  // Function to handle chapter click
  const handleChapterActive = (chapter) => {
    setActiveChapter(chapter);
  };
  const handleClick = (chapter) => {
    handleChapterActive(chapter);
    handleChapterClick(chapter);
    window.scrollTo(0, 0);
  };


  return (
    <div className={`${style.firstcontainer} container-fluid`}>

      <div className={`${style.therow} row`}>
        <div className={`${style.droupdownbtnbar} dropdown`}>
          <button className={`${style.droupdownbtn} btn dropdown-toggle`} type="button" data-bs-toggle="dropdown" aria-expanded="false">
            Bootstrap
          </button>

          <ul className={`${style.dropdownmenu} dropdown-menu`}>

         



            <li
              onClick={() => handleClick('chapter1')}

              className={`${style.chapter1} ${activeChapter === 'chapter1' ? style.active : ''} dropdown-item `}>
              Intoduction
            </li>





            <li
              onClick={() => handleClick('chapter2')}
              className={`${style.chapter2} ${activeChapter === 'chapter2' ? style.active : ''} dropdown-item  `}>
              History and Evolution
            </li>


            <li onClick={() => handleClick('chapter3')}
              className={`${style.chapter3} ${activeChapter === 'chapter3' ? style.active : ''} dropdown-item  `}>
              Features of Bootstrap
            </li>

            <li onClick={() => handleClick('chapter4')}
              className={`${style.chapter4} ${activeChapter === 'chapter4' ? style.active : ''} dropdown-item  `}>
              Grid Basics
            </li>


            <li onClick={() => handleClick('chapter5')}
              className={`${style.chapter5} ${activeChapter === 'chapter5' ? style.active : ''} dropdown-item  `}>
              Typography
            </li>


            <li onClick={() => handleClick('chapter6')}
              className={`${style.chapter6} ${activeChapter === 'chapter6' ? style.active : ''} dropdown-item  `}>
              Tables
            </li>

            <li onClick={() => handleClick('chapter7')}
              className={`${style.chapter7} ${activeChapter === 'chapter7' ? style.active : ''} dropdown-item  `}>
              Images
            </li>


            <li onClick={() => handleClick('chapter8')}
              className={`${style.chapter8} ${activeChapter === 'chapter8' ? style.active : ''} dropdown-item  `}>
              Jumbotron
            </li>

            <li onClick={() => handleClick('chapter9')}
              className={`${style.chapter9} ${activeChapter === 'chapter9' ? style.active : ''} dropdown-item  `}>
              Wells
            </li>

            <li onClick={() => handleClick('chapter10')}
              className={`${style.chapter10} ${activeChapter === 'chapter10' ? style.active : ''} dropdown-item  `}>
              Alert
            </li>

            <li onClick={() => handleClick('chapter11')}
              className={`${style.chapter11} ${activeChapter === 'chapter11' ? style.active : ''} dropdown-item  `}>
              Buttons
            </li>


            <li onClick={() => handleClick('chapter12')}
              className={`${style.chapter12} ${activeChapter === 'chapter12' ? style.active : ''} dropdown-item  `}>
              Button Groups
            </li>

            <li onClick={() => handleClick('chapter13')}
              className={`${style.chapter13} ${activeChapter === 'chapter13' ? style.active : ''} dropdown-item  `}>
              Glyphicons
            </li>

            <li onClick={() => handleClick('chapter14')}
              className={`${style.chapter14} ${activeChapter === 'chapter14' ? style.active : ''} dropdown-item  `}>
              Badges/Labels
            </li>

            <li onClick={() => handleClick('chapter15')}
              className={`${style.chapter15} ${activeChapter === 'chapter15' ? style.active : ''} dropdown-item  `}>
              Progress Bars
            </li>



            <li onClick={() => handleClick('chapter16')}
              className={`${style.chapter16} ${activeChapter === 'chapter16' ? style.active : ''} dropdown-item  `}>
              Pagination
            </li>

            <li onClick={() => handleClick('chapter17')}
              className={`${style.chapter17} ${activeChapter === 'chapter17' ? style.active : ''} dropdown-item  `}>
              Pager
            </li>


            <li onClick={() => handleClick('chapter18')}
              className={`${style.chapter18} ${activeChapter === 'chapter18' ? style.active : ''} dropdown-item  `}>
              List Groups
            </li>


            <li onClick={() => handleClick('chapter19')}
              className={`${style.chapter19} ${activeChapter === 'chapter19' ? style.active : ''} dropdown-item  `}>
              Panels
            </li>

            <li onClick={() => handleClick('chapter20')}
              className={`${style.chapter20} ${activeChapter === 'chapter20' ? style.active : ''} dropdown-item  `}>
              Dropdowns
            </li>

            <li onClick={() => handleClick('chapter21')}
              className={`${style.chapter21} ${activeChapter === 'chapter21' ? style.active : ''} dropdown-item  `}>
              Collapse
            </li>


            <li onClick={() => handleClick('chapter22')}
              className={`${style.chapter22} ${activeChapter === 'chapter22' ? style.active : ''} dropdown-item  `}>
              Tabs/Pills
            </li>

            <li onClick={() => handleClick('chapter23')}
              className={`${style.chapter23} ${activeChapter === 'chapter23' ? style.active : ''} dropdown-item  `}>
              Navbar
            </li>


            <li onClick={() => handleClick('chapter24')}
              className={`${style.chapter24} ${activeChapter === 'chapter24' ? style.active : ''} dropdown-item  `}>
              Forms
            </li>

            <li onClick={() => handleClick('chapter25')}
              className={`${style.chapter25} ${activeChapter === 'chapter25' ? style.active : ''} dropdown-item  `}>
              Inputs
            </li>

            <li onClick={() => handleClick('chapter26')}
              className={`${style.chapter26} ${activeChapter === 'chapter26' ? style.active : ''} dropdown-item  `}>
              Input 2
            </li>

            <li onClick={() => handleClick('chapter27')}
              className={`${style.chapter27} ${activeChapter === 'chapter27' ? style.active : ''} dropdown-item  `}>
              Input Sizing
            </li>


            <li onClick={() => handleClick('chapter28')}
              className={`${style.chapter28} ${activeChapter === 'chapter28' ? style.active : ''} dropdown-item  `}>
              Media Objects
            </li>


            <li onClick={() => handleClick('chapter29')}
              className={`${style.chapter29} ${activeChapter === 'chapter29' ? style.active : ''} dropdown-item  `}>
              Carousel
            </li>

            <li onClick={() => handleClick('chapter30')}
              className={`${style.chapter30} ${activeChapter === 'chapter30' ? style.active : ''} dropdown-item  `}>
              Modal
            </li>


            <li onClick={() => handleClick('chapter31')}
              className={`${style.chapter31} ${activeChapter === 'chapter31' ? style.active : ''} dropdown-item  `}>
              Tooltip
            </li>

            <li onClick={() => handleClick('chapter32')}
              className={`${style.chapter32} ${activeChapter === 'chapter32' ? style.active : ''} dropdown-item  `}>
              Popover
            </li>


            <li onClick={() => handleClick('chapter33')}
              className={`${style.chapter33} ${activeChapter === 'chapter33' ? style.active : ''} dropdown-item  `}>
              Scrollspy
            </li>

            <li onClick={() => handleClick('chapter34')}
              className={`${style.chapter34} ${activeChapter === 'chapter34' ? style.active : ''} dropdown-item  `}>
              Affix
            </li>


            <li onClick={() => handleClick('chapter35')}
              className={`${style.chapter35} ${activeChapter === 'chapter35' ? style.active : ''} dropdown-item   `}>
              Filters
            </li>


            <h5>Bootstrap Gride</h5>
            <li onClick={() => handleClick('chapter37')}
              className={`${style.chapter37} ${activeChapter === 'chapter37' ? style.active : ''} dropdown-item  `}>
              Grid System
            </li>

            <li onClick={() => handleClick('chapter38')}
              className={`${style.chapter38} ${activeChapter === 'chapter38' ? style.active : ''} dropdown-item  `}>
              Stacked/Horizontal
            </li>

            <li onClick={() => handleClick('chapter39')}
              className={`${style.chapter39} ${activeChapter === 'chapter39' ? style.active : ''} dropdown-item  `}>
              Grid Small
            </li>

            <li onClick={() => handleClick('chapter40')}
              className={`${style.chapter40} ${activeChapter === 'chapter40' ? style.active : ''} dropdown-item  `}>
              Grid Medium
            </li>


            <li onClick={() => handleClick('chapter41')}
              className={`${style.chapter41} ${activeChapter === 'chapter41' ? style.active : ''} dropdown-item  `}>
              Gride Large
            </li>

            <li onClick={() => handleClick('chapter42')}
              className={`${style.chapter42} ${activeChapter === 'chapter42' ? style.active : ''} dropdown-item  `}>
              Gride Examples
            </li>

            <h5>Bootstrap Themes</h5>
            <li onClick={() => handleClick('chapter43')}
              className={`${style.chapter43} ${activeChapter === 'chapter43' ? style.active : ''} dropdown-item  `}>
              Tamplates
            </li>


            <li onClick={() => handleClick('chapter44')}
              className={`${style.chapter44} ${activeChapter === 'chapter44' ? style.active : ''} dropdown-item  `}>
              Benefits
            </li>




            <h5>Bootstrap Examples</h5>
            <li onClick={() => handleClick('chapter45')}
              className={`${style.chapter45} ${activeChapter === 'chapter45' ? style.active : ''} dropdown-item  `}>
              Examples
            </li>

            <li onClick={() => handleClick('chapter46')}
              className={`${style.chapter46} ${activeChapter === 'chapter46' ? style.active : ''} dropdown-item  `}>
              Editor
            </li>


            <li onClick={() => handleClick('chapter47')}
              className={`${style.chapter47} ${activeChapter === 'chapter47' ? style.active : ''} dropdown-item  `}>
              Quiz
            </li>



            <li onClick={() => handleClick('chapter48')}
              className={`${style.chapter48} ${activeChapter === 'chapter48' ? style.active : ''} dropdown-item  `}>
              Inerview Prep
            </li>


            <h5>Bootstrap CSS Ref</h5>
            <li onClick={() => handleClick('chapter50')}
              className={`${style.chapter50} ${activeChapter === 'chapter50' ? style.active : ''} dropdown-item  `}>
              CSS All Classes
            </li>

            <li onClick={() => handleClick('chapter51')}
              className={`${style.chapter51} ${activeChapter === 'chapter51' ? style.active : ''} dropdown-item  `}>
              CSS Typography
            </li>

            <li onClick={() => handleClick('chapter52')}
              className={`${style.chapter52} ${activeChapter === 'chapter52' ? style.active : ''} dropdown-item  `}>
              CSS Buttons
            </li>


            <li onClick={() => handleClick('chapter53')}
              className={`${style.chapter53} ${activeChapter === 'chapter53' ? style.active : ''} dropdown-item  `}>
              CSS Forms
            </li>

            <li onClick={() => handleClick('chapter54')}
              className={`${style.chapter54} ${activeChapter === 'chapter54' ? style.active : ''} dropdown-item  `}>
              CSS Helpers
            </li>

            <li onClick={() => handleClick('chapter55')}
              className={`${style.chapter55} ${activeChapter === 'chapter55' ? style.active : ''} dropdown-item  `}>
              Images
            </li>

            <li onClick={() => handleClick('chapter56')}
              className={`${style.chapter56} ${activeChapter === 'chapter56' ? style.active : ''} dropdown-item  `}>
              Tables
            </li>



            <li onClick={() => handleClick('chapter57')}
              className={`${style.chapter57} ${activeChapter === 'chapter57' ? style.active : ''} dropdown-item  `}>
              Dropdowns
            </li>

            <li onClick={() => handleClick('chapter58')}
              className={`${style.chapter58} ${activeChapter === 'chapter58' ? style.active : ''} dropdown-item  `}>
              Navs
            </li>

            <li onClick={() => handleClick('chapter59')}
              className={`${style.chapter59} ${activeChapter === 'chapter59' ? style.active : ''} dropdown-item  `}>
              Glyphicons
            </li>

            <h5>Bootstrap JS Ref</h5>
            <li onClick={() => handleClick('chapter60')}
              className={`${style.chapter60} ${activeChapter === 'chapter60' ? style.active : ''} dropdown-item  `}>
              Affix
            </li>

            <li onClick={() => handleClick('chapter61')}
              className={`${style.chapter61} ${activeChapter === 'chapter61' ? style.active : ''} dropdown-item  `}>
              Alert
            </li>

            <li onClick={() => handleClick('chapter62')}
              className={`${style.chapter62} ${activeChapter === 'chapter62' ? style.active : ''} dropdown-item  `}>
              Button
            </li>

            <li onClick={() => handleClick('chapter63')}
              className={`${style.chapter63} ${activeChapter === 'chapter63' ? style.active : ''} dropdown-item  `}>
              Carosul
            </li>

            <li onClick={() => handleClick('chapter64')}
              className={`${style.chapter64} ${activeChapter === 'chapter64' ? style.active : ''} dropdown-item  `}>
              Collapse
            </li>


            <li onClick={() => handleClick('chapter65')}
              className={`${style.chapter65} ${activeChapter === 'chapter65' ? style.active : ''} dropdown-item  `}>
              Dropdown
            </li>

            <li onClick={() => handleClick('chapter66')}
              className={`${style.chapter66} ${activeChapter === 'chapter66' ? style.active : ''} dropdown-item  `}>
              Modal
            </li>

            <li onClick={() => handleClick('chapter67')}
              className={`${style.chapter67} ${activeChapter === 'chapter67' ? style.active : ''} dropdown-item  `}>
              Popover
            </li>

            <li onClick={() => handleClick('chapter68')}
              className={`${style.chapter68} ${activeChapter === 'chapter68' ? style.active : ''} dropdown-item  `}>
              Scrollspy
            </li>

            <li onClick={() => handleClick('chapter69')}
              className={`${style.chapter69} ${activeChapter === 'chapter69' ? style.active : ''} dropdown-item  `}>
              Tab
            </li>

            <li onClick={() => handleClick('chapter70')}
              className={`${style.chapter70} ${activeChapter === 'chapter70' ? style.active : ''} dropdown-item  `}>
              Tooltip
            </li>








          </ul>
        </div>





        <div className={`${style.leftcolumn} col-2`}>

          <ul className={`${style.chapters} `}>
            <h5 className={style.stickyheading} >Bootstrap</h5>

            <li
              onClick={() => handleClick('chapter1')}

              className={`${style.chapter1} ${activeChapter === 'chapter1' ? style.active : ''} `}>
              Intoduction
            </li>





            <li
              onClick={() => handleClick('chapter2')}
              className={`${style.chapter2} ${activeChapter === 'chapter2' ? style.active : ''}  `}>
              History and Evolution
            </li>


            <li onClick={() => handleClick('chapter3')}
              className={`${style.chapter3} ${activeChapter === 'chapter3' ? style.active : ''} `}>
              Features of Bootstrap
            </li>

            <li onClick={() => handleClick('chapter4')}
              className={`${style.chapter4} ${activeChapter === 'chapter4' ? style.active : ''}  `}>
              Grid Basics
            </li>


            <li onClick={() => handleClick('chapter5')}
              className={`${style.chapter5} ${activeChapter === 'chapter5' ? style.active : ''}  `}>
              Typography
            </li>


            <li onClick={() => handleClick('chapter6')}
              className={`${style.chapter6} ${activeChapter === 'chapter6' ? style.active : ''} `}>
              Tables
            </li>

            <li onClick={() => handleClick('chapter7')}
              className={`${style.chapter7} ${activeChapter === 'chapter7' ? style.active : ''} `}>
              Images
            </li>


            <li onClick={() => handleClick('chapter8')}
              className={`${style.chapter8} ${activeChapter === 'chapter8' ? style.active : ''}  `}>
              Jumbotron
            </li>

            <li onClick={() => handleClick('chapter9')}
              className={`${style.chapter9} ${activeChapter === 'chapter9' ? style.active : ''} `}>
              Wells
            </li>

            <li onClick={() => handleClick('chapter10')}
              className={`${style.chapter10} ${activeChapter === 'chapter10' ? style.active : ''}  `}>
              Alert
            </li>

            <li onClick={() => handleClick('chapter11')}
              className={`${style.chapter11} ${activeChapter === 'chapter11' ? style.active : ''} `}>
              Buttons
            </li>


            <li onClick={() => handleClick('chapter12')}
              className={`${style.chapter12} ${activeChapter === 'chapter12' ? style.active : ''} `}>
              Button Groups
            </li>

            <li onClick={() => handleClick('chapter13')}
              className={`${style.chapter13} ${activeChapter === 'chapter13' ? style.active : ''}  `}>
              Glyphicons
            </li>

            <li onClick={() => handleClick('chapter14')}
              className={`${style.chapter14} ${activeChapter === 'chapter14' ? style.active : ''}  `}>
              Badges/Labels
            </li>

            <li onClick={() => handleClick('chapter15')}
              className={`${style.chapter15} ${activeChapter === 'chapter15' ? style.active : ''}  `}>
              Progress Bars
            </li>



            <li onClick={() => handleClick('chapter16')}
              className={`${style.chapter16} ${activeChapter === 'chapter16' ? style.active : ''}  `}>
              Pagination
            </li>

            <li onClick={() => handleClick('chapter17')}
              className={`${style.chapter17} ${activeChapter === 'chapter17' ? style.active : ''}  `}>
              Pager
            </li>


            <li onClick={() => handleClick('chapter18')}
              className={`${style.chapter18} ${activeChapter === 'chapter18' ? style.active : ''}  `}>
              List Groups
            </li>


            <li onClick={() => handleClick('chapter19')}
              className={`${style.chapter19} ${activeChapter === 'chapter19' ? style.active : ''}  `}>
              Panels
            </li>

            <li onClick={() => handleClick('chapter20')}
              className={`${style.chapter20} ${activeChapter === 'chapter20' ? style.active : ''}  `}>
              Dropdowns
            </li>

            <li onClick={() => handleClick('chapter21')}
              className={`${style.chapter21} ${activeChapter === 'chapter21' ? style.active : ''}  `}>
              Collapse
            </li>


            <li onClick={() => handleClick('chapter22')}
              className={`${style.chapter22} ${activeChapter === 'chapter22' ? style.active : ''}  `}>
              Tabs/Pills
            </li>

            <li onClick={() => handleClick('chapter23')}
              className={`${style.chapter23} ${activeChapter === 'chapter23' ? style.active : ''}  `}>
              Navbar
            </li>


            <li onClick={() => handleClick('chapter24')}
              className={`${style.chapter24} ${activeChapter === 'chapter24' ? style.active : ''}  `}>
              Forms
            </li>

            <li onClick={() => handleClick('chapter25')}
              className={`${style.chapter25} ${activeChapter === 'chapter25' ? style.active : ''}  `}>
              Inputs
            </li>

            <li onClick={() => handleClick('chapter26')}
              className={`${style.chapter26} ${activeChapter === 'chapter26' ? style.active : ''}  `}>
              Input 2
            </li>

            <li onClick={() => handleClick('chapter27')}
              className={`${style.chapter27} ${activeChapter === 'chapter27' ? style.active : ''}  `}>
              Input Sizing
            </li>


            <li onClick={() => handleClick('chapter28')}
              className={`${style.chapter28} ${activeChapter === 'chapter28' ? style.active : ''}  `}>
              Media Objects
            </li>


            <li onClick={() => handleClick('chapter29')}
              className={`${style.chapter29} ${activeChapter === 'chapter29' ? style.active : ''} `}>
              Carousel
            </li>

            <li onClick={() => handleClick('chapter30')}
              className={`${style.chapter30} ${activeChapter === 'chapter30' ? style.active : ''} `}>
              Modal
            </li>


            <li onClick={() => handleClick('chapter31')}
              className={`${style.chapter31} ${activeChapter === 'chapter31' ? style.active : ''} `}>
              Tooltip
            </li>

            <li onClick={() => handleClick('chapter32')}
              className={`${style.chapter32} ${activeChapter === 'chapter32' ? style.active : ''} `}>
              Popover
            </li>


            <li onClick={() => handleClick('chapter33')}
              className={`${style.chapter33} ${activeChapter === 'chapter33' ? style.active : ''} `}>
              Scrollspy
            </li>

            <li onClick={() => handleClick('chapter34')}
              className={`${style.chapter34} ${activeChapter === 'chapter34' ? style.active : ''} `}>
              Affix
            </li>


            <li onClick={() => handleClick('chapter35')}
              className={`${style.chapter35} ${activeChapter === 'chapter35' ? style.active : ''}  `}>
              Filters
            </li>


            <h5>Bootstrap Gride</h5>
            <li onClick={() => handleClick('chapter37')}
              className={`${style.chapter37} ${activeChapter === 'chapter37' ? style.active : ''}  `}>
              Grid System
            </li>

            <li onClick={() => handleClick('chapter38')}
              className={`${style.chapter38} ${activeChapter === 'chapter38' ? style.active : ''}  `}>
              Stacked/Horizontal
            </li>

            <li onClick={() => handleClick('chapter39')}
              className={`${style.chapter39} ${activeChapter === 'chapter39' ? style.active : ''}  `}>
              Grid Small
            </li>

            <li onClick={() => handleClick('chapter40')}
              className={`${style.chapter40} ${activeChapter === 'chapter40' ? style.active : ''}  `}>
              Grid Medium
            </li>


            <li onClick={() => handleClick('chapter41')}
              className={`${style.chapter41} ${activeChapter === 'chapter41' ? style.active : ''}  `}>
              Gride Large
            </li>

            <li onClick={() => handleClick('chapter42')}
              className={`${style.chapter42} ${activeChapter === 'chapter42' ? style.active : ''}  `}>
              Gride Examples
            </li>

            <h5>Bootstrap Themes</h5>
            <li onClick={() => handleClick('chapter43')}
              className={`${style.chapter43} ${activeChapter === 'chapter43' ? style.active : ''}  `}>
              Tamplates
            </li>


            <li onClick={() => handleClick('chapter44')}
              className={`${style.chapter44} ${activeChapter === 'chapter44' ? style.active : ''}  `}>
              Benefits
            </li>




            <h5>Bootstrap Examples</h5>
            <li onClick={() => handleClick('chapter45')}
              className={`${style.chapter45} ${activeChapter === 'chapter45' ? style.active : ''}  `}>
              Examples
            </li>

            <li onClick={() => handleClick('chapter46')}
              className={`${style.chapter46} ${activeChapter === 'chapter46' ? style.active : ''}  `}>
              Editor
            </li>


            <li onClick={() => handleClick('chapter47')}
              className={`${style.chapter47} ${activeChapter === 'chapter47' ? style.active : ''}  `}>
              Quiz
            </li>



            <li onClick={() => handleClick('chapter48')}
              className={`${style.chapter48} ${activeChapter === 'chapter48' ? style.active : ''}  `}>
              Inerview Prep
            </li>


            <h5>Bootstrap CSS Ref</h5>
            <li onClick={() => handleClick('chapter50')}
              className={`${style.chapter50} ${activeChapter === 'chapter50' ? style.active : ''}  `}>
              CSS All Classes
            </li>

            <li onClick={() => handleClick('chapter51')}
              className={`${style.chapter51} ${activeChapter === 'chapter51' ? style.active : ''}  `}>
              CSS Typography
            </li>

            <li onClick={() => handleClick('chapter52')}
              className={`${style.chapter52} ${activeChapter === 'chapter52' ? style.active : ''}  `}>
              CSS Buttons
            </li>


            <li onClick={() => handleClick('chapter53')}
              className={`${style.chapter53} ${activeChapter === 'chapter53' ? style.active : ''}  `}>
              CSS Forms
            </li>

            <li onClick={() => handleClick('chapter54')}
              className={`${style.chapter54} ${activeChapter === 'chapter54' ? style.active : ''}  `}>
              CSS Helpers
            </li>

            <li onClick={() => handleClick('chapter55')}
              className={`${style.chapter55} ${activeChapter === 'chapter55' ? style.active : ''}  `}>
              Images
            </li>

            <li onClick={() => handleClick('chapter56')}
              className={`${style.chapter56} ${activeChapter === 'chapter56' ? style.active : ''}  `}>
              Tables
            </li>



            <li onClick={() => handleClick('chapter57')}
              className={`${style.chapter57} ${activeChapter === 'chapter57' ? style.active : ''}  `}>
              Dropdowns
            </li>

            <li onClick={() => handleClick('chapter58')}
              className={`${style.chapter58} ${activeChapter === 'chapter58' ? style.active : ''}  `}>
              Navs
            </li>

            <li onClick={() => handleClick('chapter59')}
              className={`${style.chapter59} ${activeChapter === 'chapter59' ? style.active : ''}  `}>
              Glyphicons
            </li>

            <h5>Bootstrap JS Ref</h5>
            <li onClick={() => handleClick('chapter60')}
              className={`${style.chapter60} ${activeChapter === 'chapter60' ? style.active : ''}  `}>
              Affix
            </li>

            <li onClick={() => handleClick('chapter61')}
              className={`${style.chapter61} ${activeChapter === 'chapter61' ? style.active : ''}  `}>
              Alert
            </li>

            <li onClick={() => handleClick('chapter62')}
              className={`${style.chapter62} ${activeChapter === 'chapter62' ? style.active : ''}  `}>
              Button
            </li>

            <li onClick={() => handleClick('chapter63')}
              className={`${style.chapter63} ${activeChapter === 'chapter63' ? style.active : ''}  `}>
              Carosul
            </li>

            <li onClick={() => handleClick('chapter64')}
              className={`${style.chapter64} ${activeChapter === 'chapter64' ? style.active : ''}  `}>
              Collapse
            </li>


            <li onClick={() => handleClick('chapter65')}
              className={`${style.chapter65} ${activeChapter === 'chapter65' ? style.active : ''}  `}>
              Dropdown
            </li>

            <li onClick={() => handleClick('chapter66')}
              className={`${style.chapter66} ${activeChapter === 'chapter66' ? style.active : ''}  `}>
              Modal
            </li>

            <li onClick={() => handleClick('chapter67')}
              className={`${style.chapter67} ${activeChapter === 'chapter67' ? style.active : ''}  `}>
              Popover
            </li>

            <li onClick={() => handleClick('chapter68')}
              className={`${style.chapter68} ${activeChapter === 'chapter68' ? style.active : ''}  `}>
              Scrollspy
            </li>

            <li onClick={() => handleClick('chapter69')}
              className={`${style.chapter69} ${activeChapter === 'chapter69' ? style.active : ''}  `}>
              Tab
            </li>

            <li onClick={() => handleClick('chapter70')}
              className={`${style.chapter70} ${activeChapter === 'chapter70' ? style.active : ''}  `}>
              Tooltip
            </li>







          </ul>
        </div>




        <div className={`${style.rightcolumn} col`}>


          {/* Chapter Content */}


          {selectedChapter === 'chapter1' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Introduction</h1>
              <p>
                Bootstrap is a popular, open-source front-end framework designed for building responsive and visually appealing websites and web applications. It was developed by <strong>Twitter</strong> and is now maintained by the open-source community. Bootstrap provides a set of pre-designed, responsive grid systems, components, utilities, and JavaScript plugins that help developers quickly design and customize their websites.
              </p><br />

              <h4 style={{ paddingBottom: "6px" }}>Here are some key aspects of Bootstrap:</h4>

              <h5>1. Grid System</h5>
              <p>
                Bootstrap comes with a powerful 12-column grid system that allows you to create complex layouts with ease. The grid is fully responsive, meaning it adjusts to different screen sizes (e.g., mobile, tablet, desktop). You can define how many columns an element should span on each screen size (e.g., large, medium, small).
              </p>
              <p>Example of a basic grid system:</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="row">
  <div class="col-md-4">Column 1</div>
  <div class="col-md-4">Column 2</div>
  <div class="col-md-4">Column 3</div>
</div>`}
                </code>
              </pre><br />

              <h5>2. Responsive Design</h5>
              <p>
                Bootstrap’s grid system and pre-built CSS classes allow for responsive design, meaning that your website will look great on all devices without requiring additional custom CSS. It uses media queries to adjust the layout based on the screen size.
              </p>
              <p>
                For instance, you can have one layout on mobile devices and a more complex layout on larger screens.
              </p><br />

              <h5>3. Pre-built Components</h5>
              <p>
                Bootstrap provides a wide variety of reusable components such as:
                <ul>
                  <li><strong>Buttons</strong>: Pre-styled buttons with different colors, sizes, and actions.</li><br />
                  <li><strong>Forms</strong>: Styles for text fields, checkboxes, radio buttons, and form validation.</li><br />
                  <li><strong>Navbars</strong>: Responsive navigation bars.</li><br />
                  <li><strong>Cards</strong>: A flexible and extensible content container.</li><br />
                  <li><strong>Modals</strong>: Pre-designed pop-up boxes for displaying content.</li><br />
                  <li><strong>Dropdowns</strong>, <strong>Alerts</strong>, and more.</li>
                </ul>
              </p>
              <p>Example of a button:</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<button class="btn btn-primary">Primary Button</button>`}
                </code>
              </pre><br />

              <h5>4. Utilities</h5>
              <p>
                Bootstrap includes a set of utility classes for spacing, alignment, colors, borders, text formatting, visibility control, and more. These classes make it easy to apply styles directly in HTML without writing additional CSS.
              </p>
              <p>Example of utility classes for spacing:</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="mt-3 mb-3">This div has margin-top and margin-bottom of 3 units</div>`}
                </code>
              </pre><br />

              <h5>5. JavaScript Plugins</h5>
              <p>
                Bootstrap also provides several JavaScript plugins that enhance the functionality of your website. These include:
                <ul>
                  <li><strong>Carousel</strong>: For creating image sliders.</li><br />
                  <li><strong>Tooltip</strong>: For showing small popups when hovering over elements.</li><br />
                  <li><strong>Modal</strong>: For creating dialog boxes.</li><br />
                  <li><strong>Collapse</strong>: For creating collapsible elements.</li>
                </ul>
              </p>
              <p>You can use these plugins by including Bootstrap’s JavaScript library.</p>
              <p>Example of a simple modal:</p>
              <pre className={style.codeoverflow}>
                <code>
                  {`<!-- Trigger Button -->
<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">Open Modal</button>

<!-- Modal -->
<div class="modal" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Modal Title</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        Content goes here...
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div>
    </div>
  </div>
</div>`}
                </code>
              </pre><br />

              <h5>6. Customization</h5>
              <p>
                Bootstrap is highly customizable. You can modify its default themes, colors, and components using the built-in customization options or by creating your own custom styles. The framework comes with a custom build tool that lets you include only the parts of Bootstrap you need, reducing the size of your CSS and JavaScript files.
              </p><br />

              <h5 style={{ paddingBottom: "6px" }}>7. Versions of Bootstrap</h5>
              <ul>
                <li><strong>Bootstrap 3</strong>: Introduced the 12-column grid system and mobile-first approach.</li><br />
                <li><strong>Bootstrap 4</strong>: Added improved flexbox grid, custom form controls, and utilities.</li><br />
                <li><strong>Bootstrap 5</strong>: Removed jQuery dependency, introduced new utilities, and enhanced grid options.</li>
              </ul><br />

              <h5>8. Installation</h5>
              <p>
                You can include Bootstrap in your project in two primary ways:
                <ul>
                  <li><strong>Via CDN</strong>: You can link to the Bootstrap CDN to include Bootstrap's CSS and JavaScript.</li><br />
                  <li><strong>Via NPM</strong>: You can also install Bootstrap using npm or yarn if you're working with a build system.</li>
                </ul>
              </p>
 <pre className={style.codeoverflow}>
  <code>
    {`<!-- Bootstrap CSS -->
<link href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css" rel="stylesheet">

<!-- Bootstrap JS and Popper.js -->
<script src="https://code.jquery.com/jquery-3.5.1.slim.min.js"></script>
<script src="https://cdn.jsdelivr.net/npm/@popperjs/core@2.5.2/dist/umd/popper.min.js"></script>
<script src="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/js/bootstrap.min.js"></script>`}
  </code>
</pre>

                 <pre className={style.codeoverflow}>
                <code>
                  {`npm install bootstrap`}
                </code>
              </pre><br />

              <h5 style={{ paddingBottom: "6px" }}>9. Why Use Bootstrap?</h5>
              <ul>
                <li><strong>Speed</strong>: It speeds up the development process because you don’t have to create layouts and components from scratch.</li><br />
                <li><strong>Consistency</strong>: It ensures consistent design across your site with its pre-styled components.</li><br />
                <li><strong>Responsiveness</strong>: It automatically adapts to different screen sizes, reducing the need for custom CSS.</li><br />
                <li><strong>Community Support</strong>: Being one of the most popular frameworks, Bootstrap has extensive community support and documentation.</li>
              </ul><br />

              <h4>Conclusion</h4>
              <p>
                Bootstrap is a powerful framework for building modern, responsive websites and web applications quickly. Whether you’re a beginner or an experienced developer, it simplifies many aspects of front-end development, making it an excellent choice for both personal and professional projects.
              </p>
            </div>
          )}


          {selectedChapter === 'chapter2' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>History and Evolution of Bootstrap</h1>

              <p>
                Bootstrap has evolved over the years to become one of the most popular front-end frameworks for web development. It was designed to make it easier for developers to build responsive and consistent websites. Here's a look at the key stages in the history of Bootstrap:
              </p>

              <br />

              <h3>1. Origins (2010)</h3>
              <p>
                Bootstrap was created by <strong>Mark Otto</strong> and <strong>Jacob Thornton</strong> at <strong>Twitter</strong> in <strong>2010</strong>. The framework was initially developed to solve the problem of inconsistent design elements across Twitter’s internal tools and to standardize the look and feel of these tools.
              </p>
              <p>
                The goal was to create a flexible, cohesive design system that could be used internally across various applications. It started as an internal toolkit called <strong>Twitter Blueprint</strong>, but after recognizing its potential value to the broader web development community, they decided to release it as an open-source project.
              </p>

              <br />

              <h3>2. Bootstrap 1.0 (2011) — Open Source Release</h3>
              <p>
                In <strong>2011</strong>, the framework was officially released as <strong>Bootstrap 1.0</strong> on GitHub. This marked the beginning of its journey as an open-source project, allowing developers from all over the world to use, modify, and contribute to it.
              </p>
              <p>
                <strong>Key Features of Bootstrap 1.0:</strong>
                <ul>
                  <li><strong>Grid System:</strong> A 12-column grid layout was introduced, which allowed developers to create responsive, fluid layouts.</li><br />
                  <li><strong>Basic UI Components:</strong> Elements like buttons, forms, navigation bars, and alerts were included.</li><br />
                  <li><strong>JavaScript Plugins:</strong> A set of basic interactive components (modals, tooltips, etc.) were included to enhance the user experience.</li>
                </ul>
              </p>

              <br />

              <h3>3. Bootstrap 2.0 (2012) — Mobile-First Design</h3>
              <p>
                In <strong>2012</strong>, <strong>Bootstrap 2.0</strong> was released, introducing a significant shift in web design: <strong>mobile-first</strong> design.
              </p>
              <p>
                <strong style={{ paddingBottom: "6px" }}>Key Features of Bootstrap 2.0:</strong>
                <ul>
                  <li><strong>Mobile-first approach:</strong> The framework was redesigned to prioritize mobile devices, making it easier to create responsive websites.</li><br />
                  <li><strong>Refined Grid System:</strong> The grid system was enhanced to be more flexible and adaptive.</li><br />
                  <li><strong>Improved UI Components:</strong> New UI elements such as breadcrumbs, pagination, and responsive navigation were introduced.</li><br />
                  <li><strong>Support for multiple screen sizes:</strong> Media queries were included to design for various screen sizes, from mobile phones to desktops.</li>
                </ul>
              </p>

              <br />

              <h3>4. Bootstrap 3.0 (2013) — Flat Design and Mobile-First</h3>
              <p>
                In <strong>2013</strong>, Bootstrap underwent a major redesign with the release of <strong>Bootstrap 3.0</strong>. This version embraced the <strong>flat design trend</strong> and further refined the mobile-first approach.
              </p>
              <p>
                <strong style={{ paddingBottom: "6px" }}>Key Features of Bootstrap 3.0:</strong>
                <ul>
                  <li><strong>Flat design:</strong> The design aesthetic shifted to a flat, minimalistic style, removing shadows and other 3D elements.</li><br />
                  <li><strong>Mobile-first:</strong> The framework focused heavily on mobile-first principles.</li><br />
                  <li><strong>Flexible Grid System:</strong> The grid system was enhanced with new classes for more customizable layouts.</li><br />
                  <li><strong>JavaScript Components:</strong> New features like modals, scrollspy, and affix were added for dynamic interactions.</li><br />
                  <li><strong>Customization:</strong> Bootstrap 3 introduced a more customizable structure through variables.</li>
                </ul>
              </p>

              <br />

              <h3>5. Bootstrap 4.0 (2018) — Flexbox and Sass Support</h3>
              <p>
                In <strong>2018</strong>, <strong>Bootstrap 4.0</strong> was released, marking another significant evolution.
              </p>
              <p>
                <strong style={{ paddingBottom: "6px" }}>Key Features of Bootstrap 4.0:</strong>
                <ul>
                  <li><strong>Flexbox Grid System:</strong> Bootstrap 4 replaced the old grid system with Flexbox for more flexibility.</li><br />
                  <li><strong>Sass Support:</strong> The framework switched from LESS to Sass for improved CSS customizations.</li><br />
                  <li><strong>Improved Components:</strong> New components like cards were introduced, replacing older ones.</li><br />
                  <li><strong>Drop of IE8 support:</strong> Internet Explorer 8 was no longer supported, enabling modern web standards.</li>
                </ul>
              </p>

              <br />

              <h3>6. Bootstrap 5.0 (2021) — jQuery Removal and Enhanced Customization</h3>
              <p>
                In <strong>2021</strong>, <strong>Bootstrap 5.0</strong> was released, introducing significant updates.
              </p>
              <p>
                <strong style={{ paddingBottom: "6px" }}>Key Features of Bootstrap 5.0:</strong>
                <ul>
                  <li><strong>No jQuery dependency:</strong> The framework was rewritten to use vanilla JavaScript.</li><br />
                  <li><strong>New Components:</strong> Bootstrap 5 introduced components like the accordion and offcanvas.</li><br />
                  <li><strong>Improved Forms:</strong> Floating labels and better layout for forms were introduced.</li><br />
                  <li><strong>CSS Variables:</strong> More CSS custom properties for easier customization.</li><br />
                  <li><strong>No more support for IE:</strong> Bootstrap 5 dropped support for Internet Explorer.</li>
                </ul>
              </p>

              <br />

              <h2 style={{ paddingBottom: "6px" }}>Summary of Key Milestones in Bootstrap's Evolution</h2>
              <ul>
                <li><strong>2011:</strong> Bootstrap 1.0 released, initially as an internal Twitter tool.</li><br />
                <li><strong>2012:</strong> Bootstrap 2.0 introduces mobile-first design.</li><br />
                <li><strong>2013:</strong> Bootstrap 3.0 redefines design with flat aesthetics.</li><br />
                <li><strong>2018:</strong> Bootstrap 4.0 introduces Flexbox and Sass.</li><br />
                <li><strong>2021:</strong> Bootstrap 5.0 removes jQuery, enhances customization with CSS variables.</li>
              </ul><br />

              <h2>Conclusion</h2>
              <p>
                Bootstrap has evolved from a simple internal tool at Twitter to one of the most popular frameworks worldwide. Its continuous evolution ensures that it stays relevant and useful in the fast-changing world of web development, making it easier for developers to create responsive, mobile-first websites.
              </p>

            </div>
          )}


          {selectedChapter === 'chapter3' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Features of Bootstrap</h1>


              <h3>1. Responsive Grid System</h3>
              <p>
                Bootstrap's grid system is built with a flexible 12-column layout that adapts to various screen sizes. It uses media queries to ensure that content looks good on all devices, from phones to large desktops. You can define your layout by using grid classes like <code>col-xs-</code>, <code>col-sm-</code>, <code>col-md-</code>, and <code>col-lg-</code>.
              </p><br />

              <h3>2. Mobile-First Design</h3>
              <p>
                Bootstrap is designed with mobile-first in mind. It ensures that websites are optimized for smaller screens by default and progressively enhances the layout for larger screens. This approach is implemented through the grid system and media queries.
              </p><br />

              <h3>3. Predefined CSS Classes</h3>
              <p>
                Bootstrap offers a wide variety of ready-to-use CSS classes for styling common HTML elements like buttons, forms, typography, tables, alerts, modals, and more. These predefined classes help save time and avoid writing custom CSS.
              </p><br />

              <h3 style={{ paddingBottom: "6px" }}>4. Customizable Components</h3>
              <ul>
                <li><strong>Navbars</strong> for navigation</li><br />
                <li><strong>Buttons</strong> with different styles and sizes</li><br />
                <li><strong>Forms</strong> with custom input styles</li><br />
                <li><strong>Cards</strong> for grouping content</li><br />
                <li><strong>Modals</strong> for dialogs or pop-ups</li><br />
                <li><strong>Tooltips</strong> and <strong>Popovers</strong> for additional information or interactions</li>
              </ul>
              <p>
                These components are designed to be responsive and customizable via CSS or Sass variables.
              </p><br />

              <h3>5. JavaScript Plugins</h3>
              <p>
                Bootstrap comes with several JavaScript plugins that enhance the user experience. These include:
              </p>
              <ul>
                <li><strong>Modals</strong> for pop-up dialogs</li><br />
                <li><strong>Carousels</strong> for image sliders</li><br />
                <li><strong>Tooltips</strong> and <strong>Popovers</strong> for displaying additional information</li><br />
                <li><strong>Dropdowns</strong> for creating interactive menu items</li><br />
                <li><strong>Alerts</strong> for displaying notifications</li><br />
                <li><strong>Collapse</strong> for accordions and collapsing content</li>
              </ul>
              <p>
                These plugins use jQuery (in versions prior to Bootstrap 5) and are easy to integrate with any project.
              </p><br />

              <h3>6. Flexbox Grid System</h3>
              <p>
                Starting from Bootstrap 4, the grid system was enhanced with <strong>Flexbox</strong>, allowing for more flexible and powerful layouts. Flexbox enables better alignment, spacing, and distribution of items in the grid without relying on float-based layouts.
              </p><br />

              <h3>7. Sass Variables & Customization</h3>
              <p>
                Bootstrap 4 and later versions switched from LESS to <strong>Sass</strong> for better flexibility and customization. You can override Bootstrap's default styles by customizing Sass variables, making it easier to tweak colors, typography, spacing, and more.
              </p><br />

              <h3>8. Utility Classes</h3>
              <p>
                Bootstrap provides a set of utility classes that help quickly manage layout, spacing, text, and other styling needs. These classes can be used directly in HTML, like:
              </p>
              <ul>
                <li><code>text-center</code> for centering text</li><br />
                <li><code>mt-3</code> for margin-top spacing</li><br />
                <li><code>d-flex</code> for making elements display as flex containers</li><br />
                <li><code>bg-primary</code> for background colors</li>
              </ul><br />

              <h3>9. Supports Customizable Themes</h3>
              <p>
                Bootstrap allows you to create custom themes or use third-party themes by customizing its Sass variables or using the Bootstrap Themes platform. This enables you to match the framework to your website's branding.
              </p><br />

              <h3>10. Cross-Browser Compatibility</h3>
              <p>
                Bootstrap is designed to work consistently across all modern browsers, including Chrome, Firefox, Safari, and Edge, and it provides a fallback for older versions of Internet Explorer (in Bootstrap 4 and earlier).
              </p><br />

              <h3>11. Icons and Glyphicons</h3>
              <p>
                In earlier versions of Bootstrap, <strong>Glyphicons</strong> were included as a set of vector icons. However, starting with Bootstrap 4, the framework no longer includes these icons. Instead, developers can use external libraries like <strong>FontAwesome</strong> or <strong>Bootstrap Icons</strong> for icons.
              </p><br />

              <h3>12. Accessibility Features</h3>
              <p>
                Bootstrap is built with accessibility in mind. It includes features like proper semantic HTML markup, ARIA roles, and keyboard navigation support for components like modals, dropdowns, and carousels.
              </p><br />

              <h3>13. Built-In Forms and Buttons</h3>
              <p>
                Bootstrap offers a clean, consistent way of creating forms and buttons. Features like input groups, custom checkboxes, radio buttons, and more are available with minimal configuration.
              </p><br />

              <h3>14. Predefined Themes and Styles</h3>
              <p>
                Bootstrap provides predefined themes and styles for different components, allowing you to quickly prototype a web page with a uniform design without needing to write custom CSS.
              </p><br />

              <h3>15. Container Classes</h3>
              <p>
                Bootstrap offers several <strong>container classes</strong> for creating a responsive fixed-width or fluid-width layout:
              </p>
              <ul>
                <li><code>.container</code> (fixed-width container)</li><br />
                <li><code>.container-fluid</code> (full-width container)</li><br />
                <li><code>.container-sm</code>, <code>.container-md</code>, <code>.container-lg</code>, <code>.container-xl</code> for responsive width.</li>
              </ul><br />

              <h3>16. CDN Support</h3>
              <p>
                Bootstrap can be easily included in any project by linking to its <strong>CDN</strong> (Content Delivery Network) for faster loading times and easy integration without downloading the framework.
              </p>

              <br />

              <p>
                These features make <strong>Bootstrap</strong> one of the most popular and versatile frameworks for building responsive, user-friendly web pages and applications. Whether you're a beginner or an advanced developer, it provides an extensive toolkit for creating modern websites with ease.
              </p>
            </div>
          )}


          {selectedChapter === 'chapter4' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Grid Basics</h1>
              <p>
                Bootstrap’s grid system is a powerful tool for creating responsive, flexible layouts. It is built on a
                12-column layout system and uses a combination of rows and columns to structure content. The grid is responsive,
                meaning it automatically adjusts to different screen sizes, ensuring that your layout looks great on all devices.
              </p><br />

              <h2 style={{ paddingBottom: "6px" }}>Key Concepts of Bootstrap Grid System</h2>

              <h3>1. Containers</h3>
              <p>
                Containers are the outermost element used to center content and provide padding. Bootstrap offers two types of
                containers:
              </p>
              <ul>
                <li>
                  <strong>.container</strong>: A fixed-width container that adapts to different screen sizes but has maximum
                  widths at each breakpoint.
                </li><br />
                <li>
                  <strong>.container-fluid</strong>: A full-width container that spans the entire width of the viewport,
                  regardless of screen size.
                </li>
              </ul>

                 <pre className={style.codeoverflow}>{`
    <div class="container">
      <!-- Content inside a fixed-width container -->
    </div>

    <div class="container-fluid">
      <!-- Content inside a full-width container -->
    </div>
    `}</pre><br />

              <h3>2. Rows</h3>
              <p>
                Rows are used to wrap columns and act as the parent container for columns. They ensure that columns are aligned
                properly and have adequate spacing (gutters).
              </p>

                 <pre className={style.codeoverflow}>{`
    <div class="container">
      <div class="row">
        <!-- Columns go here -->
      </div>
    </div>
    `}</pre><br />

              <h3>3. Columns</h3>
              <p>
                Columns define the width and position of your content within a row. The grid system is based on 12 columns, which
                means the total number of columns in a row should not exceed 12.
              </p>

              <p>
                Column classes follow the format <strong>col-[breakpoint]-[size]</strong>, where:
              </p>
              <ul>
                <li><strong>[breakpoint]</strong> is the screen size at which the column should apply:
                  <ul>
                    <li><strong>sm</strong> (small): ≥576px</li>
                    <li><strong>md</strong> (medium): ≥768px</li>
                    <li><strong>lg</strong> (large): ≥992px</li>
                    <li><strong>xl</strong> (extra large): ≥1200px</li>
                    <li><strong>xxl</strong> (extra-extra large): ≥1400px</li>
                  </ul>
                </li>
                <li><strong>[size]</strong> is the number of columns (1 to 12).</li>
              </ul>

                 <pre className={style.codeoverflow}>{`
    <div class="row">
      <div class="col-sm-6">Half width on small screens and up</div>
      <div class="col-sm-6">Half width on small screens and up</div>
    </div>
    `}</pre><br />

              <h3>4. Responsive Breakpoints</h3>
              <p>
                Bootstrap's grid allows you to create layouts that respond to different screen sizes. You can specify different
                column sizes for various breakpoints.
              </p>

              <pre className={style.codeoverflow}>{`
    <div class="row">
      <div class="col-12 col-md-8">Takes full width on small screens, 8 columns on medium and up</div>
      <div class="col-6 col-md-4">Takes 6 columns on small screens, 4 columns on medium and up</div>
    </div>
    `}</pre><br />

              <h3>5. Nesting Columns</h3>
              <p>
                You can nest columns within other columns to create more complex layouts. To do this, simply add a row within a
                column.
              </p>

              <pre className={style.codeoverflow}>{`
    <div class="row">
      <div class="col-md-6">
        <div class="row">
          <div class="col-6">Nested 1</div>
          <div class="col-6">Nested 2</div>
        </div>
      </div>
      <div class="col-md-6">Main column</div>
    </div>
    `}</pre><br />

              <h3>6. Auto Layout Columns</h3>
              <p>
                Bootstrap supports "auto-layout" columns where you don’t have to specify the column size, and the columns will
                share the available space equally.
              </p>

                 <pre className={style.codeoverflow}>{`
    <div class="row">
      <div class="col">Auto column 1</div>
      <div class="col">Auto column 2</div>
      <div class="col">Auto column 3</div>
    </div>
    `}</pre><br />

              <h3>7. Column Offsetting</h3>
              <p>
                You can shift columns to the right by using the <strong>.offset-[breakpoint]-[size]</strong> classes. This is
                useful when you want to add spacing before a column.
              </p>

                 <pre className={style.codeoverflow}>{`
    <div class="row">
      <div class="col-md-4 offset-md-4">Centered column</div>
    </div>
    `}</pre><br />

              <h3>8. Column Ordering</h3>
              <p>
                Bootstrap allows you to change the visual order of columns without affecting the HTML structure. You can use{' '}
                <strong>.order-[breakpoint]-[number]</strong> classes to rearrange columns.
              </p>

                 <pre className={style.codeoverflow}>{`
    <div class="row">
      <div class="col-md-4 order-md-2">Second in order</div>
      <div class="col-md-4 order-md-1">First in order</div>
      <div class="col-md-4 order-md-3">Third in order</div>
    </div>
    `}</pre><br />

              <h2>Practical Example of Grid System</h2>

              <pre className={style.codeoverflow}>{`
    <!DOCTYPE html>
    <html lang="en">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Bootstrap Grid Example</title>
      <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">
    </head>
    <body>
      <div class="container">
        <div class="row">
          <div class="col-md-4">Column 1 (4/12)</div>
          <div class="col-md-4">Column 2 (4/12)</div>
          <div class="col-md-4">Column 3 (4/12)</div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-6 col-md-8">Wide Column</div>
          <div class="col-6 col-md-4">Narrow Column</div>
        </div>
        <div class="row">
          <div class="col-6 offset-3">Centered Column</div>
        </div>
      </div>
    </body>
    </html>
    `}</pre><br />

              <h2>Conclusion</h2>
              <p>
                Bootstrap’s grid system is a flexible and responsive tool that simplifies the process of designing complex layouts.
                By using containers, rows, columns, and utility classes like offsets and ordering, you can create virtually any
                layout you need while ensuring responsiveness across different devices and screen sizes.
              </p>
            </div>
          )}

          {selectedChapter === 'chapter5' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}> Typography</h1>
              <p>
                In Bootstrap, typography is a crucial aspect of web design, allowing developers to easily style text and manage font sizes, weights, and alignments. Bootstrap provides a wide range of utility classes and pre-defined styles that make it easier to handle typographical elements without writing custom CSS. Here's an overview of typography in Bootstrap:
              </p><br />

              <h2>1. Headings</h2>
              <p>
                Bootstrap provides default heading classes for all six HTML heading levels, from <code>{'<h1>'}</code> to <code>{'<h6>'}</code>. You can use the <code>.h1</code>, <code>.h2</code>, <code>.h3</code>, etc., classes to apply heading styles to non-heading elements like <code>{'<p>'}</code> or <code>{'<div>'}</code>.
              </p>
              <pre className={style.codeoverflow}><code>
                {`<h1> Bootstrap heading</h1>
<h2>Bootstrap heading</h2>
<h3>Bootstrap heading</h3>
<h4>Bootstrap heading</h4>
<h5>Bootstrap heading</h5>
<h6>Bootstrap heading</h6>
<p class="h1">This is a paragraph styled as h1</p>`}
              </code></pre><br />

              <h2>2. Display Headings</h2>
              <p>Display headings are larger, more prominent headings useful for hero sections or large headers. Use classes from <code>.display-1</code> to <code>.display-6</code>.</p>
              <pre className={style.codeoverflow}><code>
                {`<h1 class="display-1">Display 1</h1>
<h1 class="display-2">Display 2</h1>
<h1 class="display-3">Display 3</h1>
<h1 class="display-4">Display 4</h1>
<h1 class="display-5">Display 5</h1>
<h1 class="display-6">Display 6</h1>`}
              </code></pre><br />

              <h2>3. Text Utilities</h2>
              <p>
                Bootstrap provides various utility classes to style and format text efficiently, such as font weight, italics, and monospace.
              </p>
              <pre className={style.codeoverflow}><code>
                {`<p class="fw-bold">Bold text</p>
<p class="fw-normal">Normal weight text</p>
<p class="fw-light">Light weight text</p>
<p class="fst-italic">Italic text</p>
<p class="font-monospace">Monospace text</p>`}
              </code></pre><br />

              <h2>4. Text Alignment</h2>
              <p>Use alignment classes like <code>.text-start</code>, <code>.text-center</code>, and <code>.text-end</code>, with responsive variants such as <code>.text-md-center</code>.</p>
              <pre className={style.codeoverflow}><code>
                {`<p class="text-start">Left aligned text</p>
<p class="text-center">Center aligned text</p>
<p class="text-end">Right aligned text</p>
<p class="text-md-center">Center aligned text on medium screens and larger</p>`}
              </code></pre><br />

              <h2>5. Text Color and Background</h2>
              <p>Bootstrap offers utility classes for text and background color.</p>
              <pre className={style.codeoverflow}><code>
                {`<p class="text-primary">Primary text</p>
<p class="text-success">Success text</p>
<p class="text-danger">Danger text</p>
<p class="bg-primary text-white">Primary background with white text</p>`}
              </code></pre><br />

              <h2>6. Lead Paragraph</h2>
              <p>Make paragraphs stand out by using the <code>.lead</code> class for larger text and adjusted line height.</p>
                 <pre className={style.codeoverflow}><code>{`<p class="lead">This is a lead paragraph. It stands out from regular text.</p>`}</code></pre><br />

              <h2>7. Inline Text Elements</h2>
              <p>Bootstrap supports a variety of inline HTML elements for styling abbreviations, blockquotes, and inline code.</p>
              <pre className={style.codeoverflow}><code>
                {`<p>An abbreviation of HTML is <abbr title="HyperText Markup Language">HTML</abbr>.</p>
<blockquote class="blockquote">
  <p>This is a blockquote example.</p>
  <footer class="blockquote-footer">Source Title</footer>
</blockquote>
<code>This is inline code</code>`}
              </code></pre><br />

              <h2>8. Lists</h2>
              <p>Bootstrap provides default styling for unordered, ordered, and inline lists using classes like <code>.list-inline</code>.</p>
                 <pre className={style.codeoverflow}><code>
                {`<ul>
  <li>Unordered list item 1</li>
  <li>Unordered list item 2</li>
</ul>
<ol>
  <li>Ordered list item 1</li>
  <li>Ordered list item 2</li>
</ol>`}
              </code></pre><br />

              <h2>9. Responsive Font Sizes</h2>
              <p>Font sizes adjust based on the viewport using <code>.fs-1</code>, <code>.fs-2</code>, etc., classes.</p>
                 <pre className={style.codeoverflow}><code>
                {`<p class="fs-1">Font size 1</p>
<p class="fs-2">Font size 2</p>
<p class="fs-3">Font size 3</p>`}
              </code></pre><br />

              <h2>10. Text Transformation</h2>
              <p>Transform text using <code>.text-lowercase</code>, <code>.text-uppercase</code>, and <code>.text-capitalize</code>.</p>
              <pre className={style.codeoverflow}><code>{`<p class="text-lowercase">Lowercase text</p>
<p class="text-uppercase">Uppercase text</p>
<p class="text-capitalize">Capitalized text</p>`}</code></pre><br />

              <h2>11. Blockquotes</h2>
              <p>Create blockquotes using the <code>.blockquote</code> class and <code>.blockquote-footer</code> for citation attribution.</p>
              <pre className={style.codeoverflow}><code>
                {`<blockquote class="blockquote">
  <p>This is a blockquote.</p>
  <footer class="blockquote-footer">Someone famous in <cite title="Source Title">Source Title</cite></footer>
</blockquote>`}
              </code></pre><br />

              <h2>12. Lists without Bullets</h2>
              <p>Create lists without bullets using the <code>.list-unstyled</code> class.</p>
                 <pre className={style.codeoverflow}><code>{`<ul class="list-unstyled">
  <li>Item without bullet</li>
  <li>Another item</li>
</ul>`}</code></pre><br />

              <h2>Conclusion</h2>
              <p>
                Typography in Bootstrap simplifies the process of designing consistent, responsive text layouts. By utilizing the heading, text utility, and list classes, your typography will remain easy to style and accessible across different devices.
              </p>
            </div>
          )}



          {selectedChapter === 'chapter6' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Tables</h1>
              <p>
                Bootstrap provides a simple and flexible way to style tables. Using built-in classes, you can enhance tables with consistent formatting, responsive designs, and various interactive features. Here's an overview of how to work with tables in Bootstrap.
              </p><br />

              <h2>1. <strong>Basic Table</strong></h2>
              <p style={{ paddingBottom: "6px" }}>To style a basic table, you can apply the <code>.table</code> class to the <code>&lt;table&gt;</code> element. This adds some basic padding and borders.</p>

              <h3>Example:</h3>
                 <pre className={style.codeoverflow}>
                <code>{`
        <table className="table">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">First Name</th>
              <th scope="col">Last Name</th>
              <th scope="col">Username</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">1</th>
              <td>Mark</td>
              <td>Otto</td>
              <td>@mdo</td>
            </tr>
            <tr>
              <th scope="row">2</th>
              <td>Jacob</td>
              <td>Thornton</td>
              <td>@fat</td>
            </tr>
            <tr>
              <th scope="row">3</th>
              <td>Larry</td>
              <td>Bird</td>
              <td>@twitter</td>
            </tr>
          </tbody>
        </table>
      `}</code>
              </pre><br />

              <h2>2. <strong>Striped Rows</strong></h2>
              <p style={{ paddingBottom: "6px" }}>To make rows alternate in background color, use the <code>.table-striped</code> class. This improves readability, especially in tables with many rows.</p>

              <h3>Example:</h3>
                 <pre className={style.codeoverflow}>
                <code>{`
        <table className="table table-striped">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">First Name</th>
              <th scope="col">Last Name</th>
              <th scope="col">Username</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">1</th>
              <td>Mark</td>
              <td>Otto</td>
              <td>@mdo</td>
            </tr>
            <tr>
              <th scope="row">2</th>
              <td>Jacob</td>
              <td>Thornton</td>
              <td>@fat</td>
            </tr>
            <tr>
              <th scope="row">3</th>
              <td>Larry</td>
              <td>Bird</td>
              <td>@twitter</td>
            </tr>
          </tbody>
        </table>
      `}</code>
              </pre><br />

              <h2>3. <strong>Bordered Table</strong></h2>
              <p style={{ paddingBottom: "6px" }}>Add the <code>.table-bordered</code> class to include borders on all sides of the table and cells.</p>

              <h3>Example:</h3>
                 <pre className={style.codeoverflow}>
                <code>{`
        <table className="table table-bordered">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">First Name</th>
              <th scope="col">Last Name</th>
              <th scope="col">Username</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">1</th>
              <td>Mark</td>
              <td>Otto</td>
              <td>@mdo</td>
            </tr>
            <tr>
              <th scope="row">2</th>
              <td>Jacob</td>
              <td>Thornton</td>
              <td>@fat</td>
            </tr>
            <tr>
              <th scope="row">3</th>
              <td>Larry</td>
              <td>Bird</td>
              <td>@twitter</td>
            </tr>
          </tbody>
        </table>
      `}</code>
              </pre><br />

              <h2>4. <strong>Hover Rows</strong></h2>
              <p style={{ paddingBottom: "6px" }}>Use the <code>.table-hover</code> class to highlight rows when hovered over.</p>

              <h3>Example:</h3>
                 <pre className={style.codeoverflow}>
                <code>{`
        <table className="table table-hover">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">First Name</th>
              <th scope="col">Last Name</th>
              <th scope="col">Username</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">1</th>
              <td>Mark</td>
              <td>Otto</td>
              <td>@mdo</td>
            </tr>
            <tr>
              <th scope="row">2</th>
              <td>Jacob</td>
              <td>Thornton</td>
              <td>@fat</td>
            </tr>
            <tr>
              <th scope="row">3</th>
              <td>Larry</td>
              <td>Bird</td>
              <td>@twitter</td>
            </tr>
          </tbody>
        </table>
      `}</code>
              </pre>


            </div>
          )}


          {selectedChapter === 'chapter7' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Images</h1>

              <p>
                To work with images in Bootstrap, there are several classes and techniques available to help you control the layout, size, and responsiveness of images within your web pages. Here’s how you can handle images in a Bootstrap-based React component:
              </p><br />

              <h2>1. Basic Image</h2>
              <p>
                To display a basic image in Bootstrap, you can use the <code>&lt;img&gt;</code> tag. Bootstrap doesn’t apply any specific class by default, but you can add responsive and styling classes to control the appearance.
              </p>
              <pre className={style.codeoverflow}>
                <code>
                  {`<img src="path/to/your/image.jpg" alt="Example Image" />`}
                </code>
              </pre><br />

              <h2>2. Responsive Image</h2>
              <p>
                To make an image responsive, add the <code>.img-fluid</code> class. This ensures the image scales with the parent container and remains fully responsive on various screen sizes.
              </p>
              <pre className={style.codeoverflow}>
                <code>
                  {`<img src="path/to/your/image.jpg" alt="Responsive Image" className="img-fluid" />`}
                </code>
              </pre>
              <p><code>.img-fluid</code> ensures the image automatically adjusts its width to fit the screen width while maintaining its aspect ratio.</p><br />

              <h2>3. Image with Rounded Corners</h2>
              <p>
                To give an image rounded corners, use the <code>.rounded</code> class.
              </p>
              <pre className={style.codeoverflow}>
                <code>
                  {`<img src="path/to/your/image.jpg" alt="Image with Rounded Corners" className="img-fluid rounded" />`}
                </code>
              </pre>
              <ul>
                <li><code>.rounded</code>: Small border-radius for rounded corners.</li><br />
                <li><code>.rounded-circle</code>: Makes the image perfectly circular (useful for profile pictures).</li><br />
                <li><code>.rounded-pill</code>: More pronounced rounded effect.</li>
              </ul><br />

              <h2>4. Image Thumbnail</h2>
              <p>
                To create a thumbnail effect, use the <code>.img-thumbnail</code> class. This adds a border and padding around the image.
              </p>
              <pre className={style.codeoverflow}>
                <code>
                  {`<img src="path/to/your/image.jpg" alt="Thumbnail Image" className="img-thumbnail" />`}
                </code>
              </pre><br />

              <h2>5. Aligning Images</h2>
              <p style={{ paddingBottom: "6px" }}>
                To align images within a container, you can use utility classes such as <code>.mx-auto</code> for centering or <code>.float-start</code> and <code>.float-end</code> for floating the image to the left or right.
              </p>

              <h3>Example - Centering an Image:</h3>
              <pre className={style.codeoverflow}>
                <code>
                  {`<img src="path/to/your/image.jpg" alt="Centered Image" className="img-fluid mx-auto d-block" />`}
                </code>
              </pre>
              <ul>
                <li><code>.mx-auto</code>: Centers the image horizontally within its container.</li><br />
                <li><code>.d-block</code>: Makes the image behave as a block-level element (required for centering).</li>
              </ul><br />

              <h3>Example - Floating an Image:</h3>
              <pre className={style.codeoverflow}>
                <code>
                  {`<img src="path/to/your/image.jpg" alt="Float Left Image" className="img-fluid float-start" />
         <img src="path/to/your/image.jpg" alt="Float Right Image" className="img-fluid float-end" />`}
                </code>
              </pre>
              <ul>
                <li><code>.float-start</code>: Floats the image to the left.</li><br />
                <li><code>.float-end</code>: Floats the image to the right.</li>
              </ul><br />

              <h2>6. Image Overlays (Using a Card)</h2>
              <p>
                You can overlay text or other elements on top of an image by using Bootstrap's card component.
              </p>
              <pre className={style.codeoverflow}>
                <code>
                  {`<div className="card" style={{ width: "18rem" }}>
  <img src="path/to/your/image.jpg" className="card-img-top" alt="Card image" />
  <div className="card-body">
    <h5 className="card-title">Card title</h5>
    <p className="card-text">Some quick example text to build on the card title.</p>
  </div>
</div>`}
                </code>
              </pre><br />

              <h2>7. Responsive Images with Aspect Ratio</h2>
              <p>
                Bootstrap 5 provides a utility to maintain a specific aspect ratio for your images. This is done using the <code>.ratio</code> class, which is especially useful for embedding videos, images, or iframe content.
              </p>
              <pre className={style.codeoverflow}>
                <code>
                  {`<div className="ratio ratio-16x9">
  <img src="path/to/your/image.jpg" alt="Aspect Ratio Image" className="img-fluid" />
</div>`}
                </code>
              </pre>
              <p>
                The <code>.ratio-16x9</code> ensures the image maintains a 16:9 aspect ratio. Other ratios available: <code>.ratio-4x3</code>, <code>.ratio-1x1</code>, etc.
              </p><br />

              <h2>Example React Component with Images</h2>
              <p>
                Here’s an example of how to use these Bootstrap classes in a React component:
              </p>
              <pre className={style.codeoverflow}>
                <code>
                  {`import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import style from './yourStyles.module.css'; // Adjust path to your CSS

const ImageComponent = () => {
  return (
    <div className="container">
      <h1 className="my-4">Bootstrap Images</h1>

      <h2>Responsive Image</h2>
      <img src="path/to/your/image.jpg" alt="Responsive" className="img-fluid" />

      <h2>Image with Rounded Corners</h2>
      <img src="path/to/your/image.jpg" alt="Rounded" className="img-fluid rounded" />

      <h2>Thumbnail Image</h2>
      <img src="path/to/your/image.jpg" alt="Thumbnail" className="img-thumbnail" />

      <h2>Centered Image</h2>
      <img src="path/to/your/image.jpg" alt="Centered" className="img-fluid mx-auto d-block" />

      <h2>Floating Image</h2>
      <img src="path/to/your/image.jpg" alt="Float Left" className="img-fluid float-start" />
      <img src="path/to/your/image.jpg" alt="Float Right" className="img-fluid float-end" />

      <h2>Image in a Card</h2>
      <div className="card" style={{ width: "18rem" }}>
        <img src="path/to/your/image.jpg" className="card-img-top" alt="Card Image" />
        <div className="card-body">
          <h5 className="card-title">Card Title</h5>
          <p className="card-text">Some quick example text to build on the card title.</p>
        </div>
      </div>

      <h2>Image with Aspect Ratio</h2>
      <div className="ratio ratio-16x9">
        <img src="path/to/your/image.jpg" alt="Aspect Ratio Image" className="img-fluid" />
      </div>
    </div>
  )
}`}
                </code>
              </pre>
            </div>
          )}



          {selectedChapter === 'chapter8' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Jumbotron</h1>

              <p>
                A <strong>Jumbotron</strong> in Bootstrap is a component that is used to highlight or showcase large sections of content, such as a marketing message or important information. It's typically a large box or container with some padding and background styling that makes it stand out on a page. The Jumbotron is often used for headers or call-to-action content.
              </p><br />

              <h2>Basic Usage</h2>

              <p>
                In Bootstrap 4 and 5, the Jumbotron component is used as follows:
              </p>

              <pre className={style.codeoverflow}>
                <code>{`
<div class="jumbotron">
  <h1 class="display-4">Hello, world!</h1>
  <p class="lead">This is a simple jumbotron-style component for calling extra attention to featured content or information.</p>
  <hr class="my-4">
  <p>It uses utility classes for typography and spacing to space content out within the larger container.</p>
  <a class="btn btn-primary btn-lg" href="#" role="button">Learn more</a>
</div>
      `}</code>
              </pre><br />

              <h3 style={{ paddingBottom: "6px" }}>Key Elements:</h3>
              <ul>
                <li><strong>.jumbotron</strong>: This is the main class that applies the styles for the Jumbotron.</li><br />
                <li><strong>.display-4</strong>: A Bootstrap class for large headings. You can use other display classes like <code>.display-1</code>, <code>.display-2</code>, etc., for different sizes.</li><br />
                <li><strong>.lead</strong>: Used to make the paragraph text stand out as an introductory or lead-in statement.</li><br />
                <li><strong>.btn</strong> and <strong>.btn-primary</strong>: These are button classes to style buttons within the Jumbotron.</li>
              </ul><br />

              <h3>Customizing the Jumbotron</h3>
              <p>
                You can modify the Jumbotron's size, background, and content as needed. For example, to change its background color, you can use utility classes:
              </p>

              <pre className={style.codeoverflow}>
                <code>{`
<div class="jumbotron bg-primary text-white">
  <h1 class="display-4">Welcome!</h1>
  <p class="lead">This is a custom Jumbotron with a primary background and white text.</p>
</div>
      `}</code>
              </pre><br />

              <h3>Bootstrap 5 Update</h3>
              <p style={{ paddingBottom: "6px" }}>
                In Bootstrap 5, the Jumbotron component has been removed. However, you can easily replicate its behavior using custom styles or utility classes, such as <code>bg-light</code>, <code>p-5</code>, and <code>rounded</code>.
              </p>

              <h4>Example in Bootstrap 5:</h4>
                 <pre className={style.codeoverflow}>
                <code>{`
<div class="bg-light p-5 rounded-3">
  <h1 class="display-4">Hello, world!</h1>
  <p class="lead">This is a simple container styled to resemble a Jumbotron.</p>
  <a class="btn btn-primary btn-lg" href="#" role="button">Learn more</a>
</div>
      `}</code>
              </pre>


            </div>
          )}


          {selectedChapter === 'chapter9' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>wells</h1>

              <p>
                In Bootstrap, the <strong>well</strong> component was used in earlier versions (Bootstrap 3) to create a styled container with a soft, inset border around content. However, with Bootstrap 4 and later versions (including Bootstrap 5), the <code>.well</code> class has been deprecated and is no longer available. Instead, you can replicate the "well" effect using utility classes such as padding, background colors, and borders.
              </p><br />

              <p style={{ paddingBottom: "6px" }}>
                Here's how you can create a "well" style container in Bootstrap 4 and 5 using utilities:
              </p>

              <h3>1. <strong>Basic Well Effect (Bootstrap 4/5)</strong></h3>
              <p>
                Instead of using <code>.well</code>, you can create a similar effect using <code>.bg-light</code>, <code>.border</code>, and padding utilities. Here’s an example:
              </p>

                 <pre className={style.codeoverflow}>
                <code className="language-html">
                  {`<div class="bg-light border p-3 rounded">
  <h3>This is a well-like container</h3>
  <p>This content is inside a container styled like a well, but using Bootstrap 4/5 utilities.</p>
</div>`}
                </code>
              </pre><br />

              <h4>Explanation:</h4>
              <ul>
                <li><code>bg-light</code>: Applies a light background color, similar to the default background of the <code>.well</code> in Bootstrap 3.</li><br />
                <li><code>border</code>: Adds a border around the container.</li><br />
                <li><code>p-3</code>: Adds padding to the container, giving space around the content.</li><br />
                <li><code>rounded</code>: Gives the container rounded corners, similar to the default style of <code>.well</code> in Bootstrap 3.</li>
              </ul><br />

              <h3>2. Well-like Effect with Custom Styling</h3>
              <p>
                If you want to replicate the exact look of the <code>.well</code> component from Bootstrap 3, you can customize the background, padding, and border radius:
              </p>

                 <pre className={style.codeoverflow}>
                <code className="language-html">
                  {`<div class="bg-light border p-4" style="border-radius: .375rem;">
  <h3>This is a well-like container</h3>
  <p>This content is inside a well-styled container with custom styles.</p>
</div>`}
                </code>
              </pre>

              <h3>3. Well with Shadow (Additional Styling)</h3>
              <p>
                To give the container a more noticeable "well" effect with a shadow (similar to a raised box), you can add the <code>box-shadow</code> utility:
              </p>

                 <pre className={style.codeoverflow}>
                <code className="language-html">
                  {`<div class="bg-light border p-3 rounded shadow-sm">
  <h3>This is a well-like container with a shadow</h3>
  <p>This content has a light shadow for added depth.</p>
</div>`}
                </code>
              </pre>

              <ul>
                <li><code>shadow-sm</code>: Adds a small shadow to the container to simulate a floating effect.</li>
              </ul><br />

              <h3>4. Full-width Well-like Effect</h3>
              <p>
                To make the container full-width (as in a container that spans the entire width of its parent element), you can use <code>.container-fluid</code>:
              </p>

                 <pre className={style.codeoverflow}>
                <code className="language-html">
                  {`<div class="bg-light border p-4 container-fluid">
  <h3>This is a full-width well-like container</h3>
  <p>This content takes up the entire width of the viewport.</p>
</div>`}
                </code>
              </pre>

              <p>
                This ensures that the container spans the full width of the screen or its parent container.
              </p><br />

              <h3>Conclusion</h3>
              <p>
                While Bootstrap 4 and 5 no longer include the <code>.well</code> class, you can easily recreate a well-like effect with a combination of utility classes like <code>bg-light</code>, <code>border</code>, <code>p-3</code> for padding, and <code>rounded</code> for the rounded corners. Adding optional styles like shadows can further enhance the well-like appearance.
              </p>
            </div>
          )}


          {selectedChapter === 'chapter10' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Alert</h1>
              <p>
                In Bootstrap, alerts are used to provide feedback to users in the form of messages that appear prominently on the screen. Bootstrap provides predefined classes for different types of alerts, which can be customized further. Here’s how you can use them:
              </p><br />


              <h2>1. Basic Alert</h2>
              <p>
                You can create a basic alert by using the <code>alert</code> class and a specific alert type, such as <code>alert-success</code>, <code>alert-danger</code>, <code>alert-warning</code>, or <code>alert-info</code>. Here's an example:
              </p>
                 <pre className={style.codeoverflow}><code className="html">
                {`<div class="alert alert-success" role="alert">
  This is a success alert—check it out!
</div>`}
              </code></pre>
              <ul>
                <li><strong>`alert-success`</strong>: Represents a success message (usually green).</li><br />
                <li><strong>`alert-danger`</strong>: Represents a danger message (usually red).</li><br />
                <li><strong>`alert-warning`</strong>: Represents a warning message (usually yellow).</li><br />
                <li><strong>`alert-info`</strong>: Represents an informational message (usually blue).</li>
              </ul><br />

              <h2>2. Dismissible Alerts</h2>
              <p>
                You can make alerts dismissible (closable) by adding the <code>alert-dismissible</code> class and including a close button (<code>button</code> with <code>data-dismiss="alert"</code>).
              </p>
                 <pre className={style.codeoverflow}><code className="html">
                {`<div class="alert alert-warning alert-dismissible fade show" role="alert">
  This is a warning alert—be careful!
  <button type="button" class="close" data-dismiss="alert" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>`}
              </code></pre>
              <ul>
                <li><strong>`alert-dismissible`</strong>: Makes the alert dismissible (closable).</li><br />
                <li><strong>`fade show`</strong>: Adds fade-in and fade-out effects when closing the alert.</li><br />
                <li><strong>`close`</strong>: Adds a close button.</li>
              </ul><br />

              <h2>3. Customizing Alert Colors</h2>
              <p>
                You can customize the color of the alert by using the appropriate contextual class. For example:
              </p>
                 <pre className={style.codeoverflow}><code className="html">
                {`<div class="alert alert-primary" role="alert">
  This is a primary alert—useful for important information.
</div>`}
              </code></pre>
              <p>Common contextual classes include:</p>
              <ul>
                <li><code>alert-primary</code> (blue)</li><br />
                <li><code>alert-secondary</code> (gray)</li><br />
                <li><code>alert-success</code> (green)</li><br />
                <li><code>alert-danger</code> (red)</li><br />
                <li><code>alert-warning</code> (yellow)</li><br />
                <li><code>alert-info</code> (blue)</li><br />
                <li><code>alert-light</code> (light gray)</li><br />
                <li><code>alert-dark</code> (dark gray)</li>
              </ul><br />

              <h2>4. Using Alerts in JavaScript</h2>
              <p>
                You can also dynamically add alerts using JavaScript. Here’s an example of adding an alert when an event occurs:
              </p>
                 <pre className={style.codeoverflow}><code className="javascript">
                {`// JavaScript to create an alert dynamically
const alertContainer = document.getElementById('alert-container');
const alertMessage = document.createElement('div');
alertMessage.classList.add('alert', 'alert-info', 'alert-dismissible', 'fade', 'show');
alertMessage.setAttribute('role', 'alert');
alertMessage.innerHTML = \`
  This is an info alert—using JavaScript to create it!
  <button type="button" class="close" data-dismiss="alert" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
\`;
alertContainer.appendChild(alertMessage);`}
              </code></pre>
              <p>In this example, you dynamically create an alert message in JavaScript and append it to the DOM.</p><br />

              <h2>5. Stacking Alerts</h2>
              <p>
                Multiple alerts can be stacked on top of each other by simply adding multiple alert elements in your HTML. Bootstrap will automatically space them apart:
              </p>
                 <pre className={style.codeoverflow}><code className="html">
                {`<div class="alert alert-success" role="alert">
  This is the first success alert.
</div>
<div class="alert alert-danger" role="alert">
  This is the second danger alert.
</div>`}
              </code></pre><br />

              <h2>6. Alert Links</h2>
              <p>
                You can add links within an alert using the <code>&lt;a&gt;</code> tag:
              </p>
                 <pre className={style.codeoverflow}><code className="html">
                {`<div class="alert alert-info" role="alert">
  This is an info alert with a <a href="#" class="alert-link">link</a>.
</div>`}
              </code></pre><br />

              <h2>Example in Action:</h2>
                 <pre className={style.codeoverflow}><code className="html">
                {`<div class="container mt-5">
  <div class="alert alert-success" role="alert">
    This is a success alert—everything went well!
  </div>
  <div class="alert alert-danger alert-dismissible fade show" role="alert">
    This is a danger alert—something went wrong!
    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="alert alert-warning" role="alert">
    This is a warning alert—pay attention!
  </div>
  <div class="alert alert-info" role="alert">
    This is an info alert—useful for general information.
  </div>
</div>`}
              </code></pre><br />

              <h2>Conclusion</h2>
              <p>
                Bootstrap alerts provide a simple way to display important messages with minimal code. You can customize the alert styles, make them dismissible, and even dynamically generate them with JavaScript. By using Bootstrap’s built-in utility classes, you can create a wide variety of alerts for different scenarios.
              </p>

            </div>
          )}

          {selectedChapter === 'chapter11' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Buttons</h1>

              <p>
                Bootstrap provides a set of predefined button classes that can be customized for various use cases. These buttons are easy to implement and come in various styles, sizes, and states, which makes it easy to enhance the user interface of your web application.
              </p><br />

              <h3>1. Basic Button</h3>
              <p>You can create a basic button by using the <code>btn</code> class and one of the button contextual classes. Here’s an example:</p>

                 <pre className={style.codeoverflow}><code>
                {`<button type="button" class="btn btn-primary">Primary Button</button>
<button type="button" class="btn btn-secondary">Secondary Button</button>
<button type="button" class="btn btn-success">Success Button</button>
<button type="button" class="btn btn-danger">Danger Button</button>
<button type="button" class="btn btn-warning">Warning Button</button>
<button type="button" class="btn btn-info">Info Button</button>
<button type="button" class="btn btn-light">Light Button</button>
<button type="button" class="btn btn-dark">Dark Button</button>
<button type="button" class="btn btn-link">Link Button</button>`}
              </code></pre>

              <p>Each button class represents a different contextual color:</p>
              <ul>
                <li><strong>btn-primary</strong>: Primary button (usually blue).</li><br />
                <li><strong>btn-secondary</strong>: Secondary button (gray).</li><br />
                <li><strong>btn-success</strong>: Success button (green).</li><br />
                <li><strong>btn-danger</strong>: Danger button (red).</li><br />
                <li><strong>btn-warning</strong>: Warning button (yellow).</li><br />
                <li><strong>btn-info</strong>: Info button (light blue).</li><br />
                <li><strong>btn-light</strong>: Light button (light gray).</li><br />
                <li><strong>btn-dark</strong>: Dark button (dark gray).</li><br />
                <li><strong>btn-link</strong>: Link-style button (styled as a link).</li>
              </ul><br />

              <h3>2. Button Sizes</h3>
              <p>Bootstrap allows you to adjust the size of your buttons. There are three predefined button sizes:</p>
              <ul>
                <li><strong>Small Button</strong>: Use the <code>btn-sm</code> class.</li><br />
                <li><strong>Default Size</strong>: This is the default size of buttons.</li><br />
                <li><strong>Large Button</strong>: Use the <code>btn-lg</code> class.</li>
              </ul>

                 <pre className={style.codeoverflow}><code>
                {`<button type="button" class="btn btn-primary btn-sm">Small Button</button>
<button type="button" class="btn btn-primary">Default Button</button>
<button type="button" class="btn btn-primary btn-lg">Large Button</button>`}
              </code></pre><br />

              <h3>3. Block-Level Buttons</h3>
              <p>You can make a button stretch across the entire width of its parent container by adding the <code>btn-block</code> class:</p>

                 <pre className={style.codeoverflow}><code>
                {`<button type="button" class="btn btn-primary btn-block">Block-Level Button</button>`}
              </code></pre><br />

              <h3>4. Active, Focus, and Disabled States</h3>
              <p>Bootstrap buttons support various states like <strong>active</strong>, <strong>focus</strong>, and <strong>disabled</strong>.</p>

                 <pre className={style.codeoverflow}><code>
                {`<button type="button" class="btn btn-primary active">Active Button</button>
<button type="button" class="btn btn-primary" disabled>Disabled Button</button>`}
              </code></pre><br />

              <h3>5. Outline Buttons</h3>
              <p>Bootstrap also provides outlined button styles, which give a more minimalist approach while retaining the same functionality. These are created by using the <code>{`btn-outline-{color}`}</code> class.</p>

                 <pre className={style.codeoverflow}><code>
                {`<button type="button" class="btn btn-outline-primary">Primary Outline Button</button>
<button type="button" class="btn btn-outline-secondary">Secondary Outline Button</button>`}
              </code></pre><br />

              <h3>6. Button Groups</h3>
              <p>You can group multiple buttons together in a single horizontal or vertical set using the <code>btn-group</code> class.</p>

                 <pre className={style.codeoverflow}><code>
                {`<div class="btn-group" role="group">
  <button type="button" class="btn btn-primary">Button 1</button>
  <button type="button" class="btn btn-primary">Button 2</button>
  <button type="button" class="btn btn-primary">Button 3</button>
</div>`}
              </code></pre>

              <p>For vertical button groups, add the <code>btn-group-vertical</code> class:</p>

                 <pre className={style.codeoverflow}><code>
                {`<div class="btn-group-vertical" role="group">
  <button type="button" class="btn btn-primary">Button 1</button>
  <button type="button" class="btn btn-primary">Button 2</button>
  <button type="button" class="btn btn-primary">Button 3</button>
</div>`}
              </code></pre><br />

              <h3>7. Dropdown Buttons</h3>
              <p>You can create dropdown menus with buttons by combining the <code>btn</code> class with the <code>dropdown-toggle</code> and <code>dropdown-menu</code> classes.</p>

                 <pre className={style.codeoverflow}><code>
                {`<div class="btn-group">
  <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
    Dropdown Button
  </button>
  <div class="dropdown-menu">
    <a class="dropdown-item" href="#">Action</a>
    <a class="dropdown-item" href="#">Another action</a>
    <a class="dropdown-item" href="#">Something else here</a>
  </div>
</div>`}
              </code></pre><br />

              <h3>8. Button with Icon</h3>
              <p>You can add icons inside buttons, typically by using Font Awesome or Bootstrap Icons. Here’s an example with a Font Awesome icon:</p>

                 <pre className={style.codeoverflow}><code>
                {`<button type="button" class="btn btn-primary">
  <i class="fa fa-check"></i> Submit
</button>`}
              </code></pre><br />

              <h3>Example in Action:</h3>
                 <pre className={style.codeoverflow}><code>
                {`<div class="container mt-5">
  <h1>Bootstrap Buttons</h1>
  <div>
    <button type="button" class="btn btn-primary">Primary Button</button>
    <button type="button" class="btn btn-success">Success Button</button>
    <button type="button" class="btn btn-danger">Danger Button</button>
  </div>
  <div class="mt-3">
    <button type="button" class="btn btn-outline-primary">Primary Outline Button</button>
    <button type="button" class="btn btn-outline-danger">Danger Outline Button</button>
  </div>
  <div class="mt-3">
    <div class="btn-group" role="group">
      <button type="button" class="btn btn-primary">Button 1</button>
      <button type="button" class="btn btn-primary">Button 2</button>
      <button type="button" class="btn btn-primary">Button 3</button>
    </div>
  </div>
</div>`}
              </code></pre><br />

              <h3>Conclusion</h3>
              <p>
                Bootstrap's button component is highly customizable and easy to use. With its various contextual classes, sizes, and styles, you can create buttons that suit any need. Whether you want a simple button, a group of buttons, or a button with an icon, Bootstrap’s button styles have you covered.
              </p>
            </div>
          )}


          {selectedChapter === 'chapter12' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Button Groups</h1>

              <p>
                In Bootstrap, <strong>Button Groups</strong> are used to group multiple buttons together in a horizontal or vertical alignment. This is helpful when you want to group actions or related buttons to provide a clean and organized user interface. Button groups are responsive and can be customized further using various Bootstrap classes.
              </p><br />

              <h2 style={{ paddingBottom: "6px" }}>Types of Button Groups:</h2>
              <ul>
                <li><strong>Horizontal Button Groups</strong></li><br />
                <li><strong>Vertical Button Groups</strong></li><br />
                <li><strong>Button Toolbar</strong></li><br />
                <li><strong>Nested Button Groups</strong></li>
              </ul><br />

              <h3>1. Horizontal Button Groups</h3>
              <p>
                Horizontal button groups are the default type of button group. All buttons inside a button group will be displayed in a single horizontal row.
              </p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="btn-group" role="group">
  <button type="button" class="btn btn-primary">Button 1</button>
  <button type="button" class="btn btn-primary">Button 2</button>
  <button type="button" class="btn btn-primary">Button 3</button>
</div>`}
                </code>
              </pre>
              <p>In this example, the three buttons will be aligned horizontally in a single row.</p><br />

              <h3>2. Vertical Button Groups</h3>
              <p>
                If you want to stack buttons vertically, you can use the <code>btn-group-vertical</code> class. This will display the buttons one below the other.
              </p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="btn-group-vertical" role="group">
  <button type="button" class="btn btn-primary">Button 1</button>
  <button type="button" class="btn btn-primary">Button 2</button>
  <button type="button" class="btn btn-primary">Button 3</button>
</div>`}
                </code>
              </pre>
              <p>Here, the buttons will be arranged vertically.</p><br />

              <h3>3. Button Toolbar</h3>
              <p>
                You can also create more complex groupings of buttons using the <code>btn-toolbar</code> class. This is useful if you have multiple groups of buttons that need to be displayed together.
              </p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="btn-toolbar" role="toolbar">
  <div class="btn-group mr-2" role="group">
    <button type="button" class="btn btn-primary">Button 1</button>
    <button type="button" class="btn btn-primary">Button 2</button>
  </div>
  <div class="btn-group" role="group">
    <button type="button" class="btn btn-success">Button 3</button>
    <button type="button" class="btn btn-success">Button 4</button>
  </div>
</div>`}
                </code>
              </pre>
              <p>
                In this example, two groups of buttons (Button 1 & 2 and Button 3 & 4) are placed together in a toolbar.
              </p><br />

              <h3>4. Nested Button Groups</h3>
              <p>
                You can also nest button groups inside other groups. This is useful when you need to create more complex UI components, like split buttons or dropdowns.
              </p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="btn-group" role="group">
  <button type="button" class="btn btn-primary">Button 1</button>
  <button type="button" class="btn btn-primary">Button 2</button>
  <div class="btn-group" role="group">
    <button type="button" class="btn btn-primary">Dropdown</button>
    <button type="button" class="btn btn-primary">Dropdown</button>
  </div>
</div>`}
                </code>
              </pre>
              <p>
                Here, the second button group (with two buttons) is nested inside the first button group.
              </p><br />

              <h3 style={{ paddingBottom: "6px" }}>Additional Customization:</h3>
              <ul>
                <li>
                  <strong>Sizing:</strong> You can adjust the size of button groups by using Bootstrap's sizing classes (<code>btn-sm</code>, <code>btn-lg</code>).
                     <pre className={style.codeoverflow}>
                    <code>
                      {`<div class="btn-group btn-group-lg" role="group">
  <button type="button" class="btn btn-primary">Large Button 1</button>
  <button type="button" class="btn btn-primary">Large Button 2</button>
</div>`}
                    </code>
                  </pre>
                </li><br />
                <li>
                  <strong>Justified Button Groups:</strong> To make the button group take the full width of its container, you can add the <code>btn-group-justified</code> class.
                     <pre className={style.codeoverflow}>
                    <code>
                      {`<div class="btn-group btn-group-justified" role="group">
  <button type="button" class="btn btn-primary">Button 1</button>
  <button type="button" class="btn btn-primary">Button 2</button>
  <button type="button" class="btn btn-primary">Button 3</button>
</div>`}
                    </code>
                  </pre>
                </li>
              </ul><br />

              <h3>Conclusion:</h3>
              <p>
                Bootstrap's Button Groups make it easy to group buttons in a horizontal or vertical layout, offering flexibility for user interface design. By utilizing the basic <code>btn-group</code> class, you can create organized and neat button structures, and also enhance the design with various customizations like sizing, button states, and nested elements.
              </p>
            </div>
          )}

          {selectedChapter === 'chapter13' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Glyphicons</h1>
              <p><strong>Glyphicons</strong> were once a part of Bootstrap, providing a library of vector-based icons that you could use in your projects. They were included in Bootstrap 3 but were removed in Bootstrap 4 in favor of using other icon libraries like <a href="https://fontawesome.com/" target="_blank" rel="noopener noreferrer">Font Awesome</a> or <a href="https://icons.getbootstrap.com/" target="_blank" rel="noopener noreferrer">Bootstrap Icons</a>.</p><br />

              <h3>Using Glyphicons in Bootstrap 3</h3>

              <p style={{ paddingBottom: "6px" }}>If you're still using Bootstrap 3 and want to include Glyphicons, here's how you can implement them:</p>

              <h4>1. Adding Glyphicons</h4>
              <p>Glyphicons are included by default in Bootstrap 3. To use them, simply add the <code>&lt;span&gt;</code> element with the appropriate glyphicon class.</p>
                 <pre className={style.codeoverflow}><code>{`<span class="glyphicon glyphicon-search"></span> Search`}</code></pre>
              <p>This will display a search icon next to the text "Search".</p><br />

              <h4>2. List of Common Glyphicons</h4>
              <p>Here are some common examples of Glyphicons you can use in Bootstrap 3:</p>
              <ul>
                <li><code>{`<span class="glyphicon glyphicon-search"></span>`}</code> - Search Icon</li><br />
                <li><code>{`<span class="glyphicon glyphicon-home"></span>`}</code> - Home Icon</li><br />
                <li><code>{`<span class="glyphicon glyphicon-user"></span>`}</code> - User Icon</li><br />
                <li><code>{`<span class="glyphicon glyphicon-trash"></span>`}</code> - Trash Icon</li><br />
                <li><code>{`<span class="glyphicon glyphicon-envelope"></span>`}</code> - Envelope Icon (Mail)</li><br />
                <li><code>{`<span class="glyphicon glyphicon-plus"></span>`}</code> - Plus Icon</li>
              </ul><br />

              <h4>3. Icon Sizing</h4>
              <p>You can control the size of Glyphicons by using Bootstrap's <code>.glyphicon-lg</code> (for large icons) and <code>.glyphicon-sm</code> (for small icons).</p>
                 <pre className={style.codeoverflow}><code>{`<span class="glyphicon glyphicon-home glyphicon-lg"></span> Large Home Icon`}</code></pre>
              <p>This will display a larger version of the home icon.</p><br />

              <h4>4. Icons with Buttons</h4>
              <p>You can easily add icons inside buttons for a more interactive UI. Here's an example of using a glyphicon in a button:</p>
                 <pre className={style.codeoverflow}><code>{`<button type="button" class="btn btn-primary">
  <span class="glyphicon glyphicon-thumbs-up"></span> Like
</button>`}</code></pre>
              <p>This will create a button with a thumbs-up icon and the text "Like".</p><br />

              <h3>Moving Forward: Bootstrap 4 and Beyond</h3>
              <p style={{ paddingBottom: "6px" }}>Since Glyphicons are no longer included in Bootstrap 4, you'll need to use external icon libraries like <strong>Font Awesome</strong> or <strong>Bootstrap Icons</strong>. Here's how you can integrate <strong>Bootstrap Icons</strong> (recommended for Bootstrap 4/5):</p>

              <h4>1. Using Bootstrap Icons</h4>
              <p>To use Bootstrap Icons, you can include them in your project by either using a CDN or by installing them with npm.</p>

              <h5>CDN Approach:</h5>
                 <pre className={style.codeoverflow}><code>{`<link href="https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css" rel="stylesheet">`}</code></pre>
              <p>Then, you can use them like this:</p>
                 <pre className={style.codeoverflow}><code>{`<i class="bi bi-house-door"></i> Home`}</code></pre><br />

              <h4>2. Using Font Awesome</h4>
              <p>Font Awesome is a popular alternative to Glyphicons. To use Font Awesome icons, include the Font Awesome CDN in your <code>&lt;head&gt;</code>:</p>
                 <pre className={style.codeoverflow}><code>{`<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css">`}</code></pre>
              <p>Then, use the icons like so:</p>
                 <pre className={style.codeoverflow}><code>{`<i class="fas fa-home"></i> Home`}</code></pre><br />

              <h3>Conclusion</h3>
              <p>If you're still working with <strong>Bootstrap 3</strong>, you can use <strong>Glyphicons</strong> as described above. However, for <strong>Bootstrap 4 and later</strong>, it's recommended to use <strong>Bootstrap Icons</strong> or <strong>Font Awesome</strong> for icons, as Glyphicons are no longer supported.</p>
            </div>
          )}

          {selectedChapter === 'chapter14' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Badges/Labels</h1>
              <p>
                In Bootstrap, <strong>badges</strong> or <strong>labels</strong> are used to display contextual information,
                such as counters, notifications, or status indicators. They are often small, rounded, and can be attached to
                various elements like buttons, links, or list items.
              </p><br />

              <h3>1. Basic Badge</h3>
              <p>A simple badge can be created using the <code>.badge</code> class. Badges can be used for displaying simple labels.</p>
                 <pre className={style.codeoverflow}><code>{`<span class="badge bg-primary">Primary</span>`}</code></pre><br />

              <h3>2. Badge Colors</h3>
              <p>Bootstrap offers a variety of built-in contextual classes to color badges based on the context (such as <code>bg-primary</code>, <code>bg-success</code>, <code>bg-danger</code>, etc.).</p>
              <ul>
                <li><strong>Primary:</strong> <code>bg-primary</code></li><br />
                <li><strong>Secondary:</strong> <code>bg-secondary</code></li><br />
                <li><strong>Success:</strong> <code>bg-success</code></li><br />
                <li><strong>Danger:</strong> <code>bg-danger</code></li><br />
                <li><strong>Warning:</strong> <code>bg-warning</code></li><br />
                <li><strong>Info:</strong> <code>bg-info</code></li><br />
                <li><strong>Light:</strong> <code>bg-light</code></li><br />
                <li><strong>Dark:</strong> <code>bg-dark</code></li>
              </ul>
                 <pre className={style.codeoverflow}><code>{`<span class="badge bg-success">Success</span>
<span class="badge bg-danger">Danger</span>
<span class="badge bg-warning">Warning</span>
<span class="badge bg-info">Info</span>`}</code></pre><br />

              <h3>3. Badge with Links or Buttons</h3>
              <p>Badges can be added to links, buttons, and other elements to indicate a count, notification, or status.</p>
                 <pre className={style.codeoverflow}><code>{`<a href="#" class="btn btn-primary">
  Notifications <span class="badge bg-light text-dark">5</span>
</a>`}</code></pre><br />

              <h3>4. Pill-shaped Badges</h3>
              <p>To create pill-shaped badges (more rounded), use the <code>.rounded-pill</code> class.</p>
                 <pre className={style.codeoverflow}><code>{`<span class="badge bg-primary rounded-pill">Pill Badge</span>`}</code></pre><br />

              <h3>5. Badge with Counter</h3>
              <p>Badges can be used to show numeric values, like counters. This is useful for notifications, messages, or product quantities.</p>
                 <pre className={style.codeoverflow}><code>{`<button type="button" class="btn btn-danger">
  Messages <span class="badge bg-light text-dark">10</span>
</button>`}</code></pre><br />

              <h3>6. Badges in List Groups</h3>
              <p>Badges can be included in list groups to show additional contextual information about list items.</p>
                 <pre className={style.codeoverflow}><code>{`<ul class="list-group">
  <li class="list-group-item">
    Item 1 <span class="badge bg-primary">New</span>
  </li>
  <li class="list-group-item">
    Item 2 <span class="badge bg-secondary">Sold Out</span>
  </li>
</ul>`}</code></pre><br />

              <h3>7. Badges on Buttons or Other Elements</h3>
              <p>Badges can also be used on buttons, navigation items, or other interactive elements to show additional information, like notifications or unread messages.</p>
                 <pre className={style.codeoverflow}><code>{`<button type="button" class="btn btn-info">
  Messages <span class="badge bg-light text-dark">3</span>
</button>`}</code></pre><br />

              <h3>8. Multiple Badges</h3>
              <p>You can place multiple badges next to each other to display multiple pieces of information.</p>
                 <pre className={style.codeoverflow}><code>{`<span class="badge bg-primary">Primary</span>
<span class="badge bg-secondary">Secondary</span>
<span class="badge bg-success">Success</span>`}</code></pre><br />
              <h3>9. Badge Positioning</h3>
              <p>Badges can be used on top of other elements, like icons, to indicate additional information. This can be done by positioning the badge using Bootstrap's utility classes like <code>.position-relative</code> and <code>.position-absolute</code>.</p>
                 <pre className={style.codeoverflow}><code>{`<span class="position-relative d-inline-block">
  <i class="bi bi-bell"></i>
  <span class="badge bg-danger position-absolute top-0 start-100 translate-middle">3</span>
</span>`}</code></pre><br />

              <h3>10. Customizing Badge Styles</h3>
              <p>You can also customize the badges further by changing their font size, padding, or other styles using custom CSS or Bootstrap utilities.</p>
                 <pre className={style.codeoverflow}><code>{`<span class="badge bg-primary fs-4">Larger Badge</span>`}</code></pre><br />

              <h3>Example: Full List with Badges</h3>
                 <pre className={style.codeoverflow}><code>{`<ul class="list-group">
  <li class="list-group-item">
    Task 1 <span class="badge bg-success">Completed</span>
  </li>
  <li class="list-group-item">
    Task 2 <span class="badge bg-warning">In Progress</span>
  </li>
  <li class="list-group-item">
    Task 3 <span class="badge bg-danger">Overdue</span>
  </li>
</ul>`}</code></pre><br />


            </div>
          )}

          {selectedChapter === 'chapter15' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Progress Bars</h1>

              <p style={{ paddingBottom: "6px" }}>Progress bars are used to display the progression of an ongoing process or task. Bootstrap provides an easy way to create responsive, animated progress bars with a few simple classes.</p><br />

              <h3>1. Basic Progress Bar</h3>
              <p>A simple, basic progress bar can be created using the <code>.progress</code> class for the container and the <code>.progress-bar</code> class for the progress element itself.</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="progress">
          <div class="progress-bar" style="width: 50%;">50%</div>
        </div>`}
                </code>
              </pre>
              <ul>
                <li>The <code>width</code> style determines the progress (e.g., <code>50%</code> indicates the progress is halfway done).</li><br />
                <li>The progress text (<code>50%</code>) is added to indicate the current progress.</li>
              </ul><br />

              <h3>2. Progress Bar Colors</h3>
              <p>Bootstrap allows you to use different contextual color classes for the progress bar, such as <code>bg-success</code>, <code>bg-warning</code>, <code>bg-danger</code>, and others.</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="progress">
          <div class="progress-bar bg-success" style="width: 75%;">75%</div>
        </div>`}
                </code>
              </pre>
              <p>Here are some of the available colors for progress bars in Bootstrap:</p>
              <ul>
                <li><code>bg-success</code> - Green (success)</li><br />
                <li><code>bg-info</code> - Blue (information)</li><br />
                <li><code>bg-warning</code> - Yellow (warning)</li><br />
                <li><code>bg-danger</code> - Red (danger)</li><br />
                <li><code>bg-primary</code> - Blue (primary)</li><br />
                <li><code>bg-secondary</code> - Gray (secondary)</li>
              </ul><br />

              <h3>3. Animated Progress Bar</h3>
              <p>Bootstrap supports an animated progress bar to visually indicate ongoing progress. You can use the <code>.progress-bar-striped</code> class for striped effects, and <code>.progress-bar-animated</code> for a continuous animation.</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="progress">
          <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 60%;"></div>
        </div>`}
                </code>
              </pre>
              <ul>
                <li><code>.progress-bar-striped</code>: Adds stripes to the progress bar.</li><br />
                <li><code>.progress-bar-animated</code>: Makes the stripes animate from left to right.</li>
              </ul><br />

              <h3>4. Progress Bar with Multiple Segments</h3>
              <p>You can also create a progress bar with multiple segments to show different levels of progress within the same bar.</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="progress">
          <div class="progress-bar bg-primary" style="width: 25%;">25%</div>
          <div class="progress-bar bg-warning" style="width: 50%;">50%</div>
          <div class="progress-bar bg-danger" style="width: 25%;">25%</div>
        </div>`}
                </code>
              </pre>
              <p>This will create a progress bar with 3 different segments, each with its own color.</p><br />

              <h3>5. Stacked Progress Bars</h3>
              <p>If you need to stack multiple progress bars vertically, you can simply wrap each progress bar in a <code>&lt;div&gt;</code>.</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="progress mb-3">
          <div class="progress-bar bg-primary" style="width: 25%;">25%</div>
        </div>
        <div class="progress mb-3">
          <div class="progress-bar bg-success" style="width: 50%;">50%</div>
        </div>
        <div class="progress">
          <div class="progress-bar bg-danger" style="width: 75%;">75%</div>
        </div>`}
                </code>
              </pre><br />

              <h3>6. Customizing Progress Bar Size</h3>
              <p>You can modify the height of the progress bar by using custom CSS or Bootstrap utilities.</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="progress" style="height: 30px;">
          <div class="progress-bar bg-info" style="width: 40%;">40%</div>
        </div>`}
                </code>
              </pre>
              <p>Here, the height of the progress bar is increased to <code>30px</code> using inline styles.</p><br />

              <h3>7. Progress Bar with Labels</h3>
              <p>To show a label inside the progress bar, you can place text inside the <code>.progress-bar</code> element. The label will appear at the center of the progress bar.</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="progress">
          <div class="progress-bar bg-info" style="width: 60%;">60%</div>
        </div>`}
                </code>
              </pre><br />

              <h3>8. Striped Progress Bar (Non-Animated)</h3>
              <p>If you prefer striped progress without animation, you can use the <code>.progress-bar-striped</code> class by itself:</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="progress">
          <div class="progress-bar progress-bar-striped" style="width: 50%;">50%</div>
        </div>`}
                </code>
              </pre><br />

              <h3>Full Example</h3>
              <p>Here’s a complete example combining various types of progress bars:</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="container mt-5">
          <h2>Basic Progress Bar</h2>
          <div class="progress mb-3">
            <div class="progress-bar" style="width: 40%;">40%</div>
          </div>

          <h2>Colored Progress Bar</h2>
          <div class="progress mb-3">
            <div class="progress-bar bg-success" style="width: 75%;">75%</div>
          </div>

          <h2>Animated Striped Progress Bar</h2>
          <div class="progress mb-3">
            <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 60%;"></div>
          </div>

          <h2>Multiple Segments Progress Bar</h2>
          <div class="progress mb-3">
            <div class="progress-bar bg-primary" style="width: 25%;">25%</div>
            <div class="progress-bar bg-warning" style="width: 50%;">50%</div>
            <div class="progress-bar bg-danger" style="width: 25%;">25%</div>
          </div>

          <h2>Stacked Progress Bars</h2>
          <div class="progress mb-3">
            <div class="progress-bar bg-info" style="width: 40%;">40%</div>
          </div>
          <div class="progress mb-3">
            <div class="progress-bar bg-warning" style="width: 60%;">60%</div>
          </div>
          <div class="progress">
            <div class="progress-bar bg-danger" style="width: 80%;">80%</div>
          </div>
        </div>`}
                </code>
              </pre><br />

              <h3>Conclusion</h3>
              <p>Bootstrap's progress bars are a powerful way to visually represent tasks and processes. With minimal HTML and the use of utility classes, you can easily create basic, animated, and customized progress bars to suit your application's needs.</p>
            </div>
          )}



          {selectedChapter === 'chapter16' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Pagination</h1>

              <p>
                Pagination in Bootstrap is a simple and effective way to divide content into separate pages,
                allowing users to navigate through large datasets or content sections. Bootstrap provides
                built-in classes to create pagination components easily.
              </p><br />

              <h3>Basic Pagination</h3>
              <p>
                To create basic pagination in Bootstrap, use the <code>.pagination</code> class along with
                <code>.page-item</code> for each page and <code>.page-link</code> for each individual link.
              </p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<nav>
  <ul class="pagination">
    <li class="page-item">
      <a class="page-link" href="#" aria-label="Previous">
        <span aria-hidden="true">&laquo;</span>
      </a>
    </li>
    <li class="page-item"><a class="page-link" href="#">1</a></li>
    <li class="page-item"><a class="page-link" href="#">2</a></li>
    <li class="page-item"><a class="page-link" href="#">3</a></li>
    <li class="page-item">
      <a class="page-link" href="#" aria-label="Next">
        <span aria-hidden="true">&raquo;</span>
      </a>
    </li>
  </ul>
</nav>`}
                </code>
              </pre><br />

              <h3>Pagination with Active and Disabled States</h3>
              <p>
                Highlight the current page using the <code>.active</code> class, and disable pagination links
                with the <code>.disabled</code> class.
              </p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<nav>
  <ul class="pagination">
    <li class="page-item disabled">
      <a class="page-link" href="#" tabindex="-1" aria-disabled="true">Previous</a>
    </li>
    <li class="page-item"><a class="page-link" href="#">1</a></li>
    <li class="page-item active" aria-current="page">
      <a class="page-link" href="#">2</a>
    </li>
    <li class="page-item"><a class="page-link" href="#">3</a></li>
    <li class="page-item">
      <a class="page-link" href="#">Next</a>
    </li>
  </ul>
</nav>`}
                </code>
              </pre><br />

              <h3>Pagination with Large Buttons</h3>
              <p>To create larger pagination buttons, use the <code>.pagination-lg</code> class.</p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<nav>
  <ul class="pagination pagination-lg">
    <li class="page-item"><a class="page-link" href="#">1</a></li>
    <li class="page-item"><a class="page-link" href="#">2</a></li>
    <li class="page-item"><a class="page-link" href="#">3</a></li>
  </ul>
</nav>`}
                </code>
              </pre><br />

              <h3>Pagination with Small Buttons</h3>
              <p>To create smaller pagination buttons, use the <code>.pagination-sm</code> class.</p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<nav>
  <ul class="pagination pagination-sm">
    <li class="page-item"><a class="page-link" href="#">1</a></li>
    <li class="page-item"><a class="page-link" href="#">2</a></li>
    <li class="page-item"><a class="page-link" href="#">3</a></li>
  </ul>
</nav>`}
                </code>
              </pre><br />

              <h3>Justified Pagination</h3>
              <p>
                To create pagination that stretches across the width of its container, use the
                <code>.justify-content-center</code> class to center it.
              </p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<nav>
  <ul class="pagination justify-content-center">
    <li class="page-item"><a class="page-link" href="#">1</a></li>
    <li class="page-item"><a class="page-link" href="#">2</a></li>
    <li class="page-item"><a class="page-link" href="#">3</a></li>
  </ul>
</nav>`}
                </code>
              </pre><br />

              <h3>Conclusion</h3>
              <p>
                Bootstrap's pagination components are versatile and easy to use, providing various options to
                customize the appearance and behavior of pagination. By using the appropriate classes, you can
                create standard, large, small, and justified pagination systems to enhance the user experience.
              </p>
            </div>
          )}




          {selectedChapter === 'chapter17' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Pager</h1>

              <p>
                In Bootstrap, a <strong>pager</strong> is a simple component used to create a basic pagination interface that allows users to navigate through a large set of content or data. It is typically used for smaller datasets or when you need a simple "previous" and "next" navigation option.
              </p><br />

              <h3>Basic Pager Structure</h3>
              <p style={{ paddingBottom: "6px" }}>
                In Bootstrap, the pager component is created using the <code>.pager</code> class, which is applied to an unordered list (<code>&lt;ul&gt;</code>), and each item (<code>&lt;li&gt;</code>) will contain the link (<code>&lt;a&gt;</code>) for navigation.
              </p>

              <h4>Example: Basic Pager</h4>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<nav>
  <ul class="pager">
    <li class="previous"><a href="#">Previous</a></li>
    <li class="next"><a href="#">Next</a></li>
  </ul>
</nav>`}
                </code>
              </pre><br />

              <h5 style={{ paddingBottom: "6px" }}>Explanation:</h5>
              <ul>
                <li><strong>&lt;ul class="pager"&gt;</strong>: This applies the pager styles.</li><br />
                <li><strong>&lt;li class="previous"&gt;</strong>: Represents the "Previous" button.</li><br />
                <li><strong>&lt;li class="next"&gt;</strong>: Represents the "Next" button.</li><br />
                <li><strong>&lt;a href="#"&gt;</strong>: A clickable link inside each list item.</li>
              </ul><br />

              <h3>Customizing the Pager</h3>
              <p style={{ paddingBottom: "6px" }}>You can customize the pager by adding additional classes or using other Bootstrap components to enhance its functionality.</p>

              <h4>1. Disabled State</h4>
              <p>
                To disable a pager item (e.g., "Previous" when you are on the first page), add the <code>.disabled</code> class.
              </p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<nav>
  <ul class="pager">
    <li class="previous disabled"><a href="#">Previous</a></li>
    <li class="next"><a href="#">Next</a></li>
  </ul>
</nav>`}
                </code>
              </pre><br />

              <h4>2. Alignment</h4>
              <p>
                You can align the pager to the left, center, or right using Bootstrap’s utility classes like <code>.text-center</code>, <code>.text-left</code>, or <code>.text-right</code>.
              </p>
              <h5>Example: Centered Pager</h5>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<nav class="text-center">
  <ul class="pager">
    <li class="previous"><a href="#">Previous</a></li>
    <li class="next"><a href="#">Next</a></li>
  </ul>
</nav>`}
                </code>
              </pre><br />

              <h3>Conclusion</h3>
              <p>
                Bootstrap’s pager is a lightweight and simple way to add pagination to your website, but for more complex pagination needs (e.g., displaying page numbers), you might want to use the full pagination component (<code>.pagination</code>) instead. The pager is ideal for when you only need "previous" and "next" navigation.
              </p>
            </div>
          )}



          {selectedChapter === 'chapter18' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>List Group</h1>

              <p>
                A <strong>list group</strong> in Bootstrap is a component that provides a flexible and powerful way to display a list of items in a structured manner. It is often used for lists of links, actions, or any other group of items that need to be presented in a consistent layout.
              </p><br />

              <h2>Basic List Group</h2>
              <p>A basic list group displays a series of items in a vertical list:</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<ul class="list-group">
  <li class="list-group-item">Item 1</li>
  <li class="list-group-item">Item 2</li>
  <li class="list-group-item">Item 3</li>
</ul>`}
                </code>
              </pre><br />

              <h2>List Group with Links</h2>
              <p>You can use <code>list-group-item</code> with anchor tags (<code>&lt;a&gt;</code>) to create a list of clickable items, typically used for navigation:</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<ul class="list-group">
  <li class="list-group-item"><a href="#" class="list-group-item-action">Link 1</a></li>
  <li class="list-group-item"><a href="#" class="list-group-item-action">Link 2</a></li>
  <li class="list-group-item"><a href="#" class="list-group-item-action">Link 3</a></li>
</ul>`}
                </code>
              </pre><br />

              <h2>Active State</h2>
              <p>To highlight the active list item, you can add the <code>active</code> class to a <code>list-group-item</code>. This is commonly used in navigation or selections:</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<ul class="list-group">
  <li class="list-group-item active">Active Item</li>
  <li class="list-group-item">Item 2</li>
  <li class="list-group-item">Item 3</li>
</ul>`}
                </code>
              </pre><br />

              <h2>Disabled State</h2>
              <p>You can make an item disabled by adding the <code>disabled</code> class, which will make the item unclickable and visually appear as disabled:</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<ul class="list-group">
  <li class="list-group-item">Item 1</li>
  <li class="list-group-item disabled">Disabled Item</li>
  <li class="list-group-item">Item 3</li>
</ul>`}
                </code>
              </pre><br />

              <h2>List Group with Badges</h2>
              <p>You can add a <strong>badge</strong> to the list group items for notifications or counts:</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<ul class="list-group">
  <li class="list-group-item">Item 1 <span class="badge bg-primary">New</span></li>
  <li class="list-group-item">Item 2 <span class="badge bg-secondary">20</span></li>
  <li class="list-group-item">Item 3 <span class="badge bg-success">5</span></li>
</ul>`}
                </code>
              </pre><br />

              <h2>List Group with Contextual Classes</h2>
              <p>Bootstrap provides contextual classes to style the items differently based on the state (e.g., success, warning, danger):</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<ul class="list-group">
  <li class="list-group-item list-group-item-success">Success Item</li>
  <li class="list-group-item list-group-item-warning">Warning Item</li>
  <li class="list-group-item list-group-item-danger">Danger Item</li>
</ul>`}
                </code>
              </pre><br />

              <h2>List Group with Custom Content</h2>
              <p>You can customize the content inside list group items to include buttons, text, images, etc:</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<ul class="list-group">
  <li class="list-group-item">
    <div class="d-flex justify-content-between">
      <span>Item 1</span>
      <button class="btn btn-sm btn-primary">Action</button>
    </div>
  </li>
  <li class="list-group-item">
    <div class="d-flex justify-content-between">
      <span>Item 2</span>
      <button class="btn btn-sm btn-danger">Delete</button>
    </div>
  </li>
</ul>`}
                </code>
              </pre><br />

              <h2>Flush List Group</h2>
              <p>A flush list group removes the borders and padding from the list items, making the list items appear as part of a continuous block:</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<ul class="list-group list-group-flush">
  <li class="list-group-item">Item 1</li>
  <li class="list-group-item">Item 2</li>
  <li class="list-group-item">Item 3</li>
</ul>`}
                </code>
              </pre><br />

              <h2>Stack List Group (Responsive)</h2>
              <p>You can stack list items horizontally on small screens by using the <code>list-group-horizontal</code> class:</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<ul class="list-group list-group-horizontal">
  <li class="list-group-item">Item 1</li>
  <li class="list-group-item">Item 2</li>
  <li class="list-group-item">Item 3</li>
</ul>`}
                </code>
              </pre><br />

              <h2>Example: Full List Group</h2>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<ul class="list-group">
  <li class="list-group-item active">Active Item</li>
  <li class="list-group-item">Item 2</li>
  <li class="list-group-item list-group-item-success">Success Item</li>
  <li class="list-group-item disabled">Disabled Item</li>
  <li class="list-group-item">
    Item 5 <span class="badge bg-primary">5</span>
  </li>
</ul>`}
                </code>
              </pre><br />

              <h2 style={{ paddingBottom: "6px" }}>Key Classes:</h2>
              <ul>
                <li><strong>list-group</strong>: Base class for the list group.</li><br />
                <li><strong>list-group-item</strong>: Used for each item in the list.</li><br />
                <li><strong>list-group-item-action</strong>: Used to make list items clickable.</li><br />
                <li><strong>active</strong>: Highlights the active item.</li><br />
                <li><strong>disabled</strong>: Makes the list item unclickable and visually looks disabled.</li><br />
                <li><strong>badge</strong>: Adds badges for notifications or counts.</li>
              </ul><br />

              <p>Bootstrap's list groups provide a great way to manage and display sets of information or actions in a clean and structured manner.</p>
            </div>
          )}



          {selectedChapter === 'chapter19' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Panels</h1>

              <p>
                In Bootstrap, <strong>panels</strong> are a versatile and flexible component that allows you to group content together, usually with a border, title, and optional footer. Panels are widely used to highlight or emphasize content in various web layouts. However, with Bootstrap 4 and beyond, the panel component was replaced by <strong>Cards</strong>, which provide a more flexible and powerful layout system. If you're using an older version of Bootstrap (like Bootstrap 3), panels are still in use.
              </p><br />

              <h2 style={{ paddingBottom: "6px" }}>Here's how you can use panels in <strong>Bootstrap 3</strong>:</h2>

              <h3>Basic Panel</h3>
              <p>A basic panel in Bootstrap provides a simple container with a header and content.</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="panel panel-default">
  <div class="panel-heading">Panel Heading</div>
  <div class="panel-body">Panel content goes here</div>
</div>`}
                </code>
              </pre><br />

              <h3>Panel with Different Contextual Classes</h3>
              <p>Bootstrap provides contextual classes to change the appearance of panels based on the state or type of content.</p>
              <ul>
                <li><code>panel-primary</code>: For primary content (typically blue).</li><br />
                <li><code>panel-success</code>: For success messages (green).</li><br />
                <li><code>panel-info</code>: For informational messages (light blue).</li><br />
                <li><code>panel-warning</code>: For warning messages (yellow).</li><br />
                <li><code>panel-danger</code>: For error messages (red).</li>
              </ul><br />

                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="panel panel-primary">
  <div class="panel-heading">Primary Panel</div>
  <div class="panel-body">This is the body of the primary panel.</div>
</div>

<div class="panel panel-success">
  <div class="panel-heading">Success Panel</div>
  <div class="panel-body">This is the body of the success panel.</div>
</div>

<div class="panel panel-warning">
  <div class="panel-heading">Warning Panel</div>
  <div class="panel-body">This is the body of the warning panel.</div>
</div>

<div class="panel panel-danger">
  <div class="panel-heading">Danger Panel</div>
  <div class="panel-body">This is the body of the danger panel.</div>
</div>`}
                </code>
              </pre><br />

              <h3>Panel with Footer</h3>
              <p>You can add a footer to the panel for additional content, like buttons, links, or other items.</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="panel panel-default">
  <div class="panel-heading">Panel Heading</div>
  <div class="panel-body">This is the body of the panel.</div>
  <div class="panel-footer">This is the footer of the panel</div>
</div>`}
                </code>
              </pre><br />

              <h3>Panel with Links</h3>
              <p>Panels can also include links that are styled like buttons. This is useful for making interactive panels.</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="panel panel-default">
  <div class="panel-heading">Panel Heading</div>
  <div class="panel-body">This is the body of the panel.</div>
  <div class="panel-footer">
    <a href="#" class="btn btn-primary">Go to Link</a>
  </div>
</div>`}
                </code>
              </pre><br />

              <h3>Collapsing a Panel</h3>
              <p>Bootstrap also allows you to collapse a panel's body using JavaScript. This is useful for creating accordion-like interfaces.</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="panel-group" id="accordion">
  <div class="panel panel-default">
    <div class="panel-heading">
      <h4 class="panel-title">
        <a data-toggle="collapse" data-parent="#accordion" href="#collapseOne">
          Collapsible Panel
        </a>
      </h4>
    </div>
    <div id="collapseOne" class="panel-collapse collapse in">
      <div class="panel-body">This is the body of the collapsible panel.</div>
    </div>
  </div>
</div>`}
                </code>
              </pre><br />

              <h3>Panel with List Group</h3>
              <p>You can use a <strong>list group</strong> inside a panel to display a group of items.</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="panel panel-default">
  <div class="panel-heading">Panel Heading</div>
  <div class="panel-body">
    <ul class="list-group">
      <li class="list-group-item">Item 1</li>
      <li class="list-group-item">Item 2</li>
      <li class="list-group-item">Item 3</li>
    </ul>
  </div>
</div>`}
                </code>
              </pre><br />

              <h3>Panels in Bootstrap 4 and Beyond</h3>
              <p>With the introduction of <strong>Bootstrap 4</strong>, panels were replaced by <strong>cards</strong>, which offer a more flexible and customizable layout. A basic card in Bootstrap 4 looks like this:</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="card">
  <div class="card-header">Card Header</div>
  <div class="card-body">Card content goes here</div>
</div>`}
                </code>
              </pre><br />

              <p>In <strong>Bootstrap 5</strong>, the card component continues to be the recommended structure for grouping content, with additional enhancements to card layout and styling options.</p><br />

              <h3>Key Classes for Panels in Bootstrap 3:</h3>
              <ul>
                <li><code>panel</code>: Base class for the panel.</li><br />
                <li><code>panel-heading</code>: Defines the header section of the panel.</li><br />
                <li><code>panel-body</code>: Defines the body/content section of the panel.</li><br />
                <li><code>panel-footer</code>: Defines the footer section of the panel.</li><br />
                <li><code>panel-default</code>, <code>panel-primary</code>, <code>panel-success</code>, <code>panel-info</code>, <code>panel-warning</code>, <code>panel-danger</code>: Contextual classes to style the panel.</li>
              </ul><br />

              <h3>Note:</h3>
              <p>In newer versions of Bootstrap (4 and 5), panels are no longer recommended. Cards are more flexible and provide more styling options. If you're working with Bootstrap 4 or 5, consider using cards instead of panels for better flexibility and control.</p>
            </div>
          )}



          {selectedChapter === 'chapter20' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Dropdowns</h1>
              <p>Dropdowns in Bootstrap allow users to select options from a list. They are built using classes like <code>.dropdown</code>, <code>.dropdown-toggle</code>, and <code>.dropdown-menu</code>. Bootstrap's JavaScript and utility classes handle the functionality.</p><br />

              <h4>Basic Example:</h4>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="dropdown">
  <button class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown">
    Dropdown
  </button>
  <ul class="dropdown-menu">
    <li><a class="dropdown-item" href="#">Action</a></li>
    <li><a class="dropdown-item" href="#">Another action</a></li>
    <li><a class="dropdown-item" href="#">Something else here</a></li>
  </ul>
</div>`}
                </code>
              </pre><br />

              <h4 style={{ paddingBottom: "6px" }}>Customizations:</h4>
              <ul>
                <li><strong>Align:</strong> Use <code>.dropdown-menu-end</code> for right-aligned menus.</li><br />
                <li><strong>Dropup:</strong> Replace <code>.dropdown</code> with <code>.dropup</code>.</li><br />
                <li><strong>Dividers:</strong> Add <code>&lt;hr class="dropdown-divider"&gt;</code> to separate items.</li>
              </ul><br />

              <h4>Nested Dropdown:</h4>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="dropdown">
  <button class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown">
    Parent
  </button>
  <ul class="dropdown-menu">
    <li><a class="dropdown-item" href="#">Action</a></li>
    <li class="dropdown-submenu">
      <a class="dropdown-item" href="#">Submenu</a>
      <ul class="dropdown-menu">
        <li><a class="dropdown-item" href="#">Sub-item</a></li>
      </ul>
    </li>
  </ul>
</div>`}
                </code>
              </pre><br />
            </div>
          )}

          {selectedChapter === 'chapter21' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Collapse</h1>
              <p>
                The Collapse component in Bootstrap allows toggling content visibility for menus, accordions, or any collapsible sections. It uses classes and attributes like `data-bs-toggle="collapse"` and `data-bs-target` for functionality.
              </p><br />

              <h4>Basic Example</h4>
                 <pre className={style.codeoverflow}>
                <code>{`
<button class="btn btn-primary" data-bs-toggle="collapse" data-bs-target="#collapseExample">
  Toggle
</button>
<div id="collapseExample" class="collapse">
  <div class="card card-body">Collapsible Content</div>
</div>`}</code>
              </pre><br />

              <h4>Accordion Example</h4>
                 <pre className={style.codeoverflow}>
                <code>{`
<div class="accordion" id="accordionExample">
  <div class="accordion-item">
    <button class="accordion-button" data-bs-toggle="collapse" data-bs-target="#collapseOne">
      Item 1
    </button>
    <div id="collapseOne" class="accordion-collapse collapse show">
      <div class="accordion-body">Content 1</div>
    </div>
  </div>
</div>`}</code>
              </pre><br />

              <p>
                Use JavaScript for custom behavior with `new bootstrap.Collapse(element)`. Bootstrap 5 uses vanilla JavaScript, making it lightweight and customizable.
              </p>
            </div>
          )}

          {selectedChapter === 'chapter22' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Tabs/Pills</h1>
              <p>
                Bootstrap provides <strong>Tabs</strong> and <strong>Pills</strong> as navigation components to organize content efficiently. They enable users to switch between content panels without reloading the page, offering a smooth and intuitive experience.
              </p>
              <br />

              <h2>Tabs</h2>
              <p style={{ paddingBottom: "6px" }}>
                Tabs are horizontal navigation links, typically used to group and display large sections of related content.
              </p>
              <h3>Code Example (Tabs)</h3>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<ul class="nav nav-tabs" id="myTab" role="tablist">
  <li class="nav-item">
    <a class="nav-link active" id="home-tab" data-bs-toggle="tab" href="#home" role="tab">Home</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" id="profile-tab" data-bs-toggle="tab" href="#profile" role="tab">Profile</a>
  </li>
</ul>
<div class="tab-content">
  <div class="tab-pane fade show active" id="home" role="tabpanel">
    <p>Content for Home tab.</p>
  </div>
  <div class="tab-pane fade" id="profile" role="tabpanel">
    <p>Content for Profile tab.</p>
  </div>
</div>`}
                </code>
              </pre><br />

              <h3 style={{ paddingBottom: "6px" }}>Features</h3>
              <ul>
                <li>
                  <strong>Class Usage:</strong>
                  <ul>
                    <li><code>&lt;ul class="nav nav-tabs"&gt;</code>: Defines a tab navigation bar.</li><br />
                    <li><code>&lt;div class="tab-content"&gt;</code>: Container for tab panels.</li>
                  </ul>
                </li><br />
                <li>
                  <strong>Active State:</strong> Add <code>class="active"</code> to the link and panel to make them active initially.
                </li><br />
                <li>
                  <strong>Seamless Navigation:</strong> Tabs rely on Bootstrap’s JavaScript for dynamic switching.
                </li>
              </ul>

              <br />

              <h2>Pills</h2>
              <p style={{ paddingBottom: "6px" }}>
                Pills are similar to tabs but use a rounded, pill-like design.
              </p>
              <h3>Code Example (Pills)</h3>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<ul class="nav nav-pills" id="myPills" role="tablist">
  <li class="nav-item">
    <a class="nav-link active" id="home-pill" data-bs-toggle="pill" href="#home-pill-content" role="tab">Home</a>
  </li>
  <li class="nav-item">
    <a class="nav-link" id="profile-pill" data-bs-toggle="pill" href="#profile-pill-content" role="tab">Profile</a>
  </li>
</ul>
<div class="tab-content">
  <div class="tab-pane fade show active" id="home-pill-content" role="tabpanel">
    <p>Content for Home pill.</p>
  </div>
  <div class="tab-pane fade" id="profile-pill-content" role="tabpanel">
    <p>Content for Profile pill.</p>
  </div>
</div>`}
                </code>
              </pre><br />

              <h3 style={{ paddingBottom: "6px" }}>Features</h3>
              <ul>
                <li><strong>Rounded Design:</strong> Use <code>class="nav-pills"</code> instead of <code>nav-tabs</code> for a different appearance.</li><br />
                <li><strong>Compact Navigation:</strong> Often used in smaller UI areas.</li><br />
                <li><strong>Same JavaScript Behavior:</strong> Like tabs, pills also use <code>data-bs-toggle="pill"</code> for switching.</li>
              </ul>

              <br />

              <h2>Key Differences</h2>
              <table>
                <thead>
                  <tr>
                    <th>Feature</th>
                    <th>Tabs</th>
                    <th>Pills</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><strong>Appearance</strong></td>
                    <td>Rectangular shape</td>
                    <td>Rounded corners</td>
                  </tr>
                  <tr>
                    <td><strong>Usage</strong></td>
                    <td>Ideal for large sections</td>
                    <td>Compact, modern designs</td>
                  </tr>
                  <tr>
                    <td><strong>CSS Class</strong></td>
                    <td><code>nav-tabs</code></td>
                    <td><code>nav-pills</code></td>
                  </tr>
                </tbody>
              </table>

              <br />

              <h2>Customization</h2>
              <p>
                You can style Tabs or Pills using utility classes like <code>bg-primary</code>, <code>text-white</code>, or <code>border</code>. Example:
              </p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<a class="nav-link bg-primary text-white" href="#home">Home</a>`}
                </code>
              </pre>

              <br />

              <h2>Programmatic Activation</h2>
              <p>
                You can activate Tabs or Pills dynamically using JavaScript:
              </p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`var myTab = new bootstrap.Tab(document.getElementById('profile-tab'));
myTab.show(); // Activates the Profile tab`}
                </code>
              </pre>

              <br />

              <h2>Conclusion</h2>
              <p>
                Tabs and Pills enhance navigation in web applications by allowing users to view multiple sections seamlessly. While <strong>Tabs</strong> are more structured and widely used for organizing large content areas, <strong>Pills</strong> provide a sleek and compact alternative for modern designs.
              </p>
            </div>
          )}


          {selectedChapter === 'chapter23' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Navbar</h1>
              <p>A <strong>navbar</strong> in Bootstrap is a responsive, flexible navigation component for websites, often displayed at the top.</p><br />

              <h3>Basic Navbar</h3>
              <p>Example of a simple, responsive navbar:</p>
                 <pre className={style.codeoverflow}>
                <code>{`
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
          <a class="navbar-brand" href="#">MyBrand</a>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav">
              <li class="nav-item active"><a class="nav-link" href="#">Home</a></li>
              <li class="nav-item"><a class="nav-link" href="#">About</a></li>
              <li class="nav-item"><a class="nav-link" href="#">Services</a></li>
              <li class="nav-item"><a class="nav-link" href="#">Contact</a></li>
            </ul>
          </div>
        </nav>
      `}</code>
              </pre>

              <h4>Explanation:</h4>
              <ul>
                <li><strong>navbar</strong>: Base class for the navbar.</li><br />
                <li><strong>navbar-expand-lg</strong>: Makes the navbar responsive (collapses on small screens).</li><br />
                <li><strong>navbar-light bg-light</strong>: Light color scheme with a light background.</li><br />
                <li><strong>navbar-toggler</strong>: Button to toggle the navbar on small screens.</li><br />
                <li><strong>navbar-toggler-icon</strong>: The hamburger icon for toggling.</li><br />
                <li><strong>collapse navbar-collapse</strong>: Collapses the navbar on smaller screens.</li><br />
                <li><strong>navbar-nav</strong>: The list of navigation items.</li><br />
                <li><strong>nav-item</strong>: Individual navigation items.</li><br />
                <li><strong>nav-link</strong>: Styles the links inside the navbar.</li><br />
                <li><strong>active</strong>: Highlights the current page link.</li>
              </ul><br />

              <h3>Navbar with Dropdown</h3>
              <p>Bootstrap supports dropdowns in the navbar:</p>
                 <pre className={style.codeoverflow}>
                <code>{`
        <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
          <a class="navbar-brand" href="#">MyBrand</a>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav">
              <li class="nav-item active"><a class="nav-link" href="#">Home</a></li>
              <li class="nav-item"><a class="nav-link" href="#">About</a></li>
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" data-bs-toggle="dropdown">Services</a>
                <ul class="dropdown-menu">
                  <li><a class="dropdown-item" href="#">Web Development</a></li>
                  <li><a class="dropdown-item" href="#">App Development</a></li>
                  <li><a class="dropdown-item" href="#">SEO</a></li>
                </ul>
              </li>
              <li class="nav-item"><a class="nav-link" href="#">Contact</a></li>
            </ul>
          </div>
        </nav>
      `}</code>
              </pre>

              <h4>Explanation for Dropdown:</h4>
              <ul>
                <li><strong>nav-item dropdown</strong>: Marks a dropdown item.</li><br />
                <li><strong>dropdown-toggle</strong>: Indicates a toggleable dropdown.</li><br />
                <li><strong>dropdown-menu</strong>: The dropdown menu.</li><br />
                <li><strong>dropdown-item</strong>: Individual items inside the dropdown.</li><br />
                <li><strong>aria-expanded="false"</strong>: Initial collapsed state.</li><br />
                <li><strong>data-bs-toggle="dropdown"</strong>: Bootstrap's JS to toggle dropdown.</li>
              </ul><br />

              <h3>Navbar with Right-Aligned Links</h3>
              <p>Align navbar links to the right using <code>ms-auto</code>:</p>
                 <pre className={style.codeoverflow}>
                <code>{`
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
          <a class="navbar-brand" href="#">MyBrand</a>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav ms-auto">
              <li class="nav-item active"><a class="nav-link" href="#">Home</a></li>
              <li class="nav-item"><a class="nav-link" href="#">About</a></li>
              <li class="nav-item"><a class="nav-link" href="#">Services</a></li>
              <li class="nav-item"><a class="nav-link" href="#">Contact</a></li>
            </ul>
          </div>
        </nav>
      `}</code>
              </pre>
              <h4>Explanation:</h4>
              <ul>
                <li><strong>ms-auto</strong>: Aligns navbar items to the right.</li>
              </ul><br />

              <h3>Customizing Navbar</h3>
              <p>Customize the navbar using utility classes:</p>
                 <pre className={style.codeoverflow}>
                <code>{`
        <nav class="navbar navbar-expand-lg navbar-dark bg-primary">
          <a class="navbar-brand" href="#">MyBrand</a>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav ms-auto">
              <li class="nav-item active"><a class="nav-link" href="#">Home</a></li>
              <li class="nav-item"><a class="nav-link" href="#">About</a></li>
              <li class="nav-item"><a class="nav-link" href="#">Services</a></li>
              <li class="nav-item"><a class="nav-link" href="#">Contact</a></li>
            </ul>
          </div>
        </nav>
      `}</code>
              </pre>

              <h4>Explanation:</h4>
              <ul>
                <li><strong>navbar-dark</strong>: Light link colors for dark backgrounds.</li><br />
                <li><strong>bg-primary</strong>: Primary background color (can use other colors like <code>bg-success</code>).</li>
              </ul><br />

              <h3>Conclusion</h3>
              <p>Bootstrap’s navbar is a flexible way to create responsive, customizable navigation bars for websites.</p>
            </div>
          )}


          {selectedChapter === 'chapter24' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Forms</h1>

              <p style={{ paddingBottom: "6px" }}>
                In Bootstrap, forms are styled and laid out with a variety of built-in classes that make creating responsive, attractive, and functional forms easier. Below is an overview of how forms are managed in Bootstrap:
              </p>

              <h3>1. Basic Structure</h3>
              <p>
                To create a basic form, Bootstrap uses the following syntax:
              </p>

                 <pre className={style.codeoverflow}>
                <code>{`
<form>
  <div class="mb-3">
    <label for="exampleInputEmail1" class="form-label">Email address</label>
    <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp">
    <div id="emailHelp" class="form-text">We'll never share your email with anyone else.</div>
  </div>
  <div class="mb-3">
    <label for="exampleInputPassword1" class="form-label">Password</label>
    <input type="password" class="form-control" id="exampleInputPassword1">
  </div>
  <div class="mb-3 form-check">
    <input type="checkbox" class="form-check-input" id="exampleCheck1">
    <label class="form-check-label" for="exampleCheck1">Check me out</label>
  </div>
  <button type="submit" class="btn btn-primary">Submit</button>
</form>
      `}</code>
              </pre>

              <ul>
                <li><code>form-control</code>: Adds styles to form inputs like <code>&lt;input&gt;</code>, <code>&lt;textarea&gt;</code>, and <code>&lt;select&gt;</code>.</li><br />
                <li><code>form-label</code>: Adds styles to the <code>&lt;label&gt;</code> element.</li><br />
                <li><code>form-text</code>: Adds help text below an input field.</li><br />
                <li><code>form-check</code>: Adds styling for checkboxes and radios.</li><br />
                <li><code>btn btn-primary</code>: Adds Bootstrap's primary button styling.</li>
              </ul><br />

              <h3>2. Form Layouts</h3>

              <h4>Inline Form</h4>
              <p>To display form elements inline, use <code>.form-inline</code> or <code>.row</code> with <code>.col</code> for grid-based layout:</p>

                 <pre className={style.codeoverflow}>
                <code>{`
<form class="row g-3">
  <div class="col-auto">
    <label for="inputEmail2" class="visually-hidden">Email</label>
    <input type="email" class="form-control" id="inputEmail2" placeholder="Enter email">
  </div>
  <div class="col-auto">
    <label for="inputPassword2" class="visually-hidden">Password</label>
    <input type="password" class="form-control" id="inputPassword2" placeholder="Password">
  </div>
  <div class="col-auto">
    <button type="submit" class="btn btn-primary mb-3">Submit</button>
  </div>
</form>
      `}</code>
              </pre><br />

              <h4>Horizontal Form</h4>
              <p>For horizontal forms (labels and inputs side by side on larger screens), use the grid system:</p>

                 <pre className={style.codeoverflow}>
                <code>{`
<form>
  <div class="row mb-3">
    <label for="inputEmail3" class="col-sm-2 col-form-label">Email</label>
    <div class="col-sm-10">
      <input type="email" class="form-control" id="inputEmail3">
    </div>
  </div>
  <div class="row mb-3">
    <label for="inputPassword3" class="col-sm-2 col-form-label">Password</label>
    <div class="col-sm-10">
      <input type="password" class="form-control" id="inputPassword3">
    </div>
  </div>
  <fieldset class="row mb-3">
    <legend class="col-form-label col-sm-2 pt-0">Radios</legend>
    <div class="col-sm-10">
      <div class="form-check">
        <input class="form-check-input" type="radio" name="gridRadios" id="gridRadios1" value="option1" checked>
        <label class="form-check-label" for="gridRadios1">Option 1</label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio" name="gridRadios" id="gridRadios2" value="option2">
        <label class="form-check-label" for="gridRadios2">Option 2</label>
      </div>
    </div>
  </fieldset>
  <button type="submit" class="btn btn-primary">Submit</button>
</form>
      `}</code>
              </pre>

              <ul>
                <li><code>row</code> and <code>col-sm-*</code>: Utilizes Bootstrap’s grid system to align labels and form controls side-by-side.</li>
              </ul><br />

              <h3>3. Validation Styles</h3>
              <p>Bootstrap provides styles for form validation feedback. For example:</p>

                 <pre className={style.codeoverflow}>
                <code>{`
<form class="needs-validation" novalidate>
  <div class="mb-3">
    <label for="validationCustom01" class="form-label">First name</label>
    <input type="text" class="form-control is-valid" id="validationCustom01" value="Mark" required>
    <div class="valid-feedback">Looks good!</div>
  </div>
  <div class="mb-3">
    <label for="validationCustom02" class="form-label">Last name</label>
    <input type="text" class="form-control is-invalid" id="validationCustom02" value="Otto" required>
    <div class="invalid-feedback">Please provide a valid name.</div>
  </div>
  <button class="btn btn-primary" type="submit">Submit</button>
</form>
      `}</code>
              </pre>

              <ul>
                <li><code>.is-valid</code> and <code>.is-invalid</code>: Used to indicate valid or invalid inputs.</li><br />
                <li><code>.valid-feedback</code> and <code>.invalid-feedback</code>: Used to display validation messages.</li>
              </ul><br />

              <h3>4. Custom Form Controls</h3>
              <p>Bootstrap also supports custom styles for select, checkbox, radio, range, and file inputs:</p>

                 <pre className={style.codeoverflow}>
                <code>{`
<div class="mb-3">
  <label for="customRange1" class="form-label">Range</label>
  <input type="range" class="form-range" id="customRange1">
</div>

<div class="mb-3">
  <label for="formFile" class="form-label">Default file input example</label>
  <input class="form-control" type="file" id="formFile">
</div>
      `}</code>
              </pre>

              <ul>
                <li><code>form-range</code>: Styles range inputs.</li><br />
                <li><code>form-control</code>: Styles file inputs.</li>
              </ul><br />

              <h3>5. Form Groups</h3>
              <p>To group form elements, use <code>.mb-3</code> or any other margin class:</p>

                 <pre className={style.codeoverflow}>
                <code>{`
<div class="mb-3">
  <label for="exampleInputPassword1" class="form-label">Password</label>
  <input type="password" class="form-control" id="exampleInputPassword1">
</div>
      `}</code>
              </pre><br />

              <h3>6. Disabled and Read-only Inputs</h3>
                 <pre className={style.codeoverflow}>
                <code>{`
<input class="form-control" type="text" value="Readonly input here..." aria-label="readonly input example" readonly>
<input class="form-control" type="text" value="Disabled input" aria-label="Disabled input example" disabled>
      `}</code>
              </pre><br />

              <h3>7. Form Sizing</h3>
              <p>You can control the size of input fields using <code>.form-control-lg</code> for large inputs and <code>.form-control-sm</code> for small inputs:</p>

                 <pre className={style.codeoverflow}>
                <code>{`
<input class="form-control form-control-lg" type="text" placeholder="Large input">
<input class="form-control form-control-sm" type="text" placeholder="Small input">
      `}</code>
              </pre><br />

              <p>
                These are the basic structures and features you can use to create and style forms in Bootstrap. You can easily expand this by using Bootstrap’s grid system for responsive layouts and advanced form controls.
              </p>
            </div>
          )}


          {selectedChapter === 'chapter25' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Inputs</h1>

              <p>
                Bootstrap provides a wide variety of classes and styles to customize the appearance and behavior of form inputs. Here's an overview of the different types of inputs and how to style them in Bootstrap.
              </p><br />

              <h3>1. Text Inputs</h3>
              <p>
                For text-based inputs like <code>text</code>, <code>email</code>, <code>password</code>, etc., use the <code>.form-control</code> class. This adds padding, a border, and rounded corners by default.
              </p>
                 <pre className={style.codeoverflow}>
                <code>{`<div class="mb-3">
  <label for="inputText" class="form-label">Text input</label>
  <input type="text" class="form-control" id="inputText" placeholder="Enter text">
</div>`}</code>
              </pre>
              <ul>
                <li><code>.form-control</code>: Styles the input with padding, width, and border.</li><br />
                <li><code>.form-label</code>: Adds styles to the label for the input.</li>
              </ul><br />

              <h3>2. Email and Password Inputs</h3>
              <p>
                Bootstrap can style email and password fields the same way as regular text inputs, but with specific types for better browser handling:
              </p>
                 <pre className={style.codeoverflow}>
                <code>{`<div class="mb-3">
  <label for="inputEmail" class="form-label">Email address</label>
  <input type="email" class="form-control" id="inputEmail" placeholder="name@example.com">
</div>

<div class="mb-3">
  <label for="inputPassword" class="form-label">Password</label>
  <input type="password" class="form-control" id="inputPassword">
</div>`}</code>
              </pre><br />

              <h3>3. Disabled and Read-only Inputs</h3>
              <p>
                To disable an input or make it read-only, you can use the <code>disabled</code> and <code>readonly</code> attributes respectively:
              </p>
                 <pre className={style.codeoverflow}>
                <code>{`<div class="mb-3">
  <label for="disabledTextInput" class="form-label">Disabled input</label>
  <input type="text" id="disabledTextInput" class="form-control" placeholder="Disabled input" disabled>
</div>

<div class="mb-3">
  <label for="readonlyTextInput" class="form-label">Read-only input</label>
  <input type="text" id="readonlyTextInput" class="form-control" value="Read-only input" readonly>
</div>`}</code>
              </pre><br />

              <h3>4. Checkboxes and Radios</h3>
              <p>For checkboxes and radio buttons, Bootstrap provides the <code>.form-check</code> class for easier styling:</p>
                 <pre className={style.codeoverflow}>
                <code>{`<div class="form-check">
  <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
  <label class="form-check-label" for="flexCheckDefault">
    Default checkbox
  </label>
</div>

<div class="form-check">
  <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="option1" checked>
  <label class="form-check-label" for="exampleRadios1">
    Default radio
  </label>
</div>`}</code>
              </pre><br />

              <h3>5. Select Menus</h3>
              <p>
                You can create dropdowns or select menus using the <code>&lt;select&gt;</code> tag and style them with <code>.form-select</code>:
              </p>
                 <pre className={style.codeoverflow}>
                <code>{`<div class="mb-3">
  <label for="exampleSelect" class="form-label">Select menu</label>
  <select class="form-select" id="exampleSelect">
    <option selected>Open this select menu</option>
    <option value="1">One</option>
    <option value="2">Two</option>
    <option value="3">Three</option>
  </select>
</div>`}</code>
              </pre><br />

              <h3>6. File Inputs</h3>
              <p>Bootstrap provides custom file inputs with <code>.form-control</code> and <code>.form-file</code> classes:</p>
                 <pre className={style.codeoverflow}>
                <code>{`<div class="mb-3">
  <label for="formFile" class="form-label">Default file input</label>
  <input class="form-control" type="file" id="formFile">
</div>`}</code>
              </pre><br />

              <h3>7. Range Inputs</h3>
              <p>For sliders and range inputs, Bootstrap offers a simple <code>.form-range</code> class:</p>
                 <pre className={style.codeoverflow}>
                <code>{`<div class="mb-3">
  <label for="customRange1" class="form-label">Example range input</label>
  <input type="range" class="form-range" id="customRange1">
</div>`}</code>
              </pre><br />

              <h3>8. Input Sizing</h3>
              <p>
                You can control the size of inputs using <code>.form-control-lg</code> and <code>.form-control-sm</code> for larger or smaller input fields:
              </p>
                 <pre className={style.codeoverflow}>
                <code>{`<input class="form-control form-control-lg" type="text" placeholder="Large input">
<input class="form-control form-control-sm" type="text" placeholder="Small input">`}</code>
              </pre><br />

              <h3>9. Validation States</h3>
              <p>
                Bootstrap provides validation styles like <code>.is-valid</code> and <code>.is-invalid</code> to indicate the input's state and <code>.valid-feedback</code> or <code>.invalid-feedback</code> for error messages:
              </p>
                 <pre className={style.codeoverflow}>
                <code>{`<div class="mb-3">
  <label for="validationCustom01" class="form-label">First name</label>
  <input type="text" class="form-control is-valid" id="validationCustom01" required>
  <div class="valid-feedback">Looks good!</div>
</div>

<div class="mb-3">
  <label for="validationCustom02" class="form-label">Last name</label>
  <input type="text" class="form-control is-invalid" id="validationCustom02" required>
  <div class="invalid-feedback">Please provide a valid name.</div>
</div>`}</code>
              </pre><br />

              <h3>Summary</h3>
              <p>
                These are the core input components in Bootstrap for styling forms. You can use combinations of <code>.form-control</code>, <code>.form-check</code>, <code>.form-range</code>, and validation classes to create fully responsive and interactive forms.
              </p>
            </div>
          )}


          {selectedChapter === 'chapter26' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Input 2</h1>

              <p>
                In Bootstrap, input fields for <strong>email</strong> and <strong>password</strong> are styled the same way as regular text inputs, but the input types are set to <code>email</code> and <code>password</code> for improved browser validation and handling. These fields use the <code>.form-control</code> class, which provides consistent styling across form elements.
              </p><br />

              <p>Here's an example of how to use <strong>Email</strong> and <strong>Password</strong> inputs in Bootstrap:</p>

              <h3>Email Input</h3>
              <p>
                The email input field ensures that the entered text follows the email format (e.g., <code>username@domain.com</code>). Bootstrap applies its standard <code>.form-control</code> styles, and the browser performs basic validation.
              </p>

                 <pre className={style.codeoverflow}>
                <code>{`<div class="mb-3">
  <label for="inputEmail" class="form-label">Email address</label>
  <input type="email" class="form-control" id="inputEmail" placeholder="name@example.com">
</div>`}
                </code>
              </pre><br />

              <h3>Password Input</h3>
              <p>
                The password input hides the characters as they are typed. Bootstrap uses <code>.form-control</code> for consistent styling:
              </p>

                 <pre className={style.codeoverflow}>
                <code>{`<div class="mb-3">
  <label for="inputPassword" class="form-label">Password</label>
  <input type="password" class="form-control" id="inputPassword" placeholder="Enter password">
</div>`}
                </code>
              </pre><br />

              <h3 style={{ paddingBottom: "6px" }}>Summary:</h3>
              <ul>
                <li>
                  <strong>Email Input</strong>: Styled using <code>.form-control</code> and has the type set to <code>email</code> for validation.
                </li><br />
                <li>
                  <strong>Password Input</strong>: Styled similarly, but with the type set to <code>password</code> for hidden text.
                </li>
              </ul><br />

              <p>
                Both fields ensure a clean, consistent appearance with Bootstrap's form styling while leveraging browser-side validation for email formats and hidden password entries.
              </p>
            </div>
          )}

          {selectedChapter === 'chapter27' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Input Sizing</h1>

              <p>In Bootstrap, you can adjust input field sizes with classes like <code>.form-control-lg</code>, <code>.form-control-sm</code>, and the default <code>.form-control</code>.</p><br />

              <h3>1. Large Input</h3>
              <p>Use <code>.form-control-lg</code> for larger input fields.</p>
                 <pre className={style.codeoverflow}><code>{`<input type="text" class="form-control form-control-lg" />`}</code></pre><br />

              <h3>2. Small Input</h3>
              <p>Use <code>.form-control-sm</code> for smaller input fields.</p>
                 <pre className={style.codeoverflow}><code>{`<input type="text" class="form-control form-control-sm" />`}</code></pre><br />

              <h3>3. Default Input</h3>
              <p>Without size classes, the input defaults to the standard size using <code>.form-control</code>.</p>
                 <pre className={style.codeoverflow}><code>{`<input type="text" class="form-control" />`}</code></pre><br />

              <h3>4. Input Groups</h3>
              <p>For input groups, use <code>.input-group-lg</code> or <code>.input-group-sm</code> for size adjustments.</p>
                 <pre className={style.codeoverflow}><code>{`<div class="input-group input-group-lg">... </div>`}</code></pre><br />

              <h3 style={{ paddingBottom: "6px" }}>Summary</h3>
              <ul>
                <li>Use <code>.form-control-lg</code> for large inputs.</li><br />
                <li>Use <code>.form-control-sm</code> for small inputs.</li><br />
                <li>The default size is <code>.form-control</code>.</li><br />
                <li>Adjust input group sizes with <code>.input-group-lg</code> and <code>.input-group-sm</code>.</li>
              </ul><br />
            </div>
          )}


          {selectedChapter === 'chapter28' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Media Objects</h1>

              <p>
                In Bootstrap, <strong>media objects</strong> are used to create responsive, flexible layouts for displaying media
                (images, videos, audio, etc.) alongside content like text. This is typically used to display an image or icon next
                to a block of content (such as text or links), and the layout adjusts as the screen size changes.
              </p><br />

              <p style={{ paddingBottom: "6px" }}>
                The basic structure of a media object consists of a container element (`.media`), an image or media element, and
                the content itself. Here's a breakdown of how to use media objects in Bootstrap:
              </p>

              <h3>Basic Example:</h3>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="media">
  <img src="image.jpg" class="mr-3" alt="Media image" style="width: 64px; height: 64px;">
  <div class="media-body">
    <h5 class="mt-0">Media Heading</h5>
    This is some content related to the media. You can add text, links, or other elements here.
  </div>
</div>`}
                </code>
              </pre>

              <h4 style={{ paddingBottom: "6px" }}>Explanation:</h4>
              <ul>
                <li><strong>.media</strong>: The container element that wraps the image and content.</li><br />
                <li><strong>.mr-3</strong>: This is a Bootstrap spacing class that adds margin to the right of the image (gives a margin of 1rem).</li><br />
                <li><strong>.media-body</strong>: The container for the content of the media object (text, links, etc.).</li><br />
                <li><strong>&lt;h5 class="mt-0"&gt;</strong>: A heading inside the content. The class <code>mt-0</code> removes the top margin, providing better alignment with the media.</li>
              </ul><br />

              <h3>Advanced Usage with Nested Media Objects:</h3>
              <p>
                You can also nest media objects within other media objects. This is useful when you need to display more complex
                layouts with multiple items.
              </p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="media">
  <img src="image1.jpg" class="mr-3" alt="First media" style="width: 64px; height: 64px;">
  <div class="media-body">
    <h5 class="mt-0">First Media Heading</h5>
    This is some content for the first media item.
    <div class="media mt-3">
      <img src="image2.jpg" class="mr-3" alt="Nested media" style="width: 64px; height: 64px;">
      <div class="media-body">
        <h6 class="mt-0">Nested Media Heading</h6>
        This is some content inside the nested media.
      </div>
    </div>
  </div>
</div>`}
                </code>
              </pre>

              <h4 style={{ paddingBottom: "6px" }}>Explanation:</h4>
              <ul>
                <li>The nested <code>.media</code> inside <code>.media-body</code> creates a hierarchy of media objects.</li><br />
                <li>The <code>mt-3</code> class adds margin-top to the nested media to separate it visually from the parent.</li>
              </ul><br />

              <h3>Customizing Media Objects:</h3>
              <p>
                You can adjust the layout of media objects using additional Bootstrap classes:
              </p>
              <ul>
                <li><strong>Alignment:</strong> Use <code>.align-self-start</code>, <code>.align-self-center</code>, or <code>.align-self-end</code> to control vertical alignment within a flex container.</li><br />
                <li><strong>Text Wrapping:</strong> Use <code>.text-wrap</code> or <code>.text-nowrap</code> for wrapping or preventing text from wrapping.</li><br />
                <li><strong>Responsive Images:</strong> Add <code>.img-fluid</code> class to images to make them responsive.</li>
              </ul>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="media">
  <img src="image.jpg" class="mr-3 img-fluid" alt="Responsive media" style="width: 64px; height: 64px;">
  <div class="media-body">
    <h5 class="mt-0">Responsive Media Heading</h5>
    This content is next to a responsive image.
  </div>
</div>`}
                </code>
              </pre><br />

              <h3>Conclusion:</h3>
              <p>
                The media object in Bootstrap is a versatile and powerful way to create flexible layouts for displaying content and
                media side by side, and it’s highly customizable with utility classes to control spacing, alignment, and responsiveness.
              </p>
            </div>
          )}


          {selectedChapter === 'chapter29' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Carousel</h1>

              <p>
                A <strong>Carousel</strong> in Bootstrap is a component that allows you to display a series of images or content in a sliding fashion. It is commonly used for image sliders or to present a collection of items in a rotating manner. Bootstrap’s Carousel component is built with HTML, CSS, and JavaScript, and can be customized with additional options like controls, indicators, and auto-sliding.
              </p><br />

              <h3 style={{ paddingBottom: "6px" }}>Here’s a breakdown of how to create and use a Carousel in Bootstrap:</h3>

              <h4>Basic Example:</h4>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<div id="carouselExample" class="carousel slide" data-bs-ride="carousel">
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img src="image1.jpg" class="d-block w-100" alt="Image 1">
      <div class="carousel-caption d-none d-md-block">
        <h5>First Slide</h5>
        <p>Some description for the first slide.</p>
      </div>
    </div>
    <div class="carousel-item">
      <img src="image2.jpg" class="d-block w-100" alt="Image 2">
      <div class="carousel-caption d-none d-md-block">
        <h5>Second Slide</h5>
        <p>Some description for the second slide.</p>
      </div>
    </div>
    <div class="carousel-item">
      <img src="image3.jpg" class="d-block w-100" alt="Image 3">
      <div class="carousel-caption d-none d-md-block">
        <h5>Third Slide</h5>
        <p>Some description for the third slide.</p>
      </div>
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>`}
                </code>
              </pre>

              <h4 style={{ paddingBottom: "6px" }}>Explanation:</h4>
              <ul>
                <li><strong>&lt;div class="carousel slide"&gt;</strong>: The container for the carousel. The <code>data-bs-ride="carousel"</code> attribute enables automatic cycling of slides.</li><br />
                <li><strong>&lt;div class="carousel-inner"&gt;</strong>: This is the wrapper for the carousel items. Each individual slide goes inside a <code>&lt;div class="carousel-item"&gt;</code>.</li><br />
                <li><strong>&lt;div class="carousel-item active"&gt;</strong>: The active class is applied to the first item to make it visible when the page loads.</li><br />
                <li><strong>&lt;img src="image.jpg"&gt;</strong>: The image for each carousel item. The class <code>d-block</code> ensures the image is displayed as a block-level element, and <code>w-100</code> makes it responsive, adjusting to the width of the container.</li><br />
                <li><strong>&lt;div class="carousel-caption d-none d-md-block"&gt;</strong>: This is where you can add captions or text for each slide. The <code>d-none d-md-block</code> ensures that captions are hidden on smaller screens and only visible on medium or larger devices.</li><br />
                <li><strong>Carousel Controls</strong>: The <code>&lt;button&gt;</code> elements with classes <code>carousel-control-prev</code> and <code>carousel-control-next</code> provide the previous and next buttons to manually navigate through the slides. The icons are used for navigation.</li>
              </ul><br />

              <h4>Adding Indicators:</h4>
              <p>
                You can also add indicators to your carousel to allow users to directly jump to a specific slide. These indicators are typically small circles located at the bottom of the carousel.
              </p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<ol class="carousel-indicators">
  <li data-bs-target="#carouselExample" data-bs-slide-to="0" class="active"></li>
  <li data-bs-target="#carouselExample" data-bs-slide-to="1"></li>
  <li data-bs-target="#carouselExample" data-bs-slide-to="2"></li>
</ol>`}
                </code>
              </pre><br />

              <h4>Customizing Carousel Options:</h4>
              <p>
                You can control the behavior of the carousel using data attributes or JavaScript.
              </p>
              <ul>
                <li><strong>data-bs-ride="carousel"</strong>: Automatically starts the carousel when the page loads.</li><br />
                <li><strong>data-bs-interval="2000"</strong>: Controls how long each slide stays visible (in milliseconds). This can be set in the HTML or through JavaScript.</li><br />
                <li><strong>data-bs-pause="hover"</strong>: Pauses the carousel when the user hovers over the item.</li>
              </ul><br />

              <h5>Example with a custom interval:</h5>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<div id="carouselExample" class="carousel slide" data-bs-ride="carousel" data-bs-interval="3000">`}
                </code>
              </pre><br />

              <h4>Conclusion:</h4>
              <p>
                The Bootstrap Carousel is a flexible and easy-to-use component for creating responsive, sliding media or content sections. With just a few classes and optional attributes, you can create simple or advanced carousels with image captions, controls, and indicators.
              </p>
            </div>
          )}

          {selectedChapter === 'chapter30' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Modal</h1>

              <h3>1. Basic Modal Example</h3>
                 <pre className={style.codeoverflow}><code>{`<!-- Button trigger modal -->
<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
  Launch Modal
</button>

<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        This is a simple modal example in Bootstrap.
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div>
    </div>
  </div>
</div>`}</code></pre>

              <h4 style={{ paddingBottom: "6px" }}>Explanation:</h4>
              <ol>
                <li>
                  <strong>Trigger Button:</strong> The <code>&lt;button&gt;</code> element triggers the modal using <code>data-bs-toggle="modal"</code> to indicate it's a modal trigger and <code>data-bs-target="#exampleModal"</code> to specify which modal to open.
                </li><br />
                <li>
                  <strong>Modal Structure:</strong> The modal is enclosed in <code>&lt;div class="modal fade"&gt;</code>, where <code>fade</code> is a Bootstrap class for animation. Inside the modal, <code>&lt;div class="modal-dialog"&gt;</code> defines the modal's size and positioning.
                </li><br />
                <li>
                  <strong>Modal Header:</strong> Contains the title and a close button. The <code>data-bs-dismiss="modal"</code> attribute closes the modal when clicked.
                </li><br />
                <li>
                  <strong>Modal Body:</strong> This is where you place content like forms, text, or images.
                </li><br />
                <li>
                  <strong>Modal Footer:</strong> Typically contains action buttons like "Close" or "Save changes."
                </li>
              </ol><br />

              <h3>2. Modal with Scrollable Content</h3>
                 <pre className={style.codeoverflow}><code>{`<div class="modal-dialog modal-dialog-scrollable">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Scrollable Modal</h5>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <!-- Long content here -->
      <p>Content...</p>
      <p>Content...</p>
      <p>Content...</p>
      <p>Content...</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      <button type="button" class="btn btn-primary">Save changes</button>
    </div>
  </div>
</div>`}</code></pre><br />

              <h3>3. Modal with Form</h3>
                 <pre className={style.codeoverflow}><code>{`<div class="modal-body">
  <form>
    <div class="mb-3">
      <label for="exampleInputEmail1" class="form-label">Email address</label>
      <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp">
    </div>
    <div class="mb-3">
      <label for="exampleInputPassword1" class="form-label">Password</label>
      <input type="password" class="form-control" id="exampleInputPassword1">
    </div>
    <div class="mb-3 form-check">
      <input type="checkbox" class="form-check-input" id="exampleCheck1">
      <label class="form-check-label" for="exampleCheck1">Check me out</label>
    </div>
  </form>
</div>`}</code></pre><br />

              <h3>4. Customizing Modal Size</h3>
              <ul>
                <li><strong>Small Modal:</strong> <code>&lt;div class="modal-dialog modal-sm"&gt;</code></li><br />
                <li><strong>Large Modal:</strong> <code>&lt;div class="modal-dialog modal-lg"&gt;</code></li><br />
                <li><strong>Fullscreen Modal:</strong> <code>&lt;div class="modal-dialog modal-fullscreen"&gt;</code></li>
              </ul><br />

              <h3>5. Using JavaScript to Control the Modal</h3>
                 <pre className={style.codeoverflow}><code>{`<button type="button" class="btn btn-info" id="openModalButton">Open Modal</button>

<script>
  const openModalButton = document.getElementById('openModalButton');
  const myModal = new bootstrap.Modal(document.getElementById('exampleModal'));

  openModalButton.addEventListener('click', function () {
    myModal.show();
  });
</script>`}</code></pre><br />

              <h3>Conclusion</h3>
              <p>Bootstrap modals are a powerful and flexible way to create interactive dialogs and overlays. They can be customized with options like scrollable content, form elements, and various sizes. You can trigger them with buttons and manage them using both data attributes and JavaScript.</p>
            </div>
          )}


          {selectedChapter === 'chapter31' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Tooltips</h1>
              <p>
                Tooltips in Bootstrap are small, interactive text elements that appear when a user hovers over or focuses on an element. They are often used to provide additional information or context for a particular action or item.
              </p><br />

              <h3>Basic Tooltip Example</h3>
              <p style={{ paddingBottom: "6px" }}>Here is an example of how to implement a tooltip in Bootstrap:</p>

              <h4>1. HTML Structure</h4>
              <p>
                You need to add the <code>data-bs-toggle="tooltip"</code> attribute to an element and specify the tooltip text using the <code>title</code> attribute.
              </p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<!-- Button with Tooltip -->\n<button type="button" class="btn btn-secondary" data-bs-toggle="tooltip" title="Tooltip text here">\n  Hover over me\n</button>`}
                </code>
              </pre><br />

              <h4>2. JavaScript to Enable Tooltip</h4>
              <p>
                Bootstrap requires you to initialize the tooltip using JavaScript. You can do this by targeting the element and calling the <code>Tooltip</code> method.
              </p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<script>\n  // Initialize all tooltips on the page\n  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));\n  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {\n    return new bootstrap.Tooltip(tooltipTriggerEl);\n  });\n</script>`}
                </code>
              </pre><br />

              <h3>Tooltip with Custom Position</h3>
              <p>
                You can control the position of the tooltip by adding the <code>data-bs-placement</code> attribute with values like <code>top</code>, <code>bottom</code>, <code>left</code>, or <code>right</code>.
              </p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<!-- Button with Tooltip positioned at the top -->\n<button type="button" class="btn btn-info" data-bs-toggle="tooltip" title="Tooltip on top" data-bs-placement="top">\n  Hover over me\n</button>`}
                </code>
              </pre><br />

              <h3>Tooltip with Delayed Display</h3>
              <p>
                You can use the <code>data-bs-delay</code> attribute to introduce a delay before the tooltip is shown and when it disappears.
              </p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<!-- Button with Tooltip and delay -->\n<button type="button" class="btn btn-warning" data-bs-toggle="tooltip" title="Tooltip with delay" data-bs-delay="500">\n  Hover over me\n</button>`}
                </code>
              </pre><br />

              <h3>Example with Multiple Tooltips</h3>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<!-- Multiple Tooltips Example -->\n<button type="button" class="btn btn-primary" data-bs-toggle="tooltip" title="Tooltip 1" data-bs-placement="top">\n  Button 1\n</button>\n\n<button type="button" class="btn btn-success" data-bs-toggle="tooltip" title="Tooltip 2" data-bs-placement="right">\n  Button 2\n</button>`}
                </code>
              </pre><br />

              <h3>Full Example with JavaScript and Tooltip Initialization:</h3>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<!DOCTYPE html>\n<html lang="en">\n<head>\n  <meta charset="UTF-8">\n  <meta name="viewport" content="width=device-width, initial-scale=1.0">\n  <title>Bootstrap Tooltip Example</title>\n  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/css/bootstrap.min.css" rel="stylesheet">\n</head>\n<body>\n\n  <!-- Tooltip Example -->\n  <button type="button" class="btn btn-primary" data-bs-toggle="tooltip" title="Tooltip on top" data-bs-placement="top">\n    Hover over me\n  </button>\n\n  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/js/bootstrap.bundle.min.js"></script>\n\n  <script>\n    // Initialize tooltips when the page loads\n    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));\n    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {\n      return new bootstrap.Tooltip(tooltipTriggerEl);\n    });\n  </script>\n\n</body>\n</html>`}
                </code>
              </pre><br />

              <h3 style={{ paddingBottom: "6px" }}>Summary of Tooltip Options:</h3>
              <ul>
                <li><strong>Placement:</strong> <code>top</code>, <code>bottom</code>, <code>left</code>, <code>right</code></li><br />
                <li><strong>Delay:</strong> <code>data-bs-delay="500"</code> (delay in milliseconds)</li><br />
                <li><strong>Trigger:</strong> You can set how the tooltip appears using attributes like <code>data-bs-trigger="click"</code>, <code>data-bs-trigger="focus"</code>, etc.</li>
              </ul><br />

              <h3>Conclusion:</h3>
              <p>
                Tooltips in Bootstrap provide a simple and effective way to display additional information to users. You can easily customize them using attributes like <code>data-bs-placement</code> and <code>data-bs-delay</code>, and initialize them using JavaScript for more control over their behavior.
              </p>
            </div>
          )}

          {selectedChapter === 'chapter32' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Popover</h1>
              <p>
                In Bootstrap, a <strong>Popover</strong> is a component that provides
                additional information or options related to an element when the user
                clicks or hovers over it. Popovers are similar to tooltips but are more
                interactive and can include more complex content.
              </p><br />

              <h2 style={{ paddingBottom: "6px" }}>Features of Popover</h2>
              <ul>
                <li>Popovers require the Bootstrap JavaScript and Popper.js library.</li><br />
                <li>They can display HTML content, text, forms, and even interactive elements.</li><br />
                <li>Popovers are customizable in terms of position, content, and triggers.</li>
              </ul>

              <br />

              <h2 style={{ paddingBottom: "6px" }}>How to Use Popovers in Bootstrap</h2>

              <h3>1. Include Necessary Libraries</h3>
              <p>
                Make sure you include the Bootstrap CSS and JS files, along with the Popper.js library:
              </p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<!-- Bootstrap CSS -->
<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/css/bootstrap.min.css">

<!-- Popper.js and Bootstrap JS -->
<script src="https://cdn.jsdelivr.net/npm/@popperjs/core@2.11.6/dist/umd/popper.min.js"></script>
<script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/js/bootstrap.bundle.min.js"></script>`}
                </code>
              </pre><br />

              <h3>2. Basic Example</h3>
              <p>Here’s how to add a simple popover:</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<!-- Popover Trigger Button -->
<button type="button" class="btn btn-primary" data-bs-toggle="popover" 
        data-bs-content="This is a popover!" 
        title="Popover Title">
  Click me
</button>

<script>
  // Initialize all popovers on the page
  document.addEventListener('DOMContentLoaded', function () {
    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
    popoverTriggerList.forEach(popoverTriggerEl => {
      new bootstrap.Popover(popoverTriggerEl);
    });
  });
</script>`}
                </code>
              </pre><br />

              <h3>3. Options</h3>
              <p>Bootstrap allows several options for customization:</p>
              <table>
                <thead>
                  <tr>
                    <th>Option</th>
                    <th>Description</th>
                    <th>Values</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><code>placement</code></td>
                    <td>Sets the position of the popover.</td>
                    <td><code>top</code>, <code>bottom</code>, <code>left</code>, <code>right</code>, <code>auto</code></td>
                  </tr>
                  <tr>
                    <td><code>trigger</code></td>
                    <td>Determines how the popover is triggered.</td>
                    <td><code>click</code>, <code>hover</code>, <code>focus</code>, <code>manual</code></td>
                  </tr>
                  <tr>
                    <td><code>html</code></td>
                    <td>Allows rendering of HTML content.</td>
                    <td><code>true</code>, <code>false</code></td>
                  </tr>
                  <tr>
                    <td><code>content</code></td>
                    <td>Sets the content of the popover.</td>
                    <td>String or Function</td>
                  </tr>
                </tbody>
              </table><br />

              <h3>4. Custom Initialization with JavaScript</h3>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<button id="myPopover" class="btn btn-success">Manual Popover</button>

<script>
  const popover = new bootstrap.Popover(document.getElementById('myPopover'), {
    title: 'Custom Title',
    content: 'Custom content inside the popover!',
    trigger: 'click',
    placement: 'top'
  });
</script>`}
                </code>
              </pre><br />

              <h3>5. Methods</h3>
              <p>Bootstrap provides methods for interacting with popovers:</p>
              <table>
                <thead>
                  <tr>
                    <th>Method</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><code>toggle()</code></td>
                    <td>Toggles the popover visibility.</td>
                  </tr>
                  <tr>
                    <td><code>show()</code></td>
                    <td>Shows the popover.</td>
                  </tr>
                  <tr>
                    <td><code>hide()</code></td>
                    <td>Hides the popover.</td>
                  </tr>
                  <tr>
                    <td><code>dispose()</code></td>
                    <td>Destroys the popover instance.</td>
                  </tr>
                  <tr>
                    <td><code>enable()</code> / <code>disable()</code></td>
                    <td>Enables or disables the popover trigger.</td>
                  </tr>
                </tbody>
              </table><br />

              <h3>Styling and Accessibility</h3>
              <p>
                - Use CSS classes to style your popovers.<br />
                - Ensure the content in the popover is accessible by using appropriate ARIA attributes like <code>aria-describedby</code> and <code>aria-labelledby</code>.
              </p>
              <p>Bootstrap popovers are a powerful tool to create dynamic, interactive UI elements!</p>
            </div>
          )}



          {selectedChapter === 'chapter33' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Scrollspy</h1>

              <p>
                Scrollspy in Bootstrap allows you to automatically update the navigation items based on the section currently visible on the page. It is particularly helpful for single-page websites or long content pages where users need to navigate quickly between different sections.
              </p><br />

              <h2>1. Basic Example of Scrollspy</h2>
              <p>
                In the example below, as the user scrolls through the page, the navigation links will automatically highlight the corresponding section.
              </p>

                 <pre className={style.codeoverflow}><code>{`
<!-- Navigation bar -->
<nav id="navbar-example2" class="navbar navbar-light bg-light">
  <a class="navbar-brand" href="#">Navbar</a>
  <ul class="nav nav-pills">
    <li class="nav-item">
      <a class="nav-link" href="#section1">Section 1</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" href="#section2">Section 2</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" href="#section3">Section 3</a>
    </li>
  </ul>
</nav>

<!-- Sections -->
<div data-bs-spy="scroll" data-bs-target="#navbar-example2" class="scrollspy-example" tabindex="0">
  <h4 id="section1">Section 1</h4>
  <p>Content for section 1.</p>
  <h4 id="section2">Section 2</h4>
  <p>Content for section 2.</p>
  <h4 id="section3">Section 3</h4>
  <p>Content for section 3.</p>
</div>
    `}</code></pre><br />

              <h2>2. JavaScript to Initialize Scrollspy</h2>
              <p>
                To initialize Scrollspy, you need to add JavaScript to enable it. Bootstrap uses the data attribute `data-bs-spy="scroll"` to activate Scrollspy.
              </p>

                 <pre className={style.codeoverflow}><code>{`
<script>
// Initialize Scrollspy
document.body.setAttribute('data-bs-spy', 'scroll');
document.body.setAttribute('data-bs-target', '#navbar-example2');
document.body.classList.add('scrollspy-example');
</script>
    `}</code></pre><br />

              <h2>3. Scrollspy Options</h2>
              <p>
                You can customize Scrollspy further using attributes like:
                <ul>
                  <li><code>data-bs-target</code>: The target navigation (usually a navbar or sidebar).</li>
                  <li><code>data-bs-offset</code>: A value to adjust the offset for Scrollspy (in pixels). Useful for fixed or sticky headers.</li>
                  <li><code>data-bs-spy="scroll"</code>: Activates Scrollspy on the specified container.</li>
                </ul>
              </p>

                 <pre className={style.codeoverflow}><code>{`<div data-bs-spy="scroll" data-bs-target="#navbar-example2" data-bs-offset="50" class="scrollspy-example" tabindex="0">`}</code></pre><br />

              <h2>4. Styling Scrollspy</h2>
              <p>
                Scrollspy is highly customizable, and you can adjust the styles of the navigation items to reflect the active section. The default behavior highlights the active section in the navigation, but you can style this further by applying custom classes.
              </p>

                 <pre className={style.codeoverflow}><code>{`
<style>
  .nav-link.active {
    background-color: #007bff;
    color: white;
  }
</style>
    `}</code></pre><br />

              <h2>Conclusion</h2>
              <p>
                Scrollspy is an excellent feature to enhance user experience, especially for long content pages. By automatically updating the navigation links as the user scrolls, it makes it easier for users to know their location on the page and jump to different sections quickly.
              </p>
            </div>
          )}

          {selectedChapter === 'chapter34' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Affix</h1>

              <p>
                In Bootstrap, the <strong>Affix</strong> component was used to make elements "stick" to a specific position on the screen when scrolling. This functionality was often used for side navigation or sticky headers, keeping elements visible as the user scrolled.
              </p><br />

              <h3 style={{ paddingBottom: "6px" }}>Key Points:</h3>
              <ul>
                <li><strong>Affix in Bootstrap 3:</strong> Used JavaScript to fix an element's position.</li><br />
                <li><strong>Bootstrap 4 and 5:</strong> Replaced with native CSS `position: sticky;`, which is faster and doesn't require JavaScript.</li>
              </ul><br />

              <h3>Example of Sticky Sidebar using CSS:</h3>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="sticky-sidebar">
  <h4>Sticky Sidebar</h4>
  <p>This sidebar stays visible as you scroll.</p>
</div>

<style>
  .sticky-sidebar {
    position: sticky;
    top: 0; /* Sticks at the top of the viewport */
    height: 100vh; /* Full viewport height */
  }
</style>`}
                </code>
              </pre><br />

              <h3 style={{ paddingBottom: "6px" }}>When to Use:</h3>
              <ul>
                <li><strong>Sticky Navigation Menus:</strong> Keep side menus visible.</li><br />
                <li><strong>Sidebars:</strong> For additional info or quick links.</li><br />
                <li><strong>CTAs:</strong> To make call-to-action buttons always visible.</li>
              </ul><br />

              <h3 style={{ paddingBottom: "6px" }}>Advantages of `position: sticky;`:</h3>
              <ul>
                <li><strong>No JavaScript:</strong> Simplifies implementation.</li><br />
                <li><strong>Better Performance:</strong> Native browser support is more efficient.</li><br />
                <li><strong>Cross-browser Support:</strong> Supported by modern browsers.</li>
              </ul><br />

              <p>
                In conclusion, for newer versions of Bootstrap (4 and 5), using <code>position: sticky</code> is the recommended approach for achieving affix-like behavior.
              </p>
            </div>
          )}

          {selectedChapter === 'chapter35' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Filters </h1>

              <p>
                In Bootstrap, filters are typically used to modify the appearance of elements dynamically, usually for images, text, and other visual elements. Filters in the context of Bootstrap are commonly applied through CSS, leveraging the `filter` property. You can also use Bootstrap’s utilities for adding filters to images, backgrounds, and other content. However, as of Bootstrap 5, filters are not a specific Bootstrap component but are instead implemented using CSS.
              </p><br />

              <h2>1. Using CSS Filters</h2>

              <p style={{ paddingBottom: "6px" }}>
                CSS provides a `filter` property that can apply various graphical effects to elements, such as blur, brightness, contrast, grayscale, hue rotation, invert, opacity, sepia, etc.
              </p>

              <h3>Example of applying a CSS filter to an image:</h3>

                 <pre className={style.codeoverflow}>
                <code>{`
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Bootstrap Filters Example</title>
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/css/bootstrap.min.css" rel="stylesheet">
  <style>
    .filtered-image {
      filter: grayscale(50%) contrast(120%) blur(2px); /* Apply grayscale, contrast, and blur */
    }
  </style>
</head>
<body>

  <div class="container my-5">
    <div class="row">
      <div class="col-md-6">
        <h2>Image with Filter</h2>
        <img src="https://via.placeholder.com/500" alt="Sample Image" class="img-fluid filtered-image">
      </div>
    </div>
  </div>

  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/js/bootstrap.bundle.min.js"></script>
</body>
</html>
      `}</code>
              </pre><br />

              <h2>2. Common Filter Effects in CSS</h2>

              <p>Here are some of the most common filter effects you can use in CSS:</p>

              <ul>
                <li><strong>Grayscale</strong>: Converts the image to grayscale.
                     <pre className={style.codeoverflow}><code>filter: grayscale(100%);</code></pre>
                </li><br />
                <li><strong>Blur</strong>: Applies a blur effect to the image.
                     <pre className={style.codeoverflow}><code>filter: blur(5px);</code></pre>
                </li><br />
                <li><strong>Brightness</strong>: Adjusts the brightness of the image.
                     <pre className={style.codeoverflow}><code>filter: brightness(1.5);</code></pre>
                </li><br />
                <li><strong>Contrast</strong>: Adjusts the contrast of the image.
                     <pre className={style.codeoverflow}><code>filter: contrast(150%);</code></pre>
                </li><br />
                <li><strong>Sepia</strong>: Adds a sepia tone to the image.
                     <pre className={style.codeoverflow}><code>filter: sepia(100%);</code></pre>
                </li><br />
                <li><strong>Invert</strong>: Inverts the colors of the image.
                     <pre className={style.codeoverflow}><code>filter: invert(100%);</code></pre>
                </li><br />
                <li><strong>Hue Rotation</strong>: Rotates the hues of the image.
                     <pre className={style.codeoverflow}><code>filter: hue-rotate(90deg);</code></pre>
                </li><br />
                <li><strong>Saturate</strong>: Increases or decreases the saturation of the image.
                     <pre className={style.codeoverflow}><code>filter: saturate(200%);</code></pre>
                </li>
              </ul><br />

              <h2>3. Combining Multiple Filters</h2>

              <p>You can combine multiple filter effects by separating them with spaces:</p>

                 <pre className={style.codeoverflow}>
                <code>filter: grayscale(50%) contrast(120%) blur(5px);</code>
              </pre>

              <p>This will apply 50% grayscale, 120% contrast, and 5px blur to the element.</p><br />

              <h2>4. Bootstrap Utility Classes for Filters</h2>

              <p>
                Bootstrap 5 doesn’t provide built-in utility classes for filters, but you can create custom utility classes for applying common filters. For example, you could create a custom utility class for applying a grayscale filter:
              </p>

                 <pre className={style.codeoverflow}>
                <code>{`
<style>
  .filter-grayscale {
    filter: grayscale(100%);
  }
</style>
      `}</code>
              </pre>

              <p>Then, you can use it on any element:</p>

                 <pre className={style.codeoverflow}>
                <code>{`<img src="image.jpg" class="img-fluid filter-grayscale" alt="Grayscale Image">`}</code>
              </pre><br />

              <h2>5. Using Filters in Cards or Other Components</h2>

              <p>
                You can use filters in Bootstrap components such as cards or backgrounds. Here’s an example of applying a filter to the background of a Bootstrap card:
              </p>

                 <pre className={style.codeoverflow}>
                <code>{`
<div class="card" style="width: 18rem;">
  <img src="https://via.placeholder.com/500" class="card-img-top" alt="Card image" style="filter: blur(5px);">
  <div class="card-body">
    <h5 class="card-title">Card with Filtered Background</h5>
    <p class="card-text">This card has a background image with a blur effect applied.</p>
  </div>
</div>
      `}</code>
              </pre><br />

              <h2>6. Using Bootstrap’s `backdrop-filter` (for Backdrop Effects)</h2>

              <p>If you're working with translucent elements, you can use the `backdrop-filter` property to apply filters to the area behind an element. For example:</p>

                 <pre className={style.codeoverflow}>
                <code>{`
<div class="position-relative">
  <img src="https://via.placeholder.com/500" class="img-fluid" alt="Background">
  <div class="position-absolute top-0 start-0 w-100 h-100" style="background-color: rgba(0, 0, 0, 0.5); backdrop-filter: blur(5px);">
    <h2 class="text-white">Text Over Filtered Background</h2>
  </div>
</div>
      `}</code>
              </pre><br />

              <h2 style={{ paddingBottom: "6px" }}>Summary</h2>

              <ul>
                <li><strong>CSS Filters:</strong> Use the `filter` property in CSS to apply graphical effects to elements like images, text, and backgrounds.</li><br />
                <li><strong>Bootstrap Support:</strong> Bootstrap doesn’t have built-in filter utilities, but you can easily use custom CSS or Bootstrap’s utility classes to implement them.</li><br />
                <li><strong>Advanced Filters:</strong> You can combine different filter effects for more complex visual styles and apply them to elements such as images, cards, and more.</li>
              </ul><br />
            </div>
          )}




          {selectedChapter === 'chapter37' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Grid System</h1>



              <p>The <strong>Grid System</strong> in Bootstrap is one of its most powerful features, allowing you to create responsive layouts quickly and efficiently. The grid system is based on a 12-column layout that adjusts based on screen size, ensuring your website looks great on devices of all sizes. It uses a series of <strong>containers</strong>, <strong>rows</strong>, and <strong>columns</strong> to define the layout structure.</p><br />

              <p style={{ paddingBottom: "6px" }}>Here’s a breakdown of how the Bootstrap grid system works:</p>

              <h4>1. Structure of the Grid System</h4>
              <p style={{ paddingBottom: "6px" }}>The grid system in Bootstrap is built using <strong>containers</strong>, <strong>rows</strong>, and <strong>columns</strong>. These elements work together to create responsive layouts.</p>

              <h5>a) Container</h5>
              <p>The container is the outermost wrapper that holds the grid content. There are two types of containers in Bootstrap:</p>
              <ul>
                <li><code>.container</code>: A fixed-width container that adjusts its width based on the viewport size.</li><br />
                <li><code>.container-fluid</code>: A full-width container that spans the entire width of the viewport.</li>
              </ul><br />

              <p>Example:</p>
                 <pre className={style.codeoverflow}>
                <code>{`<div class="container">
  <!-- Content goes here -->
</div>

<div class="container-fluid">
  <!-- Content goes here -->
</div>`}</code>
              </pre><br />

              <h5>b) Row</h5>
              <p>The row is a horizontal wrapper that holds the columns. It ensures that the columns inside it are aligned properly. Rows must be inside a container to ensure the layout is responsive.</p>

              <p>Example:</p>
                 <pre className={style.codeoverflow}>
                <code>{`<div class="row">
  <!-- Columns go here -->
</div>`}</code>
              </pre><br />

              <h5>c) Column</h5>
              <p>Columns are the building blocks of the grid. By default, the grid has 12 columns per row, and each column takes up a portion of the row.</p>
              <p>The class <code>col</code> is used to define the width of a column. You can create columns of equal width by just using the <code>.col</code> class or specify custom column widths using classes like <code>.col-4</code>, <code>.col-6</code>, etc., where the number represents the number of columns the element should span.</p>

              <p>Example:</p>
                 <pre className={style.codeoverflow}>
                <code>{`<div class="col-4">Column 1</div>
<div class="col-4">Column 2</div>
<div class="col-4">Column 3</div>`}</code>
              </pre>
              <p>In this example, each column takes up 4 columns out of the 12 available, resulting in 3 equal-width columns.</p>

              <br />

              <h4>2. Responsive Grid Classes</h4>
              <p>Bootstrap’s grid system is fully responsive, meaning the layout adapts to different screen sizes. The grid system includes several predefined classes for different screen sizes:</p>
              <ul>
                <li><code>{`.col-{breakpoint}-{size}`}</code>: Specifies the width of the column based on the viewport size.</li>
              </ul>
              <p>The breakpoints in Bootstrap are:</p>
              <ul>
                <li><strong>xs</strong> (extra small): Default, used for screens smaller than 576px.</li><br />
                <li><strong>sm</strong> (small): Used for screens larger than or equal to 576px.</li><br />
                <li><strong>md</strong> (medium): Used for screens larger than or equal to 768px.</li><br />
                <li><strong>lg</strong> (large): Used for screens larger than or equal to 992px.</li><br />
                <li><strong>xl</strong> (extra large): Used for screens larger than or equal to 1200px.</li><br />
                <li><strong>xxl</strong> (extra extra large): Used for screens larger than or equal to 1400px.</li>
              </ul><br />

              <p>Example:</p>
                 <pre className={style.codeoverflow}>
                <code>{`<div class="row">
  <div class="col-sm-4 col-md-6 col-lg-3">Column 1</div>
  <div class="col-sm-4 col-md-6 col-lg-3">Column 2</div>
  <div class="col-sm-4 col-md-6 col-lg-3">Column 3</div>
  <div class="col-sm-4 col-md-6 col-lg-3">Column 4</div>
</div>`}</code>
              </pre>
              <p>In this example:
                <ul>
                  <li>On small screens (<strong>sm</strong>), each column will take up 4 columns (one-third of the row).</li><br />
                  <li>On medium screens (<strong>md</strong>), each column will take up 6 columns (one-half of the row).</li><br />
                  <li>On large screens (<strong>lg</strong>), each column will take up 3 columns (one-fourth of the row).</li>
                </ul>
              </p>

              <br />

              <h4 style={{ paddingBottom: "6px" }}>3. Offset and Ordering</h4>
              <h5>a) Offset</h5>
              <p>Offsets move columns to the right by a specific number of columns. For example, <code>.offset-md-4</code> will push the column 4 columns to the right on medium-sized screens and larger.</p>

              <p>Example:</p>
                 <pre className={style.codeoverflow}>
                <code>{`<div class="row">
  <div class="col-md-4">Column 1</div>
  <div class="col-md-4 offset-md-4">Column 2 (offset by 4)</div>
</div>`}</code>
              </pre><br />

              <h5>b) Ordering</h5>
              <p>With <strong>order classes</strong>, you can control the order of columns within a row. By default, columns are displayed in the order they appear in the HTML. However, using classes like <code>.order-md-1</code>, <code>.order-md-2</code>, you can change the order of columns on different screen sizes.</p>

              <p>Example:</p>
                 <pre className={style.codeoverflow}>
                <code>{`<div class="row">
  <div class="col-md-4 order-md-2">Column 1</div>
  <div class="col-md-4 order-md-1">Column 2</div>
  <div class="col-md-4 order-md-3">Column 3</div>
</div>`}</code>
              </pre>

              <br />

              <h4>4. Nesting Columns</h4>
              <p>You can nest columns within columns to create more complex layouts. Nested columns must be inside a <code>row</code> element within a parent column.</p>

              <p>Example:</p>
                 <pre className={style.codeoverflow}>
                <code>{`<div class="row">
  <div class="col-md-6">
    <div class="row">
      <div class="col-md-6">Nested Column 1</div>
      <div class="col-md-6">Nested Column 2</div>
    </div>
  </div>
  <div class="col-md-6">Column 2</div>
</div>`}</code>
              </pre>

              <br />

              <h4>5. Equal-Height Columns</h4>
              <p>By default, columns in Bootstrap will stretch to fit the height of the content inside them. If you want to make all columns in a row the same height (even if they have different content), you can use the <code>d-flex</code> class along with <code>align-items-stretch</code> to ensure they stretch to the same height.</p>

              <p>Example:</p>
                 <pre className={style.codeoverflow}>
                <code>{`<div class="row d-flex align-items-stretch">
  <div class="col-md-4">Column 1</div>
  <div class="col-md-4">Column 2</div>
  <div class="col-md-4">Column 3</div>
</div>`}</code>
              </pre>

              <br />

              <h4 style={{ paddingBottom: "6px" }}>Summary</h4>
              <ul>
                <li>The Bootstrap grid system is based on a 12-column layout, making it easy to create flexible, responsive web pages.</li><br />
                <li>Containers, rows, and columns form the basic structure of a Bootstrap grid layout.</li><br />
                <li>Columns can be customized for different screen sizes using predefined classes for responsiveness.</li><br />
                <li>Bootstrap allows for easy customization through offsets, ordering, and nesting of columns.</li>
              </ul><br />
            </div>
          )}

          {selectedChapter === 'chapter38' && (
            <div className={style.chaptercontent}>
              <h2 className={style.heading}>Stacked/Horizontal</h2>

              <p>In Bootstrap, the <strong>Stacked</strong> and <strong>Horizontal</strong> layouts refer to how the form elements (such as labels, inputs, and buttons) are arranged within a form.</p><br />

              <h3>1. Stacked Layout</h3>
              <p style={{ paddingBottom: "6px" }}>A <strong>stacked layout</strong> is the default form layout where form controls (such as inputs) are stacked vertically on top of each other, with labels placed above the inputs.</p>

              <h4>Example:</h4>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<form>
  <div class="mb-3">
    <label for="username" class="form-label">Username</label>
    <input type="text" class="form-control" id="username" placeholder="Enter your username">
  </div>
  
  <div class="mb-3">
    <label for="password" class="form-label">Password</label>
    <input type="password" class="form-control" id="password" placeholder="Enter your password">
  </div>
  
  <button type="submit" class="btn btn-primary">Submit</button>
</form>`}
                </code>
              </pre>

              <p style={{ paddingBottom: "6px" }}>In this example:</p>
              <ul>
                <li>The labels (<code>&lt;label&gt;</code>) are stacked above their corresponding form controls.</li><br />
                <li>The <code>form-control</code> class is used for the input fields, and the <code>form-label</code> class is used for the labels.</li><br />
                <li>The <code>mb-3</code> class is used to add margin to the bottom of each input to create space between the elements.</li>
              </ul><br />

              <h3>2. Horizontal Layout</h3>
              <p style={{ paddingBottom: "6px" }}>A <strong>horizontal layout</strong> places the labels and form controls side by side, where the labels are aligned to the left, and the form controls are aligned to the right. This is typically used when you want to conserve space on wider screens, such as in forms where there are many fields.</p>

              <h4>Example:</h4>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<form>
  <div class="row mb-3">
    <label for="username" class="col-sm-2 col-form-label">Username</label>
    <div class="col-sm-10">
      <input type="text" class="form-control" id="username" placeholder="Enter your username">
    </div>
  </div>
  
  <div class="row mb-3">
    <label for="password" class="col-sm-2 col-form-label">Password</label>
    <div class="col-sm-10">
      <input type="password" class="form-control" id="password" placeholder="Enter your password">
    </div>
  </div>
  
  <button type="submit" class="btn btn-primary">Submit</button>
</form>`}
                </code>
              </pre>

              <p style={{ paddingBottom: "6px" }}>In this example:</p>
              <ul>
                <li>The <code>row</code> class is used to create a horizontal layout.</li><br />
                <li>The <code>col-sm-2</code> class is used to set the width of the label (typically 2 columns on small screens).</li><br />
                <li>The <code>col-sm-10</code> class is used to set the width of the input field.</li><br />
                <li>The <code>col-form-label</code> class is used to style the labels in the horizontal form.</li>
              </ul><br />

              <h3 style={{ paddingBottom: "6px" }}>Key Differences:</h3>
              <ul>
                <li><strong>Stacked</strong>: Labels and inputs are stacked vertically.</li><br />
                <li><strong>Horizontal</strong>: Labels are aligned to the left, and inputs are aligned to the right within the same row.</li>
              </ul><br />

              <h3>Responsive Forms:</h3>
              <p style={{ paddingBottom: "6px" }}>Both stacked and horizontal layouts can be made responsive by using Bootstrap's grid system. For example, you can use the <code>col-lg-2</code> class for large screens and <code>col-sm-12</code> for smaller screens to make the form more responsive.</p>

              <h4>Responsive Horizontal Form Example:</h4>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<form>
  <div class="row mb-3">
    <label for="username" class="col-sm-2 col-md-2 col-lg-2 col-form-label">Username</label>
    <div class="col-sm-10 col-md-10 col-lg-10">
      <input type="text" class="form-control" id="username" placeholder="Enter your username">
    </div>
  </div>
  
  <div class="row mb-3">
    <label for="password" class="col-sm-2 col-md-2 col-lg-2 col-form-label">Password</label>
    <div class="col-sm-10 col-md-10 col-lg-10">
      <input type="password" class="form-control" id="password" placeholder="Enter your password">
    </div>
  </div>
  
  <button type="submit" class="btn btn-primary">Submit</button>
</form>`}
                </code>
              </pre>
            </div>
          )}

          {selectedChapter === 'chapter39' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Grid Small</h1>

              <p>
                Here's a guide to **Grid Small** in Bootstrap, which is used to define the layout behavior for **small screens** (typically from **576px** to **767px**). Below is an explanation, code example, and key points regarding **Grid Small** in Bootstrap.
              </p><br />

              <h3 style={{ paddingBottom: "6px" }}>Grid Classes in Bootstrap:</h3>
              <ul>
                <li><code>col-sm-</code>: Defines how columns behave on small screens (≥576px but {"<768px)"}. It is ideal for layouts that are optimized for mobile devices.</li><br />
                <li><code>col-</code>: Defines how columns behave on extra small screens {"(<576px)"}. This is the default behavior without specifying a size.</li><br />
                <li><code>col-md-</code>: Defines how columns behave on medium screens (≥768px).</li><br />
                <li><code>col-lg-</code>: Defines how columns behave on large screens (≥992px).</li><br />
                <li><code>col-xl-</code>: Defines how columns behave on extra-large screens (≥1200px).</li>
              </ul><br />

              <h3>Example of Grid System with <code>col-sm-</code>:</h3>
              <p>
                In this example, we will create a responsive layout that adapts to small screens, using the <code>col-sm-</code> class:
              </p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Bootstrap Grid Small Example</title>
  <!-- Include Bootstrap CSS -->
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/css/bootstrap.min.css" rel="stylesheet">
</head>
<body>

  <div class="container">
    <div class="row">
      <!-- On extra small screens, columns take full width (col-12).
           On small screens and up (≥576px), columns take 6/12 of the width (col-sm-6). -->
      <div class="col-12 col-sm-6">
        <div class="p-3 border bg-light">Column 1</div>
      </div>
      <div class="col-12 col-sm-6">
        <div class="p-3 border bg-light">Column 2</div>
      </div>
    </div>
  </div>

  <!-- Include Bootstrap JS -->
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/js/bootstrap.bundle.min.js"></script>
</body>
</html>`}
                </code>
              </pre>

              <h3 style={{ paddingBottom: "6px" }}>Explanation:</h3>
              <ul>
                <li><strong>.container</strong>: A responsive fixed-width container that holds the grid system.</li><br />
                <li><strong>.row</strong>: Creates a horizontal group of columns.</li><br />
                <li><strong>.col-12</strong>: On extra small screens (less than 576px), each column will take up the entire width (12 columns out of 12).</li><br />
                <li><strong>.col-sm-6</strong>: On small screens (≥576px), each column will take up 6 columns out of 12, making it half of the container's width.</li>
              </ul><br />

              <h3 style={{ paddingBottom: "6px" }}>Key Points:</h3>
              <ul>
                <li>The Bootstrap grid system is based on 12 columns.</li><br />
                <li><code>col-sm-6</code> means that the column will take up 6/12 of the row on small screens and larger, which is half of the row.</li><br />
                <li><code>col-12</code> ensures the columns stack vertically on smaller screens (below 576px).</li><br />
                <li>You can use other grid classes like <code>col-md-</code>, <code>col-lg-</code>, etc., for larger screen sizes.</li><br />
                <li>On small screens (≥576px), you can arrange multiple columns side by side.</li>
              </ul><br />

              <h3 style={{ paddingBottom: "6px" }}>Result on Screens:</h3>
              <ul>
                <li><strong>Small Screens (≥576px)</strong>: The two columns will each take up 6/12 of the width, side by side (forming a 2-column layout).</li><br />
                <li><strong>Extra Small Screens {"(<576px)"}</strong>: Each column will take up the full width of the container, stacking vertically.</li>
              </ul><br />

              <h3>Conclusion:</h3>
              <p>
                The <code>col-sm-</code> class in Bootstrap is essential for creating layouts that are optimized for small devices, like smartphones. This class allows you to control the number of columns per row on small screens, enabling responsive designs that scale efficiently across different device sizes.
              </p>
            </div>
          )}


          {selectedChapter === 'chapter40' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Grid Medium </h1>

              <p>
                In Bootstrap, the <strong>Grid Medium</strong> (often referred to as <code>col-md-</code>) is used to define the layout behavior on <strong>medium screens</strong> (typically those that are <strong>768px or wider</strong>). This allows you to create responsive layouts that adapt to different screen sizes, from small (sm) to large (lg) screens, and control how the layout behaves as the screen size changes.
              </p><br />

              <h3 style={{ paddingBottom: "6px" }}>Grid Classes in Bootstrap:</h3>
              <ul>
                <li><code>col-md-</code>: Defines how columns behave on medium screens (≥768px). It allows you to customize the layout for medium-sized devices (like tablets).</li><br />
                <li><code>col-</code>: Defines how columns behave on extra small screens {"(<576px)"}. This is the default behavior without specifying a size.</li><br />
                <li><code>col-sm-</code>: Defines how columns behave on small screens (≥576px).</li><br />
                <li><code>col-lg-</code>: Defines how columns behave on large screens (≥992px).</li><br />
                <li><code>col-xl-</code>: Defines how columns behave on extra-large screens (≥1200px).</li>
              </ul><br />

              <h3>Example of Grid System with <code>col-md-</code>:</h3>
              <p>
                In this example, we will create a responsive layout that behaves differently on medium screens and larger, using the <code>col-md-</code> class:
              </p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Bootstrap Grid Medium Example</title>
  <!-- Include Bootstrap CSS -->
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/css/bootstrap.min.css" rel="stylesheet">
</head>
<body>

  <div class="container">
    <div class="row">
      <!-- On extra small screens, columns take full width (col-12).
           On medium screens and up (≥768px), columns take 4/12 of the width (col-md-4). -->
      <div class="col-12 col-md-4">
        <div class="p-3 border bg-light">Column 1</div>
      </div>
      <div class="col-12 col-md-4">
        <div class="p-3 border bg-light">Column 2</div>
      </div>
      <div class="col-12 col-md-4">
        <div class="p-3 border bg-light">Column 3</div>
      </div>
    </div>
  </div>

  <!-- Include Bootstrap JS -->
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/js/bootstrap.bundle.min.js"></script>
</body>
</html>`}
                </code>
              </pre>

              <h3 style={{ paddingBottom: "6px" }}>Explanation:</h3>
              <ul>
                <li><strong>.container</strong>: A responsive fixed-width container that holds the grid system.</li><br />
                <li><strong>.row</strong>: Creates a horizontal group of columns.</li><br />
                <li><strong>.col-12</strong>: On extra small screens (less than 576px), each column will take up the entire width (12 columns out of 12).</li><br />
                <li><strong>.col-md-4</strong>: On medium screens (≥768px), each column will take up 4 columns out of 12, making it one-third of the container width.</li>
              </ul><br />

              <h3 style={{ paddingBottom: "6px" }}>Key Points:</h3>
              <ul>
                <li>The grid system in Bootstrap is based on 12 columns.</li><br />
                <li><code>col-md-4</code> means that the column will take up 4/12 of the row on medium screens and larger, which is one-third of the row.</li><br />
                <li><code>col-12</code> ensures the columns stack vertically on smaller screens (below 768px).</li><br />
                <li>You can use other grid classes like <code>col-lg-</code>, <code>col-xl-</code>, etc., for larger screen sizes.</li><br />
                <li>On medium screens (≥768px), you can arrange multiple columns side by side.</li>
              </ul><br />

              <h3 style={{ paddingBottom: "6px" }}>Result on Screens:</h3>
              <ul>
                <li><strong>Medium Screens (≥768px)</strong>: The three columns will each take up 4/12 of the width, side by side (forming a 3-column layout).</li><br />
                <li><strong>Small Screens{"(<768px)"}</strong>: Each column will take up the full width of the container, stacking vertically.</li>
              </ul><br />

              <h3>Conclusion:</h3>
              <p>
                The <code>col-md-</code> class in Bootstrap is useful for creating layouts that adjust based on the screen size, making your web application responsive across different devices. For screens of 768px and wider (tablets and desktops), you can define a grid layout that adapts by using the <code>col-md-</code> class, allowing you to control the number of columns per row.
              </p>
            </div>
          )}




          {selectedChapter === 'chapter41' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}> Gride Large    </h1>


              <p>
                In Bootstrap, the <strong>Grid Large</strong> (referred to as <code>col-lg-</code>) is used to define the layout behavior on <strong>large screens</strong> (those that are **992px and above**). This class allows you to create responsive layouts that adapt to larger devices like tablets, laptops, and desktops.
              </p><br />

              <h3 style={{ paddingBottom: "6px" }}>Grid Classes in Bootstrap:</h3>
              <ul>
                <li><code>col-sm-</code>: Defines how columns behave on small screens (≥576px but {"<768px)"}.</li><br />
                <li><code>col-md-</code>: Defines how columns behave on medium screens (≥768px but {"<992px)"}.</li><br />
                <li><code>col-lg-</code>: Defines how columns behave on large screens (≥992px).</li><br />
                <li><code>col-xl-</code>: Defines how columns behave on extra-large screens (≥1200px).</li><br />
                <li><code>col-</code>: Defines how columns behave on extra small screens {"(<576px)"}.</li>
              </ul><br />

              <h3>Example of Grid System with <code>col-lg-</code>:</h3>
              <p>
                In this example, we will create a responsive layout that adapts to large screens, using the <code>col-lg-</code> class:
              </p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Bootstrap Grid Large Example</title>
  <!-- Include Bootstrap CSS -->
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/css/bootstrap.min.css" rel="stylesheet">
</head>
<body>

  <div class="container">
    <div class="row">
      <!-- On small screens, columns take full width (col-12).
           On large screens and up (≥992px), columns take 4/12 of the width (col-lg-4). -->
      <div class="col-12 col-lg-4">
        <div class="p-3 border bg-light">Column 1</div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="p-3 border bg-light">Column 2</div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="p-3 border bg-light">Column 3</div>
      </div>
    </div>
  </div>

  <!-- Include Bootstrap JS -->
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/js/bootstrap.bundle.min.js"></script>
</body>
</html>`}
                </code>
              </pre>

              <h3 style={{ paddingBottom: "6px" }}>Explanation:</h3>
              <ul>
                <li><strong>.container</strong>: A responsive fixed-width container that holds the grid system.</li><br />
                <li><strong>.row</strong>: Creates a horizontal group of columns.</li><br />
                <li><strong>.col-12</strong>: On extra small screens (less than 576px), each column will take up the entire width (12 columns out of 12).</li><br />
                <li><strong>.col-lg-4</strong>: On large screens (≥992px), each column will take up 4 columns out of 12, creating a 3-column layout.</li>
              </ul><br />

              <h3 style={{ paddingBottom: "6px" }}>Key Points:</h3>
              <ul>
                <li>The Bootstrap grid system is based on 12 columns.</li><br />
                <li><code>col-lg-4</code> means that the column will take up 4/12 of the row on large screens and larger, which is one-third of the row.</li><br />
                <li><code>col-12</code> ensures the columns stack vertically on smaller screens (below 992px).</li><br />
                <li>On large screens (≥992px), you can arrange columns in a 3-column layout or any other distribution by adjusting the `col-lg-` values.</li>
              </ul><br />

              <h3 style={{ paddingBottom: "6px" }}>Result on Screens:</h3>
              <ul>
                <li><strong>Large Screens (≥992px)</strong>: The three columns will each take up 4/12 of the width, side by side (forming a 3-column layout).</li><br />
                <li><strong>Small Screens {"(<992px)"}</strong>: Each column will take up the full width of the container, stacking vertically.</li>
              </ul><br />

              <h3>Conclusion:</h3>
              <p>
                The <code>col-lg-</code> class in Bootstrap is crucial for creating layouts that are optimized for large screens. This class allows you to control the number of columns per row on large devices, providing a clean and responsive design across desktops and tablets.
              </p>
            </div>
          )}



          {selectedChapter === 'chapter42' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}> Grid Examples</h1>

              <p>
                Here are some <strong>grid examples</strong> in Bootstrap to help you understand how to use the
                <strong>Bootstrap grid system</strong> effectively. The grid system allows you to create flexible
                and responsive layouts. It is based on a 12-column layout, and you can define how many columns
                an element should span based on the screen size.
              </p><br />

              <h3>Example 1: Basic Grid Layout</h3>
              <p>This example demonstrates the basic grid structure with columns that adjust based on screen size.</p>

                 <pre className={style.codeoverflow}><code>
                {`<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Basic Bootstrap Grid Example</title>
  <!-- Bootstrap CSS -->
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/css/bootstrap.min.css" rel="stylesheet">
</head>
<body>
  <div class="container">
    <div class="row">
      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <div class="p-3 border bg-light">Column 1</div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <div class="p-3 border bg-light">Column 2</div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <div class="p-3 border bg-light">Column 3</div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <div class="p-3 border bg-light">Column 4</div>
      </div>
    </div>
  </div>
  <!-- Bootstrap JS -->
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/js/bootstrap.bundle.min.js"></script>
</body>
</html>`}
              </code></pre>

              <h4 style={{ paddingBottom: "6px" }}>Key Points in Example 1:</h4>
              <ul>
                <li><strong>Grid Classes:</strong></li>
                <ul>
                  <li><code>col-12</code>: Takes up the full width on extra-small screens (less than 576px).</li><br />
                  <li><code>col-sm-6</code>: On small screens (≥576px), each column will take up half of the width (6 out of 12).</li><br />
                  <li><code>col-md-4</code>: On medium screens (≥768px), each column will take up 1/3 of the width (4 out of 12).</li><br />
                  <li><code>col-lg-3</code>: On large screens (≥992px), each column will take up 1/4 of the width (3 out of 12).</li>
                </ul>
              </ul><br />

              <h3>Example 2: Nested Grid</h3>
              <p>This example shows how to use <strong>nested grids</strong> inside a column.</p>

                 <pre className={style.codeoverflow}><code>
                {`<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Nested Grid Example</title>
  <!-- Bootstrap CSS -->
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/css/bootstrap.min.css" rel="stylesheet">
</head>
<body>
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="p-3 border bg-light">Main Column 1</div>
        <div class="row">
          <div class="col-6">
            <div class="p-3 border bg-info">Nested Column 1</div>
          </div>
          <div class="col-6">
            <div class="p-3 border bg-info">Nested Column 2</div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="p-3 border bg-light">Main Column 2</div>
      </div>
    </div>
  </div>
  <!-- Bootstrap JS -->
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/js/bootstrap.bundle.min.js"></script>
</body>
</html>`}
              </code></pre>

              <h4>Key Points in Example 2:</h4>
              <ul>
                <li>You can nest <strong>rows</strong> inside <strong>columns</strong>. In this case, inside the first column, there is another <strong>row</strong> with two <strong>nested columns</strong>.</li><br />
                <li>This allows for more complex layouts, especially when you need a grid structure inside a grid.</li>
              </ul><br />

              <h3>Example 3: Offset Columns</h3>
              <p>In this example, we use <strong>offsets</strong> to push columns to the right, creating space before the column.</p>

                 <pre className={style.codeoverflow}><code>
                {`<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Offset Columns Example</title>
  <!-- Bootstrap CSS -->
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/css/bootstrap.min.css" rel="stylesheet">
</head>
<body>
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-4">
        <div class="p-3 border bg-light">Column 1</div>
      </div>
      <div class="col-12 col-md-4 offset-md-4">
        <div class="p-3 border bg-light">Column 2 (Offset)</div>
      </div>
    </div>
  </div>
  <!-- Bootstrap JS -->
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/js/bootstrap.bundle.min.js"></script>
</body>
</html>`}
              </code></pre>

              <h4 style={{ paddingBottom: "6px" }}>Key Points in Example 3:</h4>
              <ul>
                <li><code>offset-md-4</code>: This class pushes the second column 4 columns to the right on medium screens and larger (≥768px).</li><br />
                <li>It helps to create space between columns or align content to the right.</li>
              </ul><br />

              <h3>Example 4: Grid with Equal Width Columns</h3>
              <p>This example demonstrates how to create <strong>equal-width columns</strong> in a row.</p>

                 <pre className={style.codeoverflow}><code>
                {`<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Equal Width Columns</title>
  <!-- Bootstrap CSS -->
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/css/bootstrap.min.css" rel="stylesheet">
</head>
<body>
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="p-3 border bg-light">Column 1</div>
      </div>
      <div class="col">
        <div class="p-3 border bg-light">Column 2</div>
      </div>
      <div class="col">
        <div class="p-3 border bg-light">Column 3</div>
      </div>
    </div>
  </div>
  <!-- Bootstrap JS -->
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/js/bootstrap.bundle.min.js"></script>
</body>
</html>`}
              </code></pre>

              <h4 style={{ paddingBottom: "6px" }}>Key Points in Example 4:</h4>
              <ul>
                <li><code>col</code>: When you use the <code>.col</code> class without a number, the columns will have <strong>equal widths</strong>.</li><br />
                <li>This is useful for creating simple, equal-width layouts.</li>
              </ul><br />

              <h3>Example 5: Grid with Different Column Sizes on Different Screens</h3>
              <p>This example demonstrates how you can use different column sizes for different screen sizes.</p>

                 <pre className={style.codeoverflow}><code>
                {`<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Responsive Column Sizes</title>
  <!-- Bootstrap CSS -->
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/css/bootstrap.min.css" rel="stylesheet">
</head>
<body>
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-6 col-lg-4">
        <div class="p-3 border bg-light">Column 1</div>
      </div>
      <div class="col-12 col-md-6 col-lg-4">
        <div class="p-3 border bg-light">Column 2</div>
      </div>
      <div class="col-12 col-md-6 col-lg-4">
        <div class="p-3 border bg-light">Column 3</div>
      </div>
    </div>
  </div>
  <!-- Bootstrap JS -->
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/js/bootstrap.bundle.min.js"></script>
</body>
</html>`}
              </code></pre>

              <h4 style={{ paddingBottom: "6px" }}>Key Points in Example 5:</h4>
              <ul>
                <li>This grid example changes the number of columns based on screen size.</li><br />
                <li>On extra-small screens {"(<576px)"}, each column takes up the full width (12 columns).</li><br />
                <li>On medium screens (≥768px), each column takes up half the width (6 out of 12).</li><br />
                <li>On large screens (≥992px), each column takes up one-third of the width (4 out of 12).</li>
              </ul><br />
            </div>
          )}


          {selectedChapter === 'chapter43' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Templates</h1>

              <p>
                Bootstrap templates are pre-built layouts and design patterns that help you quickly create responsive websites. They include layouts, sections (headers, footers), and components (cards, forms, etc.).
              </p><br />

              <h3 style={{ paddingBottom: "6px" }}>Key Elements</h3>
              <ul>
                <li><strong>Grid System:</strong> 12-column grid for responsive layouts.</li><br />
                <li><strong>Components:</strong> Pre-designed UI elements like buttons and modals.</li><br />
                <li><strong>Utilities:</strong> Classes for spacing, alignment, colors, etc.</li><br />
                <li><strong>JavaScript Plugins:</strong> Interactive features like carousels.</li>
              </ul><br />

              <h3 style={{ paddingBottom: "6px" }}>Template Types</h3>
              <ul>
                <li><strong>Landing Pages:</strong> Marketing or single-page sites.</li><br />
                <li><strong>Dashboards:</strong> Admin panels with charts and tables.</li><br />
                <li><strong>Blogs/Portfolios:</strong> Showcases for articles or projects.</li><br />
                <li><strong>E-commerce:</strong> Product grids and shopping carts.</li>
              </ul><br />

              <h3 style={{ paddingBottom: "6px" }}>Using Templates</h3>
              <ol>
                <li><strong>Official Templates:</strong> Free options from the <a href="https://getbootstrap.com/docs/5.3/examples/" target="_blank">Bootstrap site</a>.</li><br />
                <li><strong>Third-Party Templates:</strong> Find more on sites like <a href="https://startbootstrap.com/" target="_blank">StartBootstrap</a>.</li><br />
                <li><strong>Customize:</strong> Edit content, styles, and add Bootstrap utilities.</li>
              </ol><br />

              <h3>Example: Basic Template</h3>
                 <pre className={style.codeoverflow}>
                <code>{`<!doctype html>
<html>
<head>
  <title>Bootstrap Template</title>
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/css/bootstrap.min.css" rel="stylesheet">
</head>
<body>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">Navbar</nav>
  <header class="hero bg-primary text-white text-center py-5">Welcome</header>
  <section class="container py-5">
    <div class="row">
      <div class="col-md-4">Feature 1</div>
      <div class="col-md-4">Feature 2</div>
      <div class="col-md-4">Feature 3</div>
    </div>
  </section>
  <footer class="bg-dark text-white text-center py-3">&copy; 2024</footer>
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/js/bootstrap.bundle.min.js"></script>
</body>
</html>`}</code>
              </pre><br />

              <p>This template includes a Navbar, Hero Section, Features Section, and Footer. Customize it with your own content.</p>
            </div>
          )}


          {selectedChapter === 'chapter44' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Benefits </h1>
              <ul>
                <li>
                  <strong>Faster Development:</strong>
                  Pre-built templates save significant time by providing ready-to-use layouts and components, enabling developers to focus on customization rather than building from scratch.
                </li><br />

                <li>
                  <strong>Responsive Design:</strong>
                  Built on Bootstrap’s grid system, templates automatically adapt to various screen sizes, ensuring a seamless user experience on mobile, tablet, and desktop devices.
                </li><br />

                <li>
                  <strong>Consistent Styling:</strong>
                  Templates follow Bootstrap's design standards, ensuring visual consistency across pages and reducing design-related errors.
                </li><br />

                <li>
                  <strong>Ease of Customization:</strong>
                  Templates are modular and can be easily customized using Bootstrap classes or additional CSS, allowing developers to tailor designs to their specific needs.
                </li><br />

                <li>
                  <strong>Cross-Browser Compatibility:</strong>
                  Bootstrap templates are tested to work consistently across major browsers like Chrome, Firefox, Safari, and Edge, saving time in compatibility testing.
                </li><br />

                <li>
                  <strong>Beginner-Friendly:</strong>
                  Templates provide a well-structured starting point, making them ideal for developers with little or no design experience to create professional-looking websites quickly.
                </li><br />

                <li>
                  <strong>Built-in Interactivity:</strong>
                  Bootstrap includes JavaScript plugins (e.g., modals, carousels, and dropdowns) that add interactive features without requiring extensive coding expertise.
                </li><br />

                <li>
                  <strong>Cost-Effective:</strong>
                  Many templates are free or available at a low cost, reducing the need to hire professional designers or developers for small to medium-sized projects.
                </li><br />

                <li>
                  <strong>Scalability:</strong>
                  Templates are designed to scale with projects, enabling easy addition of new sections, components, or features as the application grows.
                </li><br />

                <li>
                  <strong>Accessibility Features:</strong>
                  Most Bootstrap templates include built-in accessibility features, such as ARIA roles and semantic HTML, ensuring better usability for all users, including those with disabilities.
                </li><br />

                <li>
                  <strong>Wide Community Support:</strong>
                  With a large user community, developers can easily find tutorials, forums, and solutions for customizing or troubleshooting Bootstrap templates.
                </li><br />

                <li>
                  <strong>Professional Appearance:</strong>
                  Even with minimal customization, templates offer a polished and professional look that enhances the credibility of your website or application.
                </li><br />

                <li>
                  <strong>Time-Saving Updates:</strong>
                  As Bootstrap updates its framework, templates can be easily upgraded to the latest version, ensuring long-term compatibility and support.
                </li>
              </ul>
            </div>
          )}


          {selectedChapter === 'chapter45' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Examples</h1>


              <h3>1. Grid System</h3>
              <p>The Bootstrap grid system uses a 12-column structure to create responsive layouts.</p>
                 <pre className={style.codeoverflow}><code>{`
<div className="container">
  <div className="row">
    <div className="col-12 col-md-4">Column 1</div>
    <div className="col-12 col-md-4">Column 2</div>
    <div className="col-12 col-md-4">Column 3</div>
  </div>
</div>
        `}</code></pre><br />

              <h3>2. Navbar</h3>
              <p>A flexible and responsive navigation bar.</p>
                 <pre className={style.codeoverflow}><code>{`
<nav className="navbar navbar-expand-lg navbar-light bg-light">
  <a className="navbar-brand" href="#">Navbar</a>
  <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
    <span className="navbar-toggler-icon"></span>
  </button>
  <div className="collapse navbar-collapse" id="navbarNav">
    <ul className="navbar-nav">
      <li className="nav-item"><a className="nav-link" href="#">Home</a></li>
      <li className="nav-item"><a className="nav-link" href="#">Features</a></li>
    </ul>
  </div>
</nav>
        `}</code></pre><br />

              <h3>3. Buttons</h3>
              <p>Various button styles like primary, secondary, and success.</p>
                 <pre className={style.codeoverflow}><code>{`
<button className="btn btn-primary">Primary Button</button>
<button className="btn btn-secondary">Secondary Button</button>
<button className="btn btn-success">Success Button</button>
        `}</code></pre><br />

              <h3>4. Card Component</h3>
              <p>Bootstrap cards are flexible content containers.</p>
                 <pre className={style.codeoverflow}><code>{`
<div className="card" style={{ width: '18rem' }}>
  <img src="https://via.placeholder.com/150" className="card-img-top" alt="Image" />
  <div className="card-body">
    <h5 className="card-title">Card title</h5>
    <p className="card-text">Some quick example text.</p>
    <a href="#" className="btn btn-primary">Go somewhere</a>
  </div>
</div>
        `}</code></pre><br />

              <h3>5. Modals</h3>
              <p>Pop-up dialogs to display content or confirm actions.</p>
                 <pre className={style.codeoverflow}><code>{`
<button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
  Launch Modal
</button>

<div className="modal fade" id="exampleModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title">Modal title</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div className="modal-body">This is a simple modal example.</div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" className="btn btn-primary">Save changes</button>
      </div>
    </div>
  </div>
</div>
        `}</code></pre><br />

              <h3>6. Alerts</h3>
              <p>Used to display important messages like success, error, or warnings.</p>
                 <pre className={style.codeoverflow}><code>{`
<div className="alert alert-success" role="alert">This is a success alert!</div>
<div className="alert alert-danger" role="alert">This is a danger alert!</div>
        `}</code></pre><br />

              <h3>7. Forms</h3>
              <p>Pre-styled form components for user input.</p>
                 <pre className={style.codeoverflow}><code>{`
<form>
  <div className="mb-3">
    <label htmlFor="email" className="form-label">Email address</label>
    <input type="email" className="form-control" id="email" />
  </div>
  <button type="submit" className="btn btn-primary">Submit</button>
</form>
        `}</code></pre><br />

              <h3>8. Carousel</h3>
              <p>A slideshow component for cycling through elements like images or text.</p>
                 <pre className={style.codeoverflow}><code>{`
<div id="carouselExample" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active">
      <img src="https://via.placeholder.com/800x400" className="d-block w-100" alt="..." />
    </div>
    <div className="carousel-item">
      <img src="https://via.placeholder.com/800x400" className="d-block w-100" alt="..." />
    </div>
  </div>
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
  </button>
</div>
        `}</code></pre>

              <p>These are basic examples showcasing Bootstrap's versatility for building responsive websites.</p>


            </div>
          )}


          {selectedChapter === 'chapter46' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Editor</h1>

              <p>
                To create an editor in Bootstrap, you typically need a text editing area like a rich text editor (e.g., for writing blog posts, emails, or any content that requires formatting). Bootstrap itself doesn't provide a built-in editor, but you can easily integrate third-party libraries like <strong>CKEditor</strong> or <strong>TinyMCE</strong> into your Bootstrap project.
              </p><br />

              <h3>Step 1: Include Bootstrap and CKEditor in Your Project</h3>
              <p>
                You can include the required Bootstrap and CKEditor files via a CDN. Here’s how to do it:
              </p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Bootstrap CKEditor Example</title>
  
  <!-- Bootstrap CSS (CDN) -->
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/css/bootstrap.min.css" rel="stylesheet">

  <!-- CKEditor (CDN) -->
  <script src="https://cdn.ckeditor.com/ckeditor5/36.0.1/classic/ckeditor.js"></script>
</head>
<body>
  <div class="container mt-5">
    <h2 class="text-center">Bootstrap Form with CKEditor</h2>
    
    <form>
      <div class="mb-3">
        <label for="editor" class="form-label">Your Content</label>
        <textarea id="editor" name="editor" class="form-control" rows="10"></textarea>
      </div>
      
      <button type="submit" class="btn btn-primary">Submit</button>
    </form>
  </div>

  <!-- Bootstrap JS (CDN) -->
  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/js/bootstrap.bundle.min.js"></script>

  <script>
    // Initialize CKEditor
    ClassicEditor
      .create(document.querySelector('#editor'))
      .catch(error => {
        console.error(error);
      });
  </script>
</body>
</html>`}
                </code>
              </pre>

              <h3 style={{ paddingBottom: "6px" }}>Explanation:</h3>
              <ul>
                <li><strong>Bootstrap</strong>: The Bootstrap 5 stylesheet and script are included from the CDN to style the page and provide responsive layout.</li><br />
                <li><strong>CKEditor</strong>: The CKEditor script is loaded from the CDN. It’s a rich text editor that supports features like bold, italics, lists, images, etc.</li><br />
                <li><strong>Form Structure</strong>: A simple Bootstrap form is created with a <code>textarea</code> element, which is later transformed into a rich text editor using CKEditor.</li>
              </ul><br />

              <h3 style={{ paddingBottom: "6px" }}>Features:</h3>
              <ul>
                <li>The <strong>textarea</strong> is automatically replaced by a CKEditor instance when the page loads.</li><br />
                <li>You can type rich text, format it, add images, links, and more, just like in any standard word processor.</li>
              </ul><br />

              <h3>Step 2: Customize CKEditor (Optional)</h3>
              <p>
                CKEditor allows you to customize its toolbar and features. For example, you can add or remove buttons and configure the editor for your needs.
              </p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`ClassicEditor
  .create(document.querySelector('#editor'), {
    toolbar: ['bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote']
  })
  .catch(error => {
    console.error(error);
  });`}
                </code>
              </pre>

              <p>This configuration limits the toolbar to only bold, italic, link, bulleted list, numbered list, and blockquote.</p><br />

              <h3>Step 3: Handling Form Submission</h3>
              <p>
                You can access the content of the CKEditor instance when the form is submitted by capturing the content like so:
              </p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`// Example to get the editor content
const editorContent = editor.getData();
console.log(editorContent);`}
                </code>
              </pre>

              <p>
                You can use this to send the content to your server or process it as needed.
              </p><br />

              <h3>Step 4: Alternative - TinyMCE</h3>
              <p>
                TinyMCE is another popular rich text editor. To use it, replace CKEditor with TinyMCE by following similar steps:
              </p>
              <h4>1. Add TinyMCE CDN:</h4>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<script src="https://cdn.tiny.cloud/1/no-api-key/tinymce/5/tinymce.min.js" referrerpolicy="origin"></script>`}
                </code>
              </pre><br />

              <h4>2. Initialize TinyMCE:</h4>
                 <pre className={style.codeoverflow}>
                <code>
                  {`tinymce.init({
  selector: '#editor',
  plugins: 'lists link image',
  toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | bullist numlist | link image'
});`}
                </code>
              </pre><br />

              <h3>Conclusion</h3>
              <p>
                Both CKEditor and TinyMCE can be easily integrated into a Bootstrap-based layout, turning a simple <code>textarea</code> into a full-featured rich text editor. You can customize these editors to fit your needs and use them within forms styled by Bootstrap.
              </p>
            </div>
          )}




          {selectedChapter === 'chapter47' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Quiz</h1>
              <p>Here is a sample quiz on <strong>Bootstrap</strong> to test understanding of its core concepts:</p>

              <h3>1. What is the latest stable version of Bootstrap as of 2024?</h3>
              <ul>
                <li>A) Bootstrap 3</li>
                <li>B) Bootstrap 4</li>
                <li>C) Bootstrap 5</li>
                <li>D) Bootstrap 6</li>
              </ul><br />

              <h3>2. Which of the following class is used to create a responsive table in Bootstrap?</h3>
              <ul>
                <li>A) <code>.table-striped</code></li>
                <li>B) <code>.table-bordered</code></li>
                <li>C) <code>.table-responsive</code></li>
                <li>D) <code>.table-hover</code></li>
              </ul><br />

              <h3>3. What does Bootstrap's grid system primarily use for layout?</h3>
              <ul>
                <li>A) Flexbox</li>
                <li>B) Float</li>
                <li>C) Tables</li>
                <li>D) Inline-block</li>
              </ul><br />

              <h3>4. How many columns are there in Bootstrap’s grid system?</h3>
              <ul>
                <li>A) 10</li>
                <li>B) 12</li>
                <li>C) 16</li>
                <li>D) 24</li>
              </ul><br />

              <h3>5. Which class is used to add a margin on all sides of an element in Bootstrap?</h3>
              <ul>
                <li>A) <code>.m-1</code></li>
                <li>B) <code>.p-1</code></li>
                <li>C) <code>.m-auto</code></li>
                <li>D) <code>.p-auto</code></li>
              </ul><br />

              <h3>6. What class would you use to make text bold in Bootstrap?</h3>
              <ul>
                <li>A) <code>.font-bold</code></li>
                <li>B) <code>.text-bold</code></li>
                <li>C) <code>.fw-bold</code></li>
                <li>D) <code>.text-weight-bold</code></li>
              </ul><br />

              <h3>7. Which class in Bootstrap hides an element on extra-small screens but keeps it visible on larger screens?</h3>
              <ul>
                <li>A) <code>.hidden-xs</code></li>
                <li>B) <code>.d-none d-sm-block</code></li>
                <li>C) <code>.d-block d-sm-none</code></li>
                <li>D) <code>.d-xs-none</code></li>
              </ul><br />

              <h3>8. How do you center a block element in Bootstrap?</h3>
              <ul>
                <li>A) <code>.text-center</code></li>
                <li>B) <code>.align-center</code></li>
                <li>C) <code>.justify-content-center</code></li>
                <li>D) <code>.mx-auto</code></li>
              </ul><br />

              <h3>9. Which class is used to create a button with a primary color in Bootstrap?</h3>
              <ul>
                <li>A) <code>.btn-default</code></li>
                <li>B) <code>.btn-primary</code></li>
                <li>C) <code>.btn-success</code></li>
                <li>D) <code>.btn-main</code></li>
              </ul><br />

              <h3>10. What class provides a fixed navigation bar at the top of the screen in Bootstrap?</h3>
              <ul>
                <li>A) <code>.navbar-default</code></li>
                <li>B) <code>.navbar-top</code></li>
                <li>C) <code>.navbar-fixed</code></li>
                <li>D) <code>.fixed-top</code></li>
              </ul><br />

              <h3 style={{ paddingBottom: "6px" }}>Answers:</h3>
              <ul>
                <li>1. C) Bootstrap 5</li><br />
                <li>2. C) <code>.table-responsive</code></li><br />
                <li>3. A) Flexbox</li><br />
                <li>4. B) 12</li><br />
                <li>5. A) <code>.m-1</code></li><br />
                <li>6. C) <code>.fw-bold</code></li><br />
                <li>7. B) <code>.d-none d-sm-block</code></li><br />
                <li>8. D) <code>.mx-auto</code></li><br />
                <li>9. B) <code>.btn-primary</code></li><br />
                <li>10. D) <code>.fixed-top</code></li>
              </ul><br />

              <p>This quiz covers basic Bootstrap features such as the grid system, responsiveness, typography, and utility classes.</p>
            </div>
          )}



          {selectedChapter === 'chapter48' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Interview Prep</h1>


              <h2 style={{ paddingBottom: "6px" }}>Key Topics to Prepare for Bootstrap Interviews</h2>

              <h3 style={{ paddingBottom: "6px" }}>1. Bootstrap Grid System</h3>
              <ul>
                <li><strong>What to study:</strong></li>
                <ul>
                  <li>How the 12-column grid system works.</li><br />
                  <li>Differences between Bootstrap 3, 4, and 5 grids.</li><br />
                  <li>Responsive breakpoints (<code>xs</code>, <code>sm</code>, <code>md</code>, <code>lg</code>, <code>xl</code>, <code>xxl</code>).</li><br />
                  <li>Classes for columns (<code>col</code>, <code>{`col-{size}-{n}`}</code>) and offsets (<code>offset-*</code>).</li>
                  <li>Flexbox features in Bootstrap’s grid system.</li>
                </ul><br />
                <li>Common questions:</li>
                <ul>
                  <li>Explain how Bootstrap's grid system works.</li><br />
                  <li>What are the different breakpoints in Bootstrap 5?</li><br />
                  <li>How can you center a column in the grid?</li>
                </ul>
              </ul><br />

              <h3>2. Responsive Design</h3>
              <ul>
                <li>What to study:</li>
                <ul>
                  <li>Media queries in Bootstrap and their role in responsiveness.</li><br />
                  <li>Responsive utility classes (e.g., <code>.d-none</code>, <code>.d-block</code>, <code>.d-sm-none</code>).</li><br />
                  <li>The <code>container</code>, <code>container-fluid</code>, and <code>{`container-{breakpoint}`}</code> classes.</li><br />
                  <li>Bootstrap's use of Flexbox and how it helps in responsiveness.</li>
                </ul><br />
                <li>Common questions:</li>
                <ul>
                  <li>How does Bootstrap make websites responsive?</li><br />
                  <li>What is the difference between <code>.d-none</code>, <code>.d-sm-block</code>, and <code>.d-lg-none</code>?</li><br />
                  <li>How can you use Bootstrap to make an image responsive?</li>
                </ul>
              </ul><br />

              <h3>3. Utility Classes</h3>
              <ul>
                <li>What to study:</li>
                <ul>
                  <li>Bootstrap’s utility classes for spacing, text alignment, colors, borders, etc.</li><br />
                  <li>Margin and padding classes (<code>.m-1</code>, <code>.p-2</code>, <code>.mx-auto</code>, etc.).</li><br />
                  <li>Text utilities (<code>.text-center</code>, <code>.text-uppercase</code>, etc.).</li><br />
                  <li>Display and visibility utilities (<code>.d-flex</code>, <code>.d-none</code>, <code>.visible-*</code>, etc.).</li>
                </ul><br />
                <li>Common questions:</li>
                <ul>
                  <li>What is the purpose of utility classes in Bootstrap?</li><br />
                  <li>How would you add margin to an element using Bootstrap classes?</li><br />
                  <li>Can you explain how Bootstrap handles the visibility of elements?</li>
                </ul>
              </ul><br />

              <h3>4. Components in Bootstrap</h3>
              <ul>
                <li>What to study:</li>
                <ul>
                  <li>Key components like Navbar, Dropdowns, Modals, Alerts, Carousels, etc.</li><br />
                  <li>How to use them and customize them using options or custom CSS.</li><br />
                  <li>The importance of JavaScript for interactive components (e.g., modals, carousels).</li>
                </ul><br />
                <li>Common questions:</li>
                <ul>
                  <li>How would you create a navigation bar using Bootstrap?</li><br />
                  <li>Explain how a modal works in Bootstrap and how it is initialized.</li><br />
                  <li>How can you customize a Bootstrap component?</li>
                </ul>
              </ul><br />

              <h3>5. Customizing Bootstrap</h3>
              <ul>
                <li><strong>What to study:</strong></li>
                <ul>
                  <li>Overriding Bootstrap styles using custom CSS or SASS.</li><br />
                  <li>Using Bootstrap’s variables to customize themes.</li><br />
                  <li>Bootstrap’s themeable features like custom buttons and color schemes.</li>
                </ul><br />
                <li>Common questions:</li>
                <ul>
                  <li>How would you customize Bootstrap to match a project’s design?</li><br />
                  <li>What are Bootstrap variables, and how can they be used to customize styles?</li>
                </ul>
              </ul><br />

              <h3>6. Bootstrap Forms</h3>
              <ul>
                <li><strong>What to study:</strong></li>
                <ul>
                  <li>Different types of form controls and their Bootstrap-specific classes.</li><br />
                  <li>Input groups, form validation, and layout techniques (inline, horizontal forms).</li><br />
                  <li>How to handle validation feedback with Bootstrap's form validation classes.</li>
                </ul><br />
                <li>Common questions:</li>
                <ul>
                  <li>How would you create a form with inline inputs in Bootstrap?</li><br />
                  <li>Explain how form validation works in Bootstrap.</li><br />
                  <li>How do you create a custom-styled input group in Bootstrap?</li>
                </ul>
              </ul><br />

              <h3>7. Icons and Bootstrap Icons</h3>
              <ul>
                <li>What to study:</li>
                <ul>
                  <li>The role of icons in Bootstrap and how to use Bootstrap Icons library.</li><br />
                  <li>Using SVG icons or integrating Font Awesome with Bootstrap.</li>
                </ul><br />
                <li>Common questions:</li>
                <ul>
                  <li>How do you add icons in a Bootstrap project?</li><br />
                  <li>Can you explain how to include and use Bootstrap Icons?</li>
                </ul>
              </ul><br />

              <h3>8. Bootstrap Modals and Popovers</h3>
              <ul>
                <li>What to study:</li>
                <ul>
                  <li>How modals are triggered and customized using data attributes or JavaScript.</li><br />
                  <li>How popovers and tooltips work, and how to initialize them using Bootstrap's JS components.</li>
                </ul><br />
                <li>Common questions:</li>
                <ul>
                  <li>How do you open and close a modal in Bootstrap using JavaScript?</li><br />
                  <li>What is the difference between a popover and a tooltip in Bootstrap?</li>
                </ul>
              </ul><br />

              <h3>9. Bootstrap Flexbox</h3>
              <ul>
                <li>What to study:</li>
                <ul>
                  <li>Understanding of Flexbox utilities in Bootstrap (e.g., <code>.d-flex</code>, <code>.justify-content-*</code>, <code>.align-items-*</code>).</li><br />
                  <li>Differences between Flexbox layout and the older float-based layout.</li>
                </ul><br />
                <li>Common questions:</li>
                <ul>
                  <li>Explain how Flexbox works in Bootstrap.</li><br />
                  <li>How can you align items horizontally and vertically using Bootstrap Flexbox?</li>
                </ul>
              </ul><br />

              <h3>10. Bootstrap JavaScript Plugins</h3>
              <ul>
                <li>What to study:</li>
                <ul>
                  <li>JavaScript features of Bootstrap like Carousel, Collapse, Tooltip, and Modal.</li><br />
                  <li>How Bootstrap JavaScript plugins can be initialized using data attributes or manually using JavaScript.</li>
                </ul><br />
                <li>Common questions:</li>
                <ul>
                  <li>How would you initialize a Bootstrap Carousel?</li><br />
                  <li>What is the role of data attributes in Bootstrap JavaScript components?</li>
                </ul>
              </ul><br />

              <h2>Sample Interview Questions</h2>
              <ul>
                <li>Explain how Bootstrap's grid system works.</li><br />
                <li>What is the difference between <code>

                  container</code> and <code>container-fluid</code> in Bootstrap?</li><br />
                <li>How can you create a responsive navigation bar using Bootstrap?</li><br />
                <li>What are the common media queries used in Bootstrap for responsiveness?</li><br />
                <li>How would you customize a Bootstrap component for a project?</li>
              </ul><br />

              <h2 style={{ paddingBottom: "6px" }}>Additional Tips</h2>
              <ul>
                <li>Stay up to date with the latest version of Bootstrap (currently Bootstrap 5).</li><br />
                <li>Practice implementing real-world projects using Bootstrap.</li><br />
                <li>Get comfortable with debugging Bootstrap issues using browser developer tools.</li>
              </ul>
            </div>
          )}


          {selectedChapter === 'chapter50' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>CSS Classes </h1>
              <p>
                Bootstrap provides a wide range of CSS classes to style your web pages efficiently.
                Below is a categorized list of the most commonly used Bootstrap classes:
              </p><br />

              <h3 style={{ paddingBottom: "6px" }}>1. Layout</h3>
              <ul>
                <li><code>.container</code>, <code>.container-fluid</code>, <code>{`.container-{breakpoint}`}</code></li><br />
                <li><code>.row</code></li><br />
                <li><code>.col</code>, <code>{`.col-{size}-{number}`}</code> (e.g., <code>.col-md-6</code>)</li><br />
                <li><code>.col-auto</code> (for auto-width columns)</li><br />
                <li><code>{`.g-{n}`}</code> (gutter spacing, e.g., <code>.g-0</code>, <code>.g-3</code>)</li>
              </ul><br />

              <h3 style={{ paddingBottom: "6px" }}>2. Grid System</h3>
              <ul>
                <li><code>.row</code>, <code>.col</code></li><br />
                <li><code>{`.col-{size}-{n}`}</code> (e.g., <code>.col-sm-12</code>, <code>.col-lg-4</code>)</li><br />
                <li><code>{`.offset-{size}-{n}`}</code> (e.g., <code>.offset-md-2</code>)</li><br />
                <li><code>{`.order-{size}-{n}`}</code> (for column ordering)</li><br />
                <li><code>{`.d-{breakpoint}-none`}</code> to <code>{`.d-{breakpoint}-block`}</code> (control display)</li>
              </ul><br />

              <h3 style={{ paddingBottom: "6px" }}>3. Spacing (Margin & Padding)</h3>
              <ul>
                <li><code>{`.m-{n}`}</code> (margin) and <code>{`.p-{n}`}</code> (padding), where <code>n</code> is a number from 0 to 5.</li><br />
                <li>Example: <code>.m-3</code> for margin, <code>.p-2</code> for padding.</li><br />
                <li><code>.mx-auto</code>, <code>.my-4</code>, <code>.p-lg-5</code> (for directional margins/paddings).</li>
              </ul><br />

              {/* Continue with the remaining Bootstrap classes list in similar structure */}
              <p>
                This is just a selection of the most commonly used classes in Bootstrap, which allows you to build fully responsive, flexible, and customizable interfaces.
              </p>
            </div>
          )}






          {selectedChapter === 'chapter51' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>CSS Typography</h1>
              <p>
                Bootstrap provides a variety of typography-related classes to help you style text and other content in a standardized and responsive way. Here’s a comprehensive guide to typography classes in Bootstrap:
              </p><br />

              <h2>1. Headings</h2>
              <p>
                Bootstrap provides heading classes for all the standard HTML heading elements (<code>{'<h1>'}</code> to <code>{'<h6>'}</code>), which scale accordingly:
              </p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<h1 class="display-1">Heading 1</h1>
<h2 class="display-2">Heading 2</h2>
<h3 class="display-3">Heading 3</h3>
<h4 class="display-4">Heading 4</h4>
<h5 class="display-5">Heading 5</h5>
<h6 class="display-6">Heading 6</h6>`}
                </code>
              </pre>
              <p>
                You can use <strong>display headings</strong> to create larger headings with classes like <code>.display-1</code> through <code>.display-6</code>. You can also use the <code>{'<small>'}</code> tag or the <code>.small</code> class to indicate subheadings:
              </p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<h1>Heading 1 <small class="text-muted">Subheading</small></h1>`}
                </code>
              </pre><br />

              <h2>2. Lead Text</h2>
              <p>
                Use the <code>.lead</code> class to make paragraph text larger and more prominent.
              </p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<p class="lead">This is a lead paragraph. It stands out from regular text.</p>`}
                </code>
              </pre><br />

              <h2>3. Inline Text Elements</h2>
              <p>
                Bootstrap provides several utility classes for inline text styling:
              </p>
              <ul>
                <li><code>.font-weight-bold</code>: Bold text</li><br />
                <li><code>.font-italic</code>: Italic text</li>
              </ul>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<p class="font-weight-bold">Bold Text</p>
<p class="font-italic">Italic Text</p>`}
                </code>
              </pre><br />

              <h2>4. Text Alignment</h2>
              <p>
                Control text alignment using <code>.text-left</code>, <code>.text-center</code>, and <code>.text-right</code>. You can also use responsive classes like <code>.text-sm-left</code>, <code>.text-md-right</code>, etc.
              </p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<p class="text-left">Left aligned text</p>
<p class="text-center">Center aligned text</p>
<p class="text-right">Right aligned text</p>`}
                </code>
              </pre><br />

              <h2>5. Text Colors</h2>
              <p>
                Bootstrap offers several text color utilities to match Bootstrap’s color scheme:
              </p>
              <ul>
                <li><code>.text-primary</code>: Primary text</li>
                <li><code>.text-danger</code>: Danger text</li>
                <li><code>.text-muted</code>: Muted text</li>
              </ul>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<p class="text-primary">Primary text</p>
<p class="text-danger">Danger text</p>
<p class="text-muted">Muted text</p>`}
                </code>
              </pre><br />

              <h2>6. Text Transform</h2>
              <p>
                Use text transformation classes like <code>.text-uppercase</code> to convert text to uppercase, or <code>.text-capitalize</code> to capitalize the first letter of each word.
              </p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<p class="text-uppercase">Uppercase text</p>
<p class="text-capitalize">Capitalized Text</p>`}
                </code>
              </pre><br />

              <h2>7. Font Size</h2>
              <p>
                Bootstrap includes responsive font sizing with classes like <code>.fs-1</code> to <code>.fs-6</code>.
              </p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<p class="fs-1">Font size 1</p>
<p class="fs-6">Font size 6 (smallest)</p>`}
                </code>
              </pre><br />

              <h2>8. Blockquote</h2>
              <p>
                For blockquotes, use <code>.blockquote</code> with optional <code>.blockquote-footer</code> for citation:
              </p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<blockquote class="blockquote">
  <p class="mb-0">A well-known quote</p>
  <footer class="blockquote-footer">Someone famous</footer>
</blockquote>`}
                </code>
              </pre><br />

              <h2>9. Lists</h2>
              <p>
                To remove default list styles, use <code>.list-unstyled</code>, and for inline lists, use <code>.list-inline</code>.
              </p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<ul class="list-unstyled">
  <li>Item 1</li>
  <li>Item 2</li>
</ul>

<ul class="list-inline">
  <li class="list-inline-item">Inline item 1</li>
  <li class="list-inline-item">Inline item 2</li>
</ul>`}
                </code>
              </pre><br />

              <h2>10. Text Wrapping and Overflow</h2>
              <p>
                Control text overflow using <code>.text-wrap</code>, <code>.text-nowrap</code>, and <code>.text-truncate</code>.
              </p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<p class="text-truncate" style="width: 150px;">
  This text will truncate if it's too long.
</p>`}
                </code>
              </pre><br />

              <h2>11. Monospace Font</h2>
              <p>
                For code or monospace text, use <code>.font-monospace</code>.
              </p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<p class="font-monospace">This is monospaced text.</p>`}
                </code>
              </pre><br />

              <h2>12. Text Decoration</h2>
              <p>
                Use <code>.text-decoration-none</code> to remove underlines, <code>.text-decoration-underline</code> to add them, or <code>.text-decoration-line-through</code> for strikethrough text.
              </p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<p class="text-decoration-underline">Underlined text</p>
<p class="text-decoration-line-through">Strikethrough text</p>`}
                </code>
              </pre>

              <br />

              <h2>Example</h2>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="container">
  <h1 class="display-4 text-center text-primary">Bootstrap Typography</h1>
  <p class="lead text-muted">Learn how to style text with Bootstrap's typography utilities.</p>

  <h2 class="text-uppercase">1. Headings</h2>
  <p class="h3">This is an H3 heading using Bootstrap's responsive heading class.</p>

  <h2 class="text-capitalize">2. Text Transform</h2>
  <p class="text-lowercase">this text is all lowercase.</p>
  <p class="text-uppercase">THIS TEXT IS UPPERCASE.</p>
  <p class="text-capitalize">this text is capitalized.</p>

  <h2 class="text-primary">3. Text Color</h2>
  <p class="text-success">This text is green (success).</p>
  <p class="text-danger">This text is red (danger).</p>

  <h2>4. Blockquotes</h2>
  <blockquote class="blockquote">
    <p class="mb-0">This is a simple blockquote example.</p>
    <footer class="blockquote-footer">Someone famous</footer>
  </blockquote>
</div>`}
                </code>
              </pre>
            </div>
          )}


          {selectedChapter === 'chapter52' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>CSS Buttons</h1>


              <p >Bootstrap provides a set of predefined button classes that are designed to be highly customizable and responsive. You can easily add button styles to your elements using these classes.</p>

              <h3>Basic Button Classes</h3>
              <p>To create buttons, you use the <code>&lt;button&gt;</code> element or <code>&lt;a&gt;</code> tag with appropriate Bootstrap button classes. Here are the common button classes:</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<button class="btn btn-primary">Primary Button</button>
        <button class="btn btn-secondary">Secondary Button</button>
        <button class="btn btn-success">Success Button</button>
        <button class="btn btn-danger">Danger Button</button>
        <button class="btn btn-warning">Warning Button</button>
        <button class="btn btn-info">Info Button</button>
        <button class="btn btn-light">Light Button</button>
        <button class="btn btn-dark">Dark Button</button>
        <button class="btn btn-link">Link Button</button>`}
                </code>
              </pre>
              <ul>
                <li><strong>.btn</strong>: The basic class to style buttons.</li><br />
                <li><strong>Color Variants</strong>: Buttons have various color classes like <code>.btn-primary</code>, <code>.btn-secondary</code>, <code>.btn-success</code>, etc., that change the button’s appearance.</li>
              </ul><br />

              <h2>2. Button Sizes</h2>
              <p>You can control the size of buttons using the following size classes:</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<button class="btn btn-primary btn-lg">Large Button</button>
        <button class="btn btn-primary">Default Button</button>
        <button class="btn btn-primary btn-sm">Small Button</button>`}
                </code>
              </pre>
              <ul>
                <li><strong>.btn-lg</strong>: Larger button.</li><br />
                <li><strong>.btn-sm</strong>: Smaller button.</li><br />
                <li><strong>Default size</strong>: Standard size.</li>
              </ul><br />

              <h2>3. Button Outline</h2>
              <p>If you prefer buttons with a transparent background and a border, use the <code>outline</code> version of the button:</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<button class="btn btn-outline-primary">Primary Outline Button</button>
        <button class="btn btn-outline-secondary">Secondary Outline Button</button>
        <button class="btn btn-outline-success">Success Outline Button</button>
        <button class="btn btn-outline-danger">Danger Outline Button</button>`}
                </code>
              </pre>
              <ul>
                <li><strong>.btn-outline-*</strong>: Creates a button with a transparent background and a border.</li>
              </ul><br />

              <h2>4. Active and Disabled Buttons</h2>
              <p>You can add active and disabled states to buttons:</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<button class="btn btn-primary active">Active Button</button>
        <button class="btn btn-primary" disabled>Disabled Button</button>`}
                </code>
              </pre>
              <ul>
                <li><strong>.active</strong>: Indicates the active state.</li><br />
                <li><strong>disabled</strong>: Adds a disabled state to the button, making it unclickable.</li>
              </ul><br />

              <h2>5. Button with Icons</h2>
              <p>You can easily add icons to buttons using icon libraries like Font Awesome or Bootstrap Icons:</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<button class="btn btn-primary">
          <i class="fa fa-thumbs-up"></i> Like
        </button>
        <button class="btn btn-danger">
          <i class="bi bi-trash"></i> Delete
        </button>`}
                </code>
              </pre>
              <ul>
                <li><strong>&lt;i class="fa fa-*"&gt;</strong>: Font Awesome icons (you need to include the Font Awesome library).</li><br />
                <li><strong>&lt;i class="bi bi-*"&gt;</strong>: Bootstrap Icons (you need to include the Bootstrap Icons library).</li>
              </ul><br />

              <h2>6. Block Level Buttons</h2>
              <p>To make buttons full-width, you can use the <code>.btn-block</code> class:</p>
                 <pre className={style.codeoverflow}>
                <code>{`<button class="btn btn-primary btn-block">Full Width Button</button>`}</code>
              </pre>
              <ul>
                <li><strong>.btn-block</strong>: Makes the button span the entire width of its parent container.</li>
              </ul><br />

              <h2>7. Button Group</h2>
              <p>To group buttons together in a row, use the <code>.btn-group</code> class:</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="btn-group">
          <button class="btn btn-primary">Button 1</button>
          <button class="btn btn-primary">Button 2</button>
          <button class="btn btn-primary">Button 3</button>
        </div>`}
                </code>
              </pre>
              <ul>
                <li><strong>.btn-group</strong>: Groups buttons into a single line, typically used for actions that share the same context.</li><br />
              </ul>

              <h2>8. Toggle Button</h2>
              <p>You can create a toggle button (for switch-like behavior) with Bootstrap:</p>
                 <pre className={style.codeoverflow}>
                <code>{`<button class="btn btn-primary" data-toggle="button" aria-pressed="false" autocomplete="off">
        Toggle Button
      </button>`}</code>
              </pre>
              <ul>
                <li><strong>data-toggle="button"</strong>: Makes the button act like a toggle, changing states when clicked.</li>
              </ul><br />

              <h2>Example: Complete Button Section</h2>
              <p>Here’s an example of a section showcasing different types of Bootstrap buttons:</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="container mt-5">
          <h2>Bootstrap Buttons Example</h2>
          
          <button class="btn btn-primary">Primary Button</button>
          <button class="btn btn-secondary">Secondary Button</button>
          <button class="btn btn-success">Success Button</button>
          <button class="btn btn-danger">Danger Button</button>
          <button class="btn btn-warning">Warning Button</button>
          <button class="btn btn-info">Info Button</button>
          <button class="btn btn-light">Light Button</button>
          <button class="btn btn-dark">Dark Button</button>
          <button class="btn btn-link">Link Button</button>

      
          <button class="btn btn-primary btn-lg">Large Button</button>
          <button class="btn btn-primary">Default Button</button>
          <button class="btn btn-primary btn-sm">Small Button</button>

        
          
          <button class="btn btn-outline-primary">Primary Outline Button</button>
          <button class="btn btn-outline-secondary">Secondary Outline Button</button>
          
      
          
          <div class="btn-group">
            <button class="btn btn-primary">Button 1</button>
            <button class="btn btn-primary">Button 2</button>
            <button class="btn btn-primary">Button 3</button>
          </div>
        </div>`}
                </code>
              </pre><br />

              <h2>Conclusion</h2>
              <p>Bootstrap’s button classes offer a fast way to create attractive, responsive buttons with minimal code. You can control button sizes, colors, outlines, and states like active and disabled with simple utility classes. Customize further by adding icons or grouping buttons for more advanced UI interactions.</p>
            </div>
          )}


          {selectedChapter === 'chapter53' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>CSS Forms</h1>

              <p>
                In Bootstrap, forms are styled with CSS classes that provide responsive layouts, consistent styling, and a user-friendly experience. This guide covers working with <strong>Forms in CSS</strong> using Bootstrap, including various types of forms, form controls, and utilities.
              </p>
              <br />

              <h3>1. Basic Form Structure</h3>
              <p>
                Bootstrap provides a basic form structure with predefined classes like <code>form-group</code>, <code>form-control</code>, and <code>btn</code>. Below is an example of a simple form with email and password inputs:
              </p>

                 <pre className={style.codeoverflow}><code>
                {`<form>
  <div class="form-group">
    <label for="email">Email address</label>
    <input type="email" class="form-control" id="email" placeholder="Enter email">
  </div>
  <div class="form-group">
    <label for="password">Password</label>
    <input type="password" class="form-control" id="password" placeholder="Password">
  </div>
  <button type="submit" class="btn btn-primary">Submit</button>
</form>`}
              </code></pre>

              <p><strong>.form-group</strong>: A wrapper that adds spacing between form elements.</p><br />
              <p><strong>.form-control</strong>: Applies consistent styling to form controls like <code>&lt;input&gt;</code>, <code>&lt;select&gt;</code>, and <code>&lt;textarea&gt;</code>.</p><br />
              <p><strong>.btn</strong>: Styles buttons with consistent design.</p>
              <br />

              <h3>2. Form Control Types</h3>
              <p>Bootstrap supports several types of form controls that can be styled:</p>

              <ul>
                <li><strong>Text Inputs</strong>
                     <pre className={style.codeoverflow}><code>
                    {`<div class="form-group">
    <label for="username">Username</label>
    <input type="text" class="form-control" id="username" placeholder="Enter username">
  </div>`}
                  </code></pre>
                </li><br />

                <li><strong>Select Dropdown</strong>
                     <pre className={style.codeoverflow}><code>
                    {`<div class="form-group">
    <label for="selectOption">Select Option</label>
    <select class="form-control" id="selectOption">
      <option>Option 1</option>
      <option>Option 2</option>
      <option>Option 3</option>
    </select>
  </div>`}
                  </code></pre>
                </li><br />

                <li><strong>Textarea</strong>
                     <pre className={style.codeoverflow}><code>
                    {`<div class="form-group">
    <label for="message">Message</label>
    <textarea class="form-control" id="message" rows="4" placeholder="Enter your message"></textarea>
  </div>`}
                  </code></pre>
                </li>
              </ul>
              <br />

              <h3>3. Input Sizing</h3>
              <p>Adjust the size of your input elements using classes like <code>form-control-sm</code> for smaller inputs and <code>form-control-lg</code> for larger ones.</p>

                 <pre className={style.codeoverflow}><code>
                {`<div class="form-group">
  <label for="smallInput">Small Input</label>
  <input type="text" class="form-control form-control-sm" id="smallInput" placeholder="Small input">
</div>

<div class="form-group">
  <label for="largeInput">Large Input</label>
  <input type="text" class="form-control form-control-lg" id="largeInput" placeholder="Large input">
</div>`}
              </code></pre>

              <p><strong>.form-control-sm</strong>: Small input field.</p><br />
              <p><strong>.form-control-lg</strong>: Large input field.</p>
              <br />

              <h3>4. Form Validation Styles</h3>
              <p style={{ paddingBottom: "6px" }}>Bootstrap provides built-in classes for form validation feedback. Use <code>is-valid</code> and <code>is-invalid</code> to display valid or invalid states for inputs.</p>

              <h4>Example: Invalid Form Control</h4>
                 <pre className={style.codeoverflow}><code>
                {`<form>
  <div class="form-group">
    <label for="email">Email address</label>
    <input type="email" class="form-control is-invalid" id="email" placeholder="Enter email">
    <div class="invalid-feedback">
      Please provide a valid email.
    </div>
  </div>
  <button type="submit" class="btn btn-primary">Submit</button>
</form>`}
              </code></pre>

              <p><strong>.is-invalid</strong>: Applies a red border to the input to indicate invalid input.</p><br />
              <p><strong>.invalid-feedback</strong>: Displays an error message below the invalid input.</p><br />

              <h4>Example: Valid Form Control</h4>
                 <pre className={style.codeoverflow}><code>
                {`<form>
  <div class="form-group">
    <label for="email">Email address</label>
    <input type="email" class="form-control is-valid" id="email" placeholder="Enter email">
    <div class="valid-feedback">
      Looks good!
    </div>
  </div>
  <button type="submit" class="btn btn-primary">Submit</button>
</form>`}
              </code></pre>

              <p><strong>.is-valid</strong>: Applies a green border to indicate valid input.</p><br />
              <p><strong>.valid-feedback</strong>: Displays a success message.</p>

              <br />

              <h3>5. Custom Forms</h3>
              <p style={{ paddingBottom: "6px" }}>Bootstrap offers custom styles for form elements like checkboxes, radio buttons, and file inputs using <code>.custom-control</code> classes.</p>

              <h4>Custom Checkboxes and Radio Buttons</h4>
                 <pre className={style.codeoverflow}><code>
                {`<div class="form-check">
  <input class="form-check-input" type="checkbox" id="customCheck1">
  <label class="form-check-label" for="customCheck1">Check this box</label>
</div>

<div class="form-check">
  <input class="form-check-input" type="radio" name="options" id="option1" checked>
  <label class="form-check-label" for="option1">Option 1</label>
</div>`}
              </code></pre>

              <p><strong>.form-check</strong>: A wrapper for checkboxes and radio buttons.</p><br />
              <p><strong>.form-check-input</strong>: Styles the checkbox or radio button.</p><br />
              <p><strong>.form-check-label</strong>: Styles the label for the input.</p><br />

              <h4>Custom File Input</h4>
                 <pre className={style.codeoverflow}><code>
                {`<div class="form-group">
  <label for="fileInput">File input</label>
  <input type="file" class="form-control-file" id="fileInput">
</div>`}
              </code></pre>

              <p><strong>.form-control-file</strong>: Applies custom styles to file input fields.</p>

              <br />

              <h3>6. Inline Forms</h3>
              <p>The <code>.form-inline</code> class arranges form controls horizontally, useful for compact forms.</p>

                 <pre className={style.codeoverflow}><code>
                {`<form class="form-inline">
  <label class="sr-only" for="inlineFormInputName">Name</label>
  <input type="text" class="form-control mb-2 mr-sm-2" id="inlineFormInputName" placeholder="Jane Doe">

  <label class="sr-only" for="inlineFormInputEmail">Email</label>
  <input type="email" class="form-control mb-2 mr-sm-2" id="inlineFormInputEmail" placeholder="jane@example.com">

  <button type="submit" class="btn btn-primary mb-2">Submit</button>
</form>`}
              </code></pre>

              <p><strong>.form-inline</strong>: Aligns form controls horizontally.</p><br />
              <p><strong>.mb-2</strong>: Adds bottom margin to form controls.</p><br />
              <p><strong>.mr-sm-2</strong>: Adds right margin to form controls.</p>

              <br />

              <h3>7. Grid Layout for Forms</h3>
              <p>Use Bootstrap's grid system to create multi-column forms with classes like <code>.col-md-6</code> for equal-width columns.</p>

                 <pre className={style.codeoverflow}><code>
                {`<form>
  <div class="form-row">
    <div class="form-group col-md-6">
      <label for="firstName">First Name</label>
      <input type="text" class="form-control" id="firstName" placeholder="First name">
    </div>
    <div class="form-group col-md-6">
      <label for="lastName">Last Name</label>
      <input type="text" class="form-control" id="lastName" placeholder="Last name">
    </div>
  </div>
  <button type="submit" class="btn btn-primary">Submit</button>
</form>`}
              </code></pre>

              <p><strong>.form-row</strong>: A row within a form for grouping columns.</p><br />
              <p><strong>.col-md-6</strong>: Creates equal-width columns on medium devices and above.</p>
            </div>
          )}


          {selectedChapter === 'chapter54' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}> CSS Helpers</h1>

              <p>
                Bootstrap provides a set of CSS helper classes that can make development faster and more efficient by providing pre-designed, reusable classes for common tasks. These helper classes are small utility classes that can quickly modify the appearance of elements without the need for custom CSS. Here are some of the common categories of helper classes available in Bootstrap:
              </p><br />

              <h2>1. Spacing Helpers</h2>
              <p>These classes help with controlling the spacing (margin and padding) of elements.</p>
              <ul>
                <li><strong>Margin Classes:</strong>
                  <ul>
                    <li><code>{`m-{side}-{size}`}</code>: Sets margin for all sides (<code>m-3</code> for 1rem margin, etc.)</li><br />
                    <li><code>{`mt-{size}`}</code>: Margin top (e.g., <code>mt-2</code>)</li><br />
                    <li><code>{`mr-{size}`}</code>: Margin right (e.g., <code>mr-3</code>)</li><br />
                    <li><code>{`mb-{size}`}</code>: Margin bottom (e.g., <code>mb-1</code>)</li><br />
                    <li><code>{`ml-{size}`}</code>: Margin left (e.g., <code>ml-4</code>)</li><br />
                    <li><code>{`mx-{size}`}</code>: Horizontal margin (left and right)</li><br />
                    <li><code>{`my-{size}`}</code>: Vertical margin (top and bottom)</li>
                  </ul>
                </li><br />

                <li><strong>Padding Classes:</strong>
                  <ul>
                    <li><code>{`p-{side}-{size}`}</code>: Sets padding for all sides (<code>p-3</code>)</li><br />
                    <li><code>{`pt-{size}`}</code>: Padding top (e.g., <code>pt-3</code>)</li><br />
                    <li><code>{`pr-{size}`}</code>: Padding right (e.g., <code>pr-4</code>)</li><br />
                    <li><code>{`pb-{size}`}</code>: Padding bottom (e.g., <code>pb-2</code>)</li><br />
                    <li><code>{`pl-{size}`}</code>: Padding left (e.g., <code>pl-1</code>)</li><br />
                    <li><code>{`px-{size}`}</code>: Horizontal padding (left and right)</li><br />
                    <li><code>{`py-{size}`}</code>: Vertical padding (top and bottom)</li>
                  </ul>
                </li>
              </ul><br />

              <h2>2. Text Helpers</h2>
              <p>These classes help you style text elements easily.</p>
              <ul>
                <li><code>{`text-{alignment}`}</code>: Text alignment (e.g., <code>text-center</code>, <code>text-right</code>, <code>text-left</code>)</li><br />
                <li><code>{`text-{color}`}</code>: Text color (e.g., <code>text-primary</code>, <code>text-success</code>, <code>text-muted</code>)</li><br />
                <li><code>{`font-weight-{value}`}</code>: Font weight (e.g., <code>font-weight-bold</code>, <code>font-weight-light</code>)</li><br />
                <li><code>{`text-decoration-{value}`}</code>: Text decoration (e.g., <code>text-decoration-underline</code>)</li><br />
                <li><code>{`text-{transform}`}</code>: Text transformation (e.g., <code>text-uppercase</code>, <code>text-lowercase</code>)</li>
              </ul><br />

              <h2>3. Display Helpers</h2>
              <p>These classes control the display properties of elements.</p>
              <ul>
                <li><code>{`d-{value}`}</code>: Controls the display type (e.g., <code>d-block</code>, <code>d-inline</code>, <code>d-none</code>)</li><br />
                <li><code>{`d-{breakpoint}-{value}`}</code>: Control the display based on breakpoints (e.g., <code>d-md-none</code>)</li>
              </ul><br />

              <h2>4. Visibility Helpers</h2>
              <p>Bootstrap offers visibility helpers for controlling whether an element is visible or not.</p>
              <ul>
                <li><code>visible</code> / <code>invisible</code>: Toggles visibility</li><br />
                <li><code>{`d-{value}`}</code> and <code>{`d-{breakpoint}-{value}`}</code> can also control visibility</li>
              </ul><br />

              <h2>5. Flexbox Helpers</h2>
              <p>Bootstrap includes several classes to work with the Flexbox layout system.</p>
              <ul>
                <li><code>d-flex</code>: Makes an element a flex container.</li><br />
                <li><code>{`justify-content-{alignment}`}</code>: Aligns children along the main axis (e.g., <code>justify-content-center</code>)</li><br />
                <li><code>{`align-items-{alignment}`}</code>: Aligns children along the cross axis (e.g., <code>align-items-center</code>)</li><br />
                <li><code>{`flex-{direction}`}</code>: Controls the direction of flex items (e.g., <code>{`flex-row`}</code>, <code>flex-column</code>)</li><br />
                <li><code>{`flex-{wrap}`}</code>: Controls wrapping behavior (e.g., <code>flex-wrap</code>, <code>flex-nowrap</code>)</li>
              </ul><br />

              <h2>6. Borders Helpers</h2>
              <p>Control borders of elements using these classes:</p>
              <ul>
                <li><code>border</code>: Adds a border on all sides.</li><br />
                <li><code>{`border-{side}`}</code>: Border on a specific side (e.g., <code>border-top</code>, <code>border-left</code>)</li><br />
                <li><code>{`border-{color}`}</code>: Border color (e.g., <code>border-primary</code>, <code>border-secondary</code>)</li><br />
                <li><code>rounded</code>: Adds rounded corners.</li><br />
                <li><code>{`rounded-{size}`}</code>: Specifies the size of the rounded corners (e.g., <code>rounded-sm</code>, <code>rounded-lg</code>)</li>
              </ul><br />

              <h2>7. Positioning Helpers</h2>
              <p>These classes help in controlling the position of an element.</p>
              <ul>
                <li><code>{`position-{value}</code>: Sets the position property (e.g., <code>position-relative `}</code>, <code>{`position-fixed)`}</code></li><br />
                <li><code>{`top-{value}</code>, <code>right-{value}</code>, <code>bottom-{value}`}</code>, <code>{`left-{value}`}</code>: Position along axes (e.g., <code>top-0</code>)</li><br />
                <li><code>{`z-index-{value}`}</code>: Controls stacking order  <code>{`(e.g.,z-index-10)`}</code></li>
              </ul><br />

              <h2>8. Screen Readers</h2>
              <p>Bootstrap provides classes to hide content from the screen but keep it available for screen readers:</p>
              <ul>
                <li><code>sr-only</code>: Hides content from the screen but makes it available for screen readers.</li><br />
                <li><code>sr-only-focusable</code>: Makes screen reader text visible when the element receives focus.</li>
              </ul><br />

              <h2>9. Other Helpers</h2>
              <p>Additional helper classes for different use cases.</p>
              <ul>
                <li><strong>Shadow Classes:</strong>
                  <ul>
                    <li><code>shadow</code>: Adds a small shadow.</li><br />
                    <li><code>shadow-sm</code>: Smaller shadow.</li><br />
                    <li><code>shadow-lg</code>: Larger shadow.</li>
                  </ul>
                </li>
                <li><strong>Overflow Helpers:</strong>
                  <ul>
                    <li><code>overflow-auto</code>, <code>overflow-hidden</code>, <code>overflow-scroll</code>: Controls overflow behavior.</li>
                  </ul>
                </li>
              </ul><br />

              <p>These helper classes allow you to quickly apply common styles to elements without writing custom CSS, helping to keep your codebase clean and manageable.</p>
            </div>
          )}

          {selectedChapter === 'chapter55' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Images</h1>

              <p>Here’s a detailed explanation of how to use CSS images in Bootstrap, along with some examples to help you understand how to incorporate images effectively within your Bootstrap layout.</p><br />

              <h3>1. Basic Image with Bootstrap</h3>
              <p>Bootstrap offers an easy way to display images, where the default styles ensure they are responsive. Use the <code>.img-fluid</code> class to make images responsive.</p>
                 <pre className={style.codeoverflow}>
                <code>{`<img src="path/to/your/image.jpg" class="img-fluid" alt="Responsive image">`}</code>
              </pre>
              <p>The <code>.img-fluid</code> class makes sure the image scales with the parent container and is responsive, adjusting the size according to the screen width.</p><br />

              <h3>2. Image as a Background (CSS Approach)</h3>
              <p style={{ paddingBottom: "6px" }}>You can use CSS to set an image as the background for any Bootstrap component or section. This is commonly done with the <code>background-image</code> property in your CSS.</p>

              <h4>Example: Setting an Image as Background for a Section</h4>
                 <pre className={style.codeoverflow}>
                <code>{`<section class="bg-image">
  <h1 class="text-center text-white">Welcome to My Website</h1>
</section>`}</code>
              </pre>
                 <pre className={style.codeoverflow}>
                <code>{`/* CSS */
.bg-image {
  background-image: url('path/to/your/image.jpg');
  background-size: cover;  /* Ensures the background covers the full section */
  background-position: center;  /* Centers the background */
  height: 300px;  /* Adjust the height based on your needs */
}`}</code>
              </pre>
              <p>This method is useful for creating visually rich sections with images as backgrounds, while still maintaining responsiveness.</p><br />

              <h3>3. Rounded and Circular Images</h3>
              <p style={{ paddingBottom: "6px" }}>Bootstrap provides utility classes to easily make images rounded or circular, which is very common in profile picture designs.</p>

              <h4>Example: Rounded Image</h4>
                 <pre className={style.codeoverflow}>
                <code>{`<img src="path/to/your/image.jpg" class="img-fluid rounded" alt="Rounded Image">`}</code>
              </pre>
              <h4>Example: Circular Image</h4>
                 <pre className={style.codeoverflow}>
                <code>{`<img src="path/to/your/image.jpg" class="img-fluid rounded-circle" alt="Circular Image">`}</code>
              </pre><br />

              <h3>4. Images in Bootstrap Grid System</h3>
              <p>You can place images inside the Bootstrap grid system to ensure that they are aligned properly and maintain responsiveness across different screen sizes.</p>
                 <pre className={style.codeoverflow}>
                <code>{`<div class="container">
  <div class="row">
    <div class="col-md-6">
      <img src="path/to/your/image.jpg" class="img-fluid" alt="Image in Grid">
    </div>
    <div class="col-md-6">
      <p>This is some text next to the image.</p>
    </div>
  </div>
</div>`}</code>
              </pre>
              <p>In this example, the image will occupy half of the container on medium-sized screens and larger, and it will stack with the text on smaller screens.</p><br />

              <h3>5. Image with Overlay (CSS and Bootstrap)</h3>
              <p style={{ paddingBottom: "6px" }}>A popular design choice is to have an image with a text overlay. You can achieve this using a combination of Bootstrap's utilities and custom CSS.</p>

              <h4>Example: Image with Overlay</h4>
                 <pre className={style.codeoverflow}>
                <code>{`<div class="overlay-container">
  <img src="path/to/your/image.jpg" class="img-fluid" alt="Image with Overlay">
  <div class="overlay-text">
    <h2>Welcome to My Site</h2>
    <p>Explore the best content here!</p>
  </div>
</div>`}</code>
              </pre>
                 <pre className={style.codeoverflow}>
                <code>{`/* CSS */
.overlay-container {
  position: relative;
  width: 100%;
}

.overlay-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent black background */
  padding: 20px;
}`}</code>
              </pre>
              <p>In this example, the image is displayed with a dark overlay, and the text is centered over the image.</p><br />

              <h3>6. Image Gallery (Grid Layout with Bootstrap)</h3>
              <p>You can create a responsive image gallery using the Bootstrap grid system, which makes it easy to display images in rows and columns.</p>
                 <pre className={style.codeoverflow}>
                <code>{`<div class="container">
  <div class="row">
    <div class="col-md-4">
      <img src="path/to/your/image1.jpg" class="img-fluid" alt="Gallery Image">
    </div>
    <div class="col-md-4">
      <img src="path/to/your/image2.jpg" class="img-fluid" alt="Gallery Image">
    </div>
    <div class="col-md-4">
      <img src="path/to/your/image3.jpg" class="img-fluid" alt="Gallery Image">
    </div>
  </div>
</div>`}</code>
              </pre>
              <p>In this gallery layout, each image will be displayed in a 3-column grid on medium-sized screens and larger. On smaller screens, it will automatically adjust to a single-column layout.</p><br />

              <h3>7. Image with Caption</h3>
              <p>You can use Bootstrap's <code>.figure</code> and <code>.figure-caption</code> classes to display an image with a caption.</p>
                 <pre className={style.codeoverflow}>
                <code>{`<figure class="figure">
  <img src="path/to/your/image.jpg" class="figure-img img-fluid rounded" alt="Image with Caption">
  <figcaption class="figure-caption text-center">This is an image caption.</figcaption>
</figure>`}</code>
              </pre><br />

              <h3>Conclusion</h3>
              <p>Bootstrap provides several ways to work with images in your web pages. You can easily use images as backgrounds, style them with the grid system, and add effects like rounding and overlay text. Bootstrap's built-in classes like <code>.img-fluid</code>, <code>.rounded</code>, <code>.table</code>, and <code>.bg-image</code> make it easy to create responsive and visually appealing designs.</p>
            </div>
          )}




          {selectedChapter === 'chapter56' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Tables</h1>

              <p>
                To create tables in Bootstrap with CSS, you can leverage the powerful table styling classes provided by Bootstrap. These classes help to easily style tables and make them responsive, sortable, and more interactive. Here’s an overview of how you can use CSS tables in Bootstrap.
              </p><br />

              <h3>1. Basic Table</h3>
              <p>
                Bootstrap provides a <code>.table</code> class that automatically adds styles to your <code>&lt;table&gt;</code>. You can also use additional classes to style the table in various ways.
              </p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>CSS Tables in Bootstrap</title>
    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/css/bootstrap.min.css" rel="stylesheet">
  </head>
  <body>
    <div class="container mt-5">
      <h2>Basic Table</h2>
      <table class="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Age</th>
            <th>Country</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>John Doe</td>
            <td>28</td>
            <td>USA</td>
          </tr>
          <tr>
            <td>Jane Smith</td>
            <td>34</td>
            <td>UK</td>
          </tr>
          <tr>
            <td>Mark Lee</td>
            <td>45</td>
            <td>Canada</td>
          </tr>
        </tbody>
      </table>
    </div>
  </body>
</html>`}
                </code>
              </pre><br />

              <h3>2. Striped Rows</h3>
              <p>
                You can add striped rows for better readability using the <code>.table-striped</code> class. This will alternate the row colors for a cleaner design.
              </p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<table class="table table-striped">
  <thead>
    <tr>
      <th>Name</th>
      <th>Age</th>
      <th>Country</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>John Doe</td>
      <td>28</td>
      <td>USA</td>
    </tr>
    <tr>
      <td>Jane Smith</td>
      <td>34</td>
      <td>UK</td>
    </tr>
    <tr>
      <td>Mark Lee</td>
      <td>45</td>
      <td>Canada</td>
    </tr>
  </tbody>
</table>`}
                </code>
              </pre><br />

              <h3>3. Hoverable Rows</h3>
              <p>
                To highlight rows when the user hovers over them, you can add the <code>.table-hover</code> class.
              </p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<table class="table table-hover">
  <thead>
    <tr>
      <th>Name</th>
      <th>Age</th>
      <th>Country</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>John Doe</td>
      <td>28</td>
      <td>USA</td>
    </tr>
    <tr>
      <td>Jane Smith</td>
      <td>34</td>
      <td>UK</td>
    </tr>
    <tr>
      <td>Mark Lee</td>
      <td>45</td>
      <td>Canada</td>
    </tr>
  </tbody>
</table>`}
                </code>
              </pre><br />

              <h3>4. Bordered Table</h3>
              <p>
                To add borders to your table, you can use the <code>.table-bordered</code> class. This adds borders to all cells, including the table header and the table body.
              </p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<table class="table table-bordered">
  <thead>
    <tr>
      <th>Name</th>
      <th>Age</th>
      <th>Country</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>John Doe</td>
      <td>28</td>
      <td>USA</td>
    </tr>
    <tr>
      <td>Jane Smith</td>
      <td>34</td>
      <td>UK</td>
    </tr>
    <tr>
      <td>Mark Lee</td>
      <td>45</td>
      <td>Canada</td>
    </tr>
  </tbody>
</table>`}
                </code>
              </pre><br />

              <h3>5. Responsive Table</h3>
              <p>
                If you want your table to be scrollable horizontally on smaller screens, you can wrap it with the <code>.table-responsive</code> class. This makes the table scrollable when the viewport is smaller than the table width.
              </p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="table-responsive">
  <table class="table">
    <thead>
      <tr>
        <th>Name</th>
        <th>Age</th>
        <th>Country</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>John Doe</td>
        <td>28</td>
        <td>USA</td>
      </tr>
      <tr>
        <td>Jane Smith</td>
        <td>34</td>
        <td>UK</td>
      </tr>
      <tr>
        <td>Mark Lee</td>
        <td>45</td>
        <td>Canada</td>
      </tr>
    </tbody>
  </table>
</div>`}
                </code>
              </pre><br />

              <h3>6. Contextual Classes</h3>
              <p>
                You can also style rows or columns using contextual classes like <code>.table-primary</code>, <code>.table-success</code>, <code>.table-danger</code>, <code>.table-warning</code>, <code>.table-info</code>, <code>.table-light</code>, or <code>.table-dark</code> to provide different color themes.
              </p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<table class="table">
  <thead>
    <tr>
      <th>Name</th>
      <th>Age</th>
      <th>Country</th>
    </tr>
  </thead>
  <tbody>
    <tr class="table-primary">
      <td>John Doe</td>
      <td>28</td>
      <td>USA</td>
    </tr>
    <tr class="table-success">
      <td>Jane Smith</td>
      <td>34</td>
      <td>UK</td>
    </tr>
    <tr class="table-danger">
      <td>Mark Lee</td>
      <td>45</td>
      <td>Canada</td>
    </tr>
  </tbody>
</table>`}
                </code>
              </pre><br />

              <h3>7. Small Table</h3>
              <p>
                You can make the table smaller by using the <code>.table-sm</code> class.
              </p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<table class="table table-sm">
  <thead>
    <tr>
      <th>Name</th>
      <th>Age</th>
      <th>Country</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>John Doe</td>
      <td>28</td>
      <td>USA</td>
    </tr>
    <tr>
      <td>Jane Smith</td>
      <td>34</td>
      <td>UK</td>
    </tr>
    <tr>
      <td>Mark Lee</td>
      <td>45</td>
      <td>Canada</td>
    </tr>
  </tbody>
</table>`}
                </code>
              </pre><br />

              <h3>Full Example:</h3>
              <p>
                Here’s a full example that combines several of these features:
              </p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Responsive Bootstrap Table Example</title>
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/css/bootstrap.min.css" rel="stylesheet">
</head>
<body>
  <div class="container mt-5">
    <h2>Responsive Bootstrap Table</h2>
    <div class="table-responsive">
      <table class="table table-bordered table-striped table-hover">
        <thead>
          <tr>
            <th>Name</th>
            <th>Age</th>
            <th>Country</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>John Doe</td>
            <td>28</td>
            <td>USA</td>
          </tr>
          <tr>
            <td>Jane Smith</td>
            <td>34</td>
            <td>UK</td>
          </tr>
          <tr>
            <td>Mark Lee</td>
            <td>45</td>
            <td>Canada</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</body>
</html>`}
                </code>
              </pre>
            </div>
          )}



          {selectedChapter === 'chapter57' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Dropdown</h1>

              <p>
                In Bootstrap, you can create a dropdown menu using only CSS (without JavaScript) by utilizing `:hover` pseudo-classes and the `visibility` or `display` properties. This is useful for simple dropdowns where you don't need dynamic behavior like opening or closing on click but rather when the user hovers over the trigger element.
              </p><br />

              <h3>Basic CSS-Only Dropdown</h3>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>CSS Dropdown in Bootstrap</title>
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/css/bootstrap.min.css" rel="stylesheet">
  <style>
    .dropdown-menu {
      display: none;
    }

    .dropdown:hover .dropdown-menu {
      display: block;
    }
  </style>
</head>
<body>
  <div class="dropdown">
    <button class="btn btn-secondary dropdown-toggle" type="button">
      Dropdown button
    </button>
    <ul class="dropdown-menu">
      <li><a class="dropdown-item" href="#">Action</a></li>
      <li><a class="dropdown-item" href="#">Another action</a></li>
      <li><a class="dropdown-item" href="#">Something else here</a></li>
    </ul>
  </div>
</body>
</html>`}
                </code>
              </pre><br />

              <h4 style={{ paddingBottom: "6px" }}>Explanation:</h4>
              <ul>
                <li><strong>CSS-only Behavior:</strong> The `.dropdown-menu` is initially hidden using `display: none;`. When the `.dropdown` is hovered, the `.dropdown-menu` is displayed using `display: block;`. This is achieved with the `:hover` pseudo-class.</li><br />
                <li><strong>Bootstrap Integration:</strong> The `.dropdown` and `.dropdown-item` classes are part of Bootstrap, which provides styling for the dropdown button and items.</li>
              </ul><br />

              <h3>More Advanced Example (CSS-Only Dropdown with a Delay)</h3>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>CSS Dropdown in Bootstrap</title>
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/css/bootstrap.min.css" rel="stylesheet">
  <style>
    .dropdown-menu {
      display: none;
      opacity: 0;
      transition: opacity 0.3s ease;
    }

    .dropdown:hover .dropdown-menu {
      display: block;
      opacity: 1;
    }
  </style>
</head>
<body>
  <div class="dropdown">
    <button class="btn btn-secondary dropdown-toggle" type="button">
      Dropdown button
    </button>
    <ul class="dropdown-menu">
      <li><a class="dropdown-item" href="#">Action</a></li>
      <li><a class="dropdown-item" href="#">Another action</a></li>
      <li><a class="dropdown-item" href="#">Something else here</a></li>
    </ul>
  </div>
</body>
</html>`}
                </code>
              </pre><br />

              <h4 style={{ paddingBottom: "6px" }}>Explanation of Advanced Example:</h4>
              <ul>
                <li><strong>Smooth Transition:</strong> The `.dropdown-menu` is initially hidden (`display: none`) and has an `opacity` of `0` (invisible). When the `.dropdown` is hovered, the `.dropdown-menu` is shown (`display: block`) and its `opacity` is transitioned to `1` (fully visible) over a period of `0.3s`.</li><br />
                <li><strong>No JavaScript Required:</strong> This solution works purely with CSS, leveraging the `:hover` pseudo-class and `opacity` transitions for a smooth dropdown effect.</li>
              </ul><br />

              <h4 style={{ paddingBottom: "6px" }}>Limitations of CSS-Only Dropdowns:</h4>
              <ul>
                <li><strong>No Click-to-Toggle:</strong> With this approach, the dropdown will only open on hover, not on click. If you need the dropdown to toggle on clicks (e.g., for mobile devices or accessibility), you would need JavaScript.</li><br />
                <li><strong>No Dynamic Control:</strong> You can't dynamically control when the dropdown opens or closes, like opening on click or based on specific actions.</li>
              </ul><br />

              <p>
                For more complex behaviors, you would still need JavaScript or Bootstrap's JavaScript components, but this approach is ideal for simple hover-based dropdowns.
              </p>
            </div>
          )}

          {selectedChapter === 'chapter58' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Navs</h1>
              <p>Navs create navigational menus. They can be styled as tabs, pills, or default navbars.</p>

              <h3>1. Basic Nav</h3>
                 <pre className={style.codeoverflow}><code>{`
<ul className="nav">
  <li className="nav-item"><a className="nav-link active" href="#">Home</a></li>
  <li className="nav-item"><a className="nav-link" href="#">Features</a></li>
  <li className="nav-item"><a className="nav-link" href="#">Pricing</a></li>
</ul>
    `}</code></pre><br />

              <h3>2. Active Link</h3>
                 <pre className={style.codeoverflow}><code>{`
<ul className="nav">
  <li className="nav-item"><a className="nav-link active" href="#">Active</a></li>
  <li className="nav-item"><a className="nav-link" href="#">Link</a></li>
</ul>
    `}</code></pre><br />

              <h3>3. Pills</h3>
                 <pre className={style.codeoverflow}><code>{`
<ul className="nav nav-pills">
  <li className="nav-item"><a className="nav-link active" href="#">Home</a></li>
  <li className="nav-item"><a className="nav-link" href="#">Profile</a></li>
  <li className="nav-item"><a className="nav-link" href="#">Messages</a></li>
</ul>
    `}</code></pre><br />

              <h3>4. Tabs</h3>
                 <pre className={style.codeoverflow}><code>{`
<ul className="nav nav-tabs">
  <li className="nav-item"><a className="nav-link active" data-bs-toggle="tab" href="#home">Home</a></li>
  <li className="nav-item"><a className="nav-link" data-bs-toggle="tab" href="#profile">Profile</a></li>
  <li className="nav-item"><a className="nav-link" data-bs-toggle="tab" href="#contact">Contact</a></li>
</ul>
<div className="tab-content">
  <div className="tab-pane fade show active" id="home">Home Content</div>
  <div className="tab-pane fade" id="profile">Profile Content</div>
  <div className="tab-pane fade" id="contact">Contact Content</div>
</div>
    `}</code></pre><br />

              <h3>5. Justified</h3>
                 <pre className={style.codeoverflow}><code>{`
<ul className="nav nav-justified">
  <li className="nav-item"><a className="nav-link active" href="#">Home</a></li>
  <li className="nav-item"><a className="nav-link" href="#">Features</a></li>
  <li className="nav-item"><a className="nav-link" href="#">Pricing</a></li>
</ul>
    `}</code></pre><br />

              <h3>6. Vertical</h3>
                 <pre className={style.codeoverflow}><code>{`
<ul className="nav flex-column">
  <li className="nav-item"><a className="nav-link active" href="#">Home</a></li>
  <li className="nav-item"><a className="nav-link" href="#">Features</a></li>
  <li className="nav-item"><a className="nav-link" href="#">Pricing</a></li>
</ul>
    `}</code></pre><br />

              <h3>7. Disabled</h3>
                 <pre className={style.codeoverflow}><code>{`
<ul className="nav">
  <li className="nav-item"><a className="nav-link active" href="#">Active</a></li>
  <li className="nav-item"><a className="nav-link disabled" href="#" tabindex="-1" aria-disabled="true">Disabled</a></li>
</ul>
    `}</code></pre>
            </div>
          )}


          {selectedChapter === 'chapter59' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Glyphicons</h1>

              <p>
                Glyphicons are a set of iconic web fonts that were included in Bootstrap 3,
                but Bootstrap 4 and newer versions have removed support for Glyphicons.
                Instead, they recommend using other icon libraries, such as
                <a href="https://fontawesome.com/" target="_blank" rel="noopener noreferrer">Font Awesome</a>
                or <a href="https://icons.getbootstrap.com/" target="_blank" rel="noopener noreferrer">Bootstrap Icons</a>,
                for better flexibility and customization.
              </p>

              <p>
                However, if you're working with Bootstrap 3 or still want to use Glyphicons in a Bootstrap 4+ project,
                you can include them separately. Here's how you can use Glyphicons in Bootstrap 3 and how to use an alternative icon set with Bootstrap 4 or 5.
              </p><br />

              <h2>1. Using Glyphicons in Bootstrap 3</h2>
              <p>
                In Bootstrap 3, Glyphicons were built-in and could be added using the <code>glyphicon</code> class.
                Here's how to use them:
              </p>
                 <pre className={style.codeoverflow}>
                <code>
                  {'<!-- Home Icon -->\n'}
                  {'<span class="glyphicon glyphicon-home" aria-hidden="true"></span>\n'}
                  {'\n'}
                  {'<!-- Search Icon -->\n'}
                  {'<span class="glyphicon glyphicon-search" aria-hidden="true"></span>\n'}
                  {'\n'}
                  {'<!-- User Icon -->\n'}
                  {'<span class="glyphicon glyphicon-user" aria-hidden="true"></span>\n'}
                </code>
              </pre><br />

              <h2>2. Using Icons in Bootstrap 4 or 5 (Alternative to Glyphicons)</h2>
              <p style={{ paddingBottom: "6px" }}>
                Since Bootstrap 4 and 5 no longer include Glyphicons by default,
                you can use other popular icon libraries like Font Awesome or Bootstrap Icons.
              </p>

              <h3>Option A: Using Bootstrap Icons</h3>
              <p style={{ paddingBottom: "6px" }}>
                You can use
                <a href="https://icons.getbootstrap.com/" target="_blank" rel="noopener noreferrer">Bootstrap Icons</a>,
                which is now maintained by the same team that created Bootstrap.
              </p>

              <h4>To use Bootstrap Icons:</h4>
              <ol>
                <li>
                  <strong>Include Bootstrap Icons via CDN:</strong>
                     <pre className={style.codeoverflow}>
                    <code>
                      {'<link href="https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css" rel="stylesheet">'}
                    </code>
                  </pre>
                </li><br />
                <li>
                  <strong>Use Icons in HTML:</strong>
                     <pre className={style.codeoverflow}>
                    <code>
                      {'<i class="bi bi-house-door"></i>'}\n
                      {'<i class="bi bi-search"></i>'}\n
                      {'<i class="bi bi-person"></i>'}
                    </code>
                  </pre>
                </li>
              </ol><br />

              <h3>Option B: Using Font Awesome Icons</h3>
              <p style={{ paddingBottom: "6px" }}>
                Another popular alternative is Font Awesome. Here's how you can include and use it.
              </p>

              <h4>To use Font Awesome:</h4>
              <ol>
                <li>
                  <strong>Include Font Awesome via CDN:</strong>
                     <pre className={style.codeoverflow}>
                    <code>
                      {'<link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css" rel="stylesheet">'}
                    </code>
                  </pre>
                </li>
                <li>
                  <strong>Use Icons in HTML:</strong>
                     <pre className={style.codeoverflow}>
                    <code>
                      {'<i class="fas fa-home"></i>'}\n
                      {'<i class="fas fa-search"></i>'}\n
                      {'<i class="fas fa-user"></i>'}
                    </code>
                  </pre>
                </li>
              </ol><br />

              <h3>Option C: Using SVG or Icon Fonts Locally</h3>
              <p>
                You can also download icon sets like Font Awesome or Bootstrap Icons and host them locally within your project.
              </p>
              <ul>
                <li>
                  <strong>Download Font Awesome:</strong>
                  <a href="https://fontawesome.com/download" target="_blank" rel="noopener noreferrer">Font Awesome Download</a>
                </li><br />
                <li>
                  <strong>Download Bootstrap Icons:</strong>
                  <a href="https://github.com/twbs/icons" target="_blank" rel="noopener noreferrer">Bootstrap Icons Download</a>
                </li>
              </ul><br />

              <h2>Conclusion</h2>
              <p>
                - Bootstrap 3 comes with built-in Glyphicons which are easy to use by adding the <code>glyphicon</code> class.
              </p>
              <p>
                - Bootstrap 4 and 5 no longer support Glyphicons, but you can easily use alternatives like
                <a href="https://icons.getbootstrap.com/" target="_blank" rel="noopener noreferrer">Bootstrap Icons</a>
                or <a href="https://fontawesome.com/" target="_blank" rel="noopener noreferrer">Font Awesome</a>.
              </p>
            </div>
          )}


          {selectedChapter === 'chapter60' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Affix</h1>

              <p>
                In Bootstrap, the <strong>Affix</strong> plugin was used in earlier versions (Bootstrap 3) to create elements that would "stick" to the top of the viewport as the user scrolls down the page, providing a sticky navigation effect. However, starting from <strong>Bootstrap 4</strong>, the Affix plugin has been removed, and its functionality is generally replaced by <strong>CSS `position: sticky`</strong> and JavaScript solutions.
              </p><br />

              <h2>Affix in Bootstrap 3</h2>
              <p style={{ paddingBottom: "6px" }}>
                In <strong>Bootstrap 3</strong>, you could use the Affix plugin to make elements sticky. Here's how it was typically used:
              </p>

              <h3>HTML Structure</h3>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<div data-spy="affix" data-offset-top="50" class="affix-element">
  <p>This element will stick to the top when you scroll.</p>
</div>`}
                </code>
              </pre><br />

              <h3>JavaScript (Bootstrap 3)</h3>
                 <pre className={style.codeoverflow}>
                <code>
                  {`$('.affix-element').affix({
  offset: {
    top: 50,  // The element will become affixed when the top of the window is 50px from the element
    bottom: 200  // The element will un-affix after scrolling 200px from the bottom of the window
  }
});`}
                </code>
              </pre>

              <p>
                In this case, the <code>data-spy="affix"</code> attribute and <code>data-offset-top</code> helped to determine when the element should become fixed at the top of the screen.
              </p><br />

              <h2>Replacing Affix in Bootstrap 4 and Beyond</h2>
              <p style={{ paddingBottom: "6px" }}>
                Since <strong>Bootstrap 4</strong> has removed the Affix plugin, you'll need to use <strong>CSS</strong> and <strong>JavaScript</strong> alternatives to replicate this behavior. The modern approach uses <code>position: sticky</code> in CSS or custom JavaScript solutions.
              </p>

              <h3>Example Using <code>position: sticky</code> (CSS)</h3>
              <p style={{ paddingBottom: "6px" }}>
                For sticky elements in Bootstrap 4 and newer, you can use the <code>position: sticky</code> CSS property, which works natively in modern browsers.
              </p>

              <h4>HTML</h4>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="sticky-top">
  <p>This element will stick to the top of the viewport when you scroll down.</p>
</div>`}
                </code>
              </pre><br />

              <h4>Explanation</h4>
              <ul>
                <li><strong>.sticky-top</strong>: This is a Bootstrap utility class that applies <code>position: sticky</code> with <code>top: 0</code> to the element, making it stick to the top of the viewport when you scroll past it.</li>
              </ul>
              <p>
                This is a more straightforward and performant approach to achieving the "affix" effect without the need for JavaScript.
              </p><br />

              <h3>Example Using JavaScript for Sticky Elements (Without Bootstrap)</h3>
              <p style={{ paddingBottom: "6px" }}>
                If you prefer a JavaScript solution or need more complex behavior, here’s how you can implement a sticky element with plain JavaScript:
              </p>

              <h4>HTML</h4>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<div id="sticky-element">
  <p>This element will stick to the top when you scroll.</p>
</div>`}
                </code>
              </pre><br />

              <h4>CSS</h4>
                 <pre className={style.codeoverflow}>
                <code>
                  {`#sticky-element {
  position: relative; /* Default position */
  top: 0;
}
.sticky {
  position: fixed;
  top: 0;
}`}
                </code>
              </pre><br />

              <h4>JavaScript</h4>
                 <pre className={style.codeoverflow}>
                <code>
                  {`window.onscroll = function() {stickFunction()};

var stickyElement = document.getElementById("sticky-element");
var sticky = stickyElement.offsetTop;

function stickFunction() {
  if (window.pageYOffset > sticky) {
    stickyElement.classList.add("sticky");
  } else {
    stickyElement.classList.remove("sticky");
  }
}`}
                </code>
              </pre><br />

              <h2 style={{ paddingBottom: "6px" }}>Conclusion</h2>
              <ul>
                <li><strong>Bootstrap 3</strong> had the <code>affix</code> plugin for sticky behavior, but it’s no longer available in <strong>Bootstrap 4+</strong>.</li><br />
                <li>For modern versions of Bootstrap, you can achieve a sticky effect using <strong>CSS `position: sticky`</strong> with the <code>.sticky-top</code> class.</li><br />
                <li>If you need more control, a <strong>JavaScript solution</strong> can be implemented.</li>
              </ul><br />

              <p>
                This approach is both simpler and more reliable across modern browsers compared to the old Affix plugin.
              </p>
            </div>
          )}


          {selectedChapter === 'chapter61' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Alert</h1>

              <p>Alerts are used to provide feedback messages to users. They can be dismissible or static.</p>

              <h3>1. Basic Alert</h3>
                 <pre className={style.codeoverflow}><code>{`
<div className="alert alert-primary" role="alert">
  This is a primary alert—check it out!
</div>
    `}</code></pre><br />

              <h3>2. Dismissible Alert</h3>
              <p>Use the <code>data-bs-dismiss="alert"</code> attribute to make alerts dismissible.</p>
                 <pre className={style.codeoverflow}><code>{`
<div className="alert alert-success alert-dismissible fade show" role="alert">
  This is a dismissible alert.
  <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
</div>
    `}</code></pre><br />

              <h3>3. Alert Variants</h3>
              <p>Alerts come in various colors: primary, secondary, success, danger, warning, info, light, and dark.</p>
                 <pre className={style.codeoverflow}><code>{`
<div className="alert alert-danger" role="alert">
  This is a danger alert!
</div>
<div className="alert alert-warning" role="alert">
  This is a warning alert!
</div>
    `}</code></pre><br />

              <h3>4. Auto Dismiss Alert</h3>
              <p>Alerts can be automatically dismissed after a set period using JavaScript.</p>
                 <pre className={style.codeoverflow}><code>{`
setTimeout(function() {
  const alert = document.querySelector('.alert');
  alert.classList.remove('show');
}, 5000);  // Dismiss after 5 seconds
    `}</code></pre>



            </div>
          )}


          {selectedChapter === 'chapter62' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Button</h1>
              <p>Bootstrap buttons are styled with CSS but enhanced with JavaScript for dynamic functionality like toggling states and triggering actions.</p><br />

              <h3>1. Basic Button</h3>
                 <pre className={style.codeoverflow}><code>{`<button type="button" class="btn btn-primary">Primary Button</button>`}</code></pre><br />

              <h3>2. Button States & Toggles</h3>
              <p>Use JavaScript to toggle button states like active or loading.</p>
                 <pre className={style.codeoverflow}><code>
                {`<button type="button" class="btn btn-primary" id="toggleButton">Toggle</button>
<script>
  document.getElementById("toggleButton").addEventListener("click", function () {
    this.classList.toggle("active");
  });
</script>`}
              </code></pre><br />

              <h3>3. Button Group</h3>
                 <pre className={style.codeoverflow}><code>{`
<div class="btn-group" role="group">
  <button class="btn btn-primary">Left</button>
  <button class="btn btn-primary">Middle</button>
  <button class="btn btn-primary">Right</button>
</div>`}</code></pre><br />

              <h3>4. JavaScript API</h3>
                 <pre className={style.codeoverflow}><code>{`
<div class="btn-group">
  <button class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown">Dropdown</button>
  <ul class="dropdown-menu">
    <li><a class="dropdown-item" href="#">Action</a></li>
  </ul>
</div>`}</code></pre><br />

              <h3>5. JavaScript Button Features</h3>
              <p>Buttons can trigger modals, tooltips, and popovers.</p>
                 <pre className={style.codeoverflow}><code>{`
<button type="button" class="btn btn-info" data-bs-toggle="tooltip" title="Tooltip on top">Hover me</button>
<script>
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  tooltipTriggerList.map(function (tooltipTriggerEl) {
    new bootstrap.Tooltip(tooltipTriggerEl);
  });
</script>`}</code></pre><br />

              <p>JavaScript enhances Bootstrap buttons for interactivity, making them dynamic and versatile.</p>
            </div>
          )}

          {selectedChapter === 'chapter63' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Carousel</h1>

              <p>
                The <strong>Bootstrap JavaScript Reference</strong> for the <strong>Carousel</strong> component provides interactive functionality to create a slide-based image or content gallery. The Carousel uses JavaScript to allow users to control the transition between items in a sliding manner, typically used for displaying images, videos, or other content dynamically.
              </p><br />

              <h2>Carousel Structure in Bootstrap</h2>
              <p >
                To create a basic Bootstrap carousel, you need to use a combination of HTML, CSS, and JavaScript. Bootstrap provides built-in JavaScript functions for controlling carousel items, transitioning slides, and automatic cycling.
              </p><br />

              <h3>1. Basic Carousel Structure</h3>
              <p>
                The basic structure of a carousel includes a <code>div</code> container with the class <code>carousel</code>, and inside it, you will have <code>carousel-inner</code> containing <code>carousel-item</code> elements, which represent individual slides. The carousel also includes navigation controls such as previous/next buttons.
              </p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<div id="carouselExample" class="carousel slide" data-bs-ride="carousel">
  <div class="carousel-inner">
    <div class="carousel-item active">
      <img src="image1.jpg" class="d-block w-100" alt="First slide">
    </div>
    <div class="carousel-item">
      <img src="image2.jpg" class="d-block w-100" alt="Second slide">
    </div>
    <div class="carousel-item">
      <img src="image3.jpg" class="d-block w-100" alt="Third slide">
    </div>
  </div>
  <button class="carousel-control-prev" type="button" data-bs-target="#carouselExample" data-bs-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Previous</span>
  </button>
  <button class="carousel-control-next" type="button" data-bs-target="#carouselExample" data-bs-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="visually-hidden">Next</span>
  </button>
</div>`}
                </code>
              </pre><br />

              <h3>2. JavaScript for Carousel Control</h3>
              <p style={{ paddingBottom: "6px" }}>
                You can control the carousel through JavaScript to cycle through the items, pause, or start the carousel programmatically.
              </p>

              <h4>Example: Initialize Carousel with JavaScript</h4>
              <p>
                Bootstrap automatically initializes carousels that use the <code>data-bs-ride="carousel"</code> attribute. However, if you want to control the carousel with JavaScript (e.g., to programmatically start, pause, or go to a specific slide), you can use the following JavaScript API.
              </p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<script>
  // Get the carousel element
  var myCarousel = document.getElementById('carouselExample');
  
  // Initialize the Bootstrap carousel
  var carousel = new bootstrap.Carousel(myCarousel, {
    interval: 2000,  // Set the interval to 2 seconds
    ride: 'carousel' // Automatically start cycling
  });

  // Manually control the carousel
  function pauseCarousel() {
    carousel.pause();
  }

  function startCarousel() {
    carousel.cycle();
  }

  // Optionally add event listeners to buttons
  document.getElementById('pauseButton').addEventListener('click', pauseCarousel);
  document.getElementById('startButton').addEventListener('click', startCarousel);
</script>`}
                </code>
              </pre><br />

              <h3 style={{ paddingBottom: "6px" }}>3. Additional Features with JavaScript</h3>
              <h4>Example: Programmatically Sliding to a Specific Item</h4>
              <p>If you want to programmatically go to a specific slide, you can use the <code>to</code> method:</p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<script>
  // Programmatically go to the second slide (index starts from 0)
  carousel.to(1); // Move to the second slide (0 is the first)
</script>`}
                </code>
              </pre><br />

              <h4>Example: Carousel Pause and Play Buttons</h4>
              <p>You can add buttons to pause and resume the carousel's automatic sliding.</p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<button id="pauseButton" class="btn btn-warning">Pause</button>
<button id="startButton" class="btn btn-success">Start</button>`}
                </code>
              </pre><br />

              <h3>4. Event Listeners in Carousel</h3>
              <p>
                Bootstrap Carousel provides several useful events for handling user interaction. These events can be used to detect when the carousel is sliding or has slid to a new item.
              </p>
              <ul>
                <li><code>slide.bs.carousel</code>: Triggered before the slide transition.</li><br />
                <li><code>slid.bs.carousel</code>: Triggered after the slide transition.</li>
              </ul>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<script>
  myCarousel.addEventListener('slide.bs.carousel', function (event) {
    console.log('The carousel is sliding!');
  });

  myCarousel.addEventListener('slid.bs.carousel', function (event) {
    console.log('The carousel has slid!');
  });
</script>`}
                </code>
              </pre><br />

              <h3>5. Auto Sliding (Cycling)</h3>
              <p>
                By default, the carousel can automatically cycle through the slides. You can control this behavior using the <code>data-bs-ride="carousel"</code> attribute or programmatically with JavaScript.
              </p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<!-- Carousel with automatic cycling -->
<div id="carouselExample" class="carousel slide" data-bs-ride="carousel">
  <!-- Carousel items here -->
</div>`}
                </code>
              </pre>

              <p>Alternatively, using JavaScript, you can control the cycling like so:</p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`carousel.cycle(); // Start cycling through the slides
carousel.pause(); // Pause the automatic cycling`}
                </code>
              </pre><br />

              <h2>Conclusion</h2>
              <p>
                Bootstrap's Carousel component combines CSS and JavaScript to create responsive, interactive slide shows. You can customize it further by using JavaScript to control its behavior (e.g., pausing, cycling, navigating to specific slides) and adding extra features like event listeners or manual controls. With these techniques, you can make the carousel more dynamic and responsive to user interactions.
              </p>
            </div>
          )}


          {selectedChapter === 'chapter64' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Collapse</h1>

              <p>
                The <strong>Collapse</strong> component in Bootstrap provides a way to toggle between showing
                and hiding content. It can be used for things like dropdowns, accordion menus, or collapsible
                content areas.
              </p>
              <p>
                By default, the content is hidden, and you can show it by clicking on a button or link. This
                behavior is controlled using Bootstrap's JavaScript API.
              </p>

              <br />

              <h3>1. Basic Collapse Structure</h3>
              <p style={{ paddingBottom: "6px" }}>
                In Bootstrap, the <strong>Collapse</strong> component is typically used with a trigger element,
                like a button or a link, that will toggle the visibility of a target element. The target element
                is usually a <code>div</code> or another block-level element that contains the content you want to
                show or hide.
              </p>

              <h4>Example: Simple Collapse</h4>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<!-- Trigger Button -->
<button class="btn btn-primary" type="button" data-bs-toggle="collapse" 
  data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
  Toggle Collapse
</button>

<!-- Collapsible Content -->
<div class="collapse" id="collapseExample">
  <div class="card card-body">
    This is some collapsible content. Click the button above to toggle visibility.
  </div>
</div>`}
                </code>
              </pre>

              <h5 style={{ paddingBottom: "6px" }}>Explanation:</h5>
              <ul>
                <li><code>data-bs-toggle="collapse"</code>: Specifies that the button will toggle the collapse action.</li><br />
                <li><code>data-bs-target="#collapseExample"</code>: Targets the content to be shown or hidden when the button is clicked.</li><br />
                <li><code>aria-expanded</code>: Provides accessibility support, indicating whether the content is expanded or collapsed.</li><br />
                <li><code>collapse</code> class: Applied to the target <code>div</code> to enable collapsing behavior.</li>
              </ul>

              <br />

              <h3>2. JavaScript for Custom Collapse Control</h3>
              <p style={{ paddingBottom: "6px" }}>
                You can also control the collapse behavior with JavaScript, which allows more programmatic control,
                such as collapsing or expanding specific elements based on user interaction or other events.
              </p>

              <h4>Example: Initializing Collapse with JavaScript</h4>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<!-- Trigger Button -->
<button class="btn btn-primary" id="toggleCollapse" type="button">
  Toggle Collapse
</button>

<!-- Collapsible Content -->
<div class="collapse" id="collapseExample">
  <div class="card card-body">
    This is some collapsible content. Click the button above to toggle visibility.
  </div>
</div>

<script>
  var myCollapse = document.getElementById('collapseExample');
  var collapse = new bootstrap.Collapse(myCollapse, {
    toggle: false // Don't automatically toggle on page load
  });

  document.getElementById('toggleCollapse').addEventListener('click', function () {
    collapse.toggle(); // Toggle the collapse visibility
  });
</script>`}
                </code>
              </pre>

              <h5 style={{ paddingBottom: "6px" }}>Explanation:</h5>
              <ul>
                <li><code>new bootstrap.Collapse(myCollapse)</code>: Initializes the collapse functionality on the target element.</li><br />
                <li><code>collapse.toggle()</code>: Toggles the collapse state (expand or collapse) programmatically.</li>
              </ul>

              <br />

              <h3>3. Accordion Style Collapse</h3>
              <p>
                An accordion is a component where only one section can be expanded at a time. To implement this,
                you can group multiple collapse elements, ensuring that opening one will automatically close the others.
              </p>

              <h4>Example: Accordion Collapse</h4>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="accordion" id="accordionExample">
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingOne">
      <button class="accordion-button" type="button" data-bs-toggle="collapse" 
        data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
        Accordion Item #1
      </button>
    </h2>
    <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
      <div class="accordion-body">
        Content for the first item. You can expand and collapse each item.
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingTwo">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" 
        data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
        Accordion Item #2
      </button>
    </h2>
    <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
      <div class="accordion-body">
        Content for the second item.
      </div>
    </div>
  </div>
</div>`}
                </code>
              </pre>

              <h5>Explanation:</h5>
              <ul>
                <li><code>data-bs-parent="#accordionExample"</code>: Ensures only one accordion item is expanded at a time.</li>
                <li>Each item in the accordion has a button to control the collapse state of its associated content.</li>
              </ul>

              <br />

              <h3>4. Using Events with Collapse</h3>
              <p>
                Bootstrap provides several events that you can use to handle when the collapse state changes.
                These events are useful for adding extra functionality based on the collapse's state.
              </p>

              <h5>Events:</h5>
              <ul>
                <li><code>show.bs.collapse</code>: Triggered when a collapse is about to show.</li><br />
                <li><code>shown.bs.collapse</code>: Triggered when a collapse has been fully shown.</li><br />
                <li><code>hide.bs.collapse</code>: Triggered when a collapse is about to hide.</li><br />
                <li><code>hidden.bs.collapse</code>: Triggered when a collapse has been fully hidden.</li>
              </ul><br />

              <h4>Example: Using Events</h4>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<script>
  var myCollapse = document.getElementById('collapseExample');
  
  myCollapse.addEventListener('show.bs.collapse', function () {
    console.log('The collapse is about to be shown!');
  });

  myCollapse.addEventListener('shown.bs.collapse', function () {
    console.log('The collapse has been shown!');
  });

  myCollapse.addEventListener('hide.bs.collapse', function () {
    console.log('The collapse is about to be hidden!');
  });

  myCollapse.addEventListener('hidden.bs.collapse', function () {
    console.log('The collapse has been hidden!');
  });
</script>`}
                </code>
              </pre>

              <br />

              <h3>5. Programmatically Controlling Collapse</h3>
              <p>
                You can also use JavaScript methods to control the collapse component programmatically:
              </p>
              <ul>
                <li><code>collapse.show()</code>: To show the collapsible content.</li>
                <li><code>collapse.hide()</code>: To hide the collapsible content.</li>
                <li><code>collapse.toggle()</code>: To toggle the visibility between shown and hidden states.</li>
              </ul>

              <h4>Example: Programmatically Triggering Collapse</h4>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<script>
  // Show the collapse programmatically
  collapse.show();

  // Hide the collapse programmatically
  collapse.hide();
</script>`}
                </code>
              </pre>

              <br />

              <h3>Conclusion</h3>
              <p>
                The <strong>Collapse</strong> component in Bootstrap is highly versatile, allowing you to show and
                hide content with ease. It can be controlled through both HTML attributes and JavaScript, making
                it suitable for a wide range of use cases such as dropdowns, accordions, and collapsible panels.
                Using the built-in Bootstrap classes and JavaScript API, you can easily create dynamic and interactive
                elements in your web pages.
              </p>
            </div>
          )}


          {selectedChapter === 'chapter65' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Dropdown</h1>

              <p>
                The <strong>Bootstrap Dropdown</strong> component allows you to toggle a menu of links or actions in your UI.
                It can be used for navigation, actions, or displaying a set of options for the user to choose from.
              </p>   <br />

              <p>Here's a guide to using Bootstrap's dropdown component along with JavaScript control, as well as a brief explanation of key features:</p>



              <h2>1. Basic Dropdown Structure</h2>
              <p style={{ paddingBottom: "6px" }}>
                A basic dropdown in Bootstrap typically consists of a button (or link) that triggers the dropdown menu, and the menu itself which contains the items.
              </p>

              <h3>HTML Example: Basic Dropdown</h3>

                 <pre className={style.codeoverflow}>
                <code>{`
        <!-- Dropdown Button -->
        <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" 
          data-bs-toggle="dropdown" aria-expanded="false">
          Dropdown button
        </button>
        
        <!-- Dropdown Menu -->
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <li><a class="dropdown-item" href="#">Action</a></li>
          <li><a class="dropdown-item" href="#">Another action</a></li>
          <li><a class="dropdown-item" href="#">Something else here</a></li>
        </ul>
       `} </code>
              </pre><br />

              <h3 style={{ paddingBottom: "6px" }}>Key Components:</h3>
              <ul>
                <li><strong>Button</strong>: The button triggers the dropdown, and uses <code>data-bs-toggle="dropdown"</code> to indicate the dropdown behavior.</li><br />
                <li><strong>Dropdown Menu</strong>: The menu that contains the dropdown items, wrapped in <code>&lt;ul&gt;</code> tags with the class <code>dropdown-menu</code>.</li><br />
                <li><strong>Dropdown Items</strong>: Each individual item in the dropdown is a list item (<code>&lt;li&gt;</code>) containing an anchor (<code>&lt;a&gt;</code>) with the class <code>dropdown-item</code>.</li>
              </ul><br />

              <h3 style={{ paddingBottom: "6px" }}>Explanation:</h3>
              <ul>
                <li><code>aria-expanded</code>: This attribute indicates whether the dropdown menu is open (<code>true</code>) or closed (<code>false</code>).</li><br />
                <li><code>aria-labelledby</code>: Links the dropdown menu to the button, providing an accessible name to the dropdown.</li>
              </ul>

              <br />

              <h2>2. JavaScript Controlled Dropdown</h2>
              <p style={{ paddingBottom: "6px" }}>
                If you want more programmatic control, such as opening or closing the dropdown based on user interaction or other events, you can do so using the Bootstrap JavaScript API.
              </p>

              <h3>Example: Programmatically Controlling Dropdown</h3>

                 <pre className={style.codeoverflow}>
                <code>{`
        <!-- Dropdown Button -->
        <button class="btn btn-secondary" id="dropdownButton">Dropdown button</button>

        <!-- Dropdown Menu -->
        <ul class="dropdown-menu" id="dropdownMenu">
          <li><a class="dropdown-item" href="#">Action</a></li>
          <li><a class="dropdown-item" href="#">Another action</a></li>
          <li><a class="dropdown-item" href="#">Something else here</a></li>
        </ul>

        <script>
          var myDropdown = new bootstrap.Dropdown(document.getElementById('dropdownButton'));
          myDropdown.show();  // Programmatically show the dropdown
          myDropdown.hide();  // Programmatically hide the dropdown
        </script>
      `}</code>
              </pre><br />

              <h3 style={{ paddingBottom: "6px" }}>Methods:</h3>
              <ul>
                <li><code>show()</code>: This method can be called to programmatically open the dropdown menu.</li><br />
                <li><code>hide()</code>: This method can be used to close the dropdown.</li>
              </ul>
              <br />

              <h2>3. Dropdown with Submenus</h2>
              <p style={{ paddingBottom: "6px" }}>
                Bootstrap also allows you to create dropdowns with nested menus (submenus). Here’s how you can create a dropdown that includes a nested dropdown.
              </p>

              <h3>Example: Nested Dropdown</h3>

                 <pre className={style.codeoverflow}>
                <code>{`
       <!-- Dropdown Button -->
        <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" 
          data-bs-toggle="dropdown" aria-expanded="false">
          Dropdown with Submenu
        </button>
        
        <!-- Dropdown Menu with Submenu -->
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <li><a class="dropdown-item" href="#">Action</a></li>
          <li><a class="dropdown-item" href="#">Another action</a></li>

          <!-- Submenu -->
          <li class="dropdown-submenu">
            <a class="dropdown-item dropdown-toggle" href="#">More Options</a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" href="#">Submenu Action 1</a></li>
              <li><a class="dropdown-item" href="#">Submenu Action 2</a></li>
            </ul>
          </li>
        </ul>
      `}</code>
              </pre>

              <br />

              <h2>4. Customizing Dropdown Behavior with Events</h2>
              <p style={{ paddingBottom: "6px" }}>
                Bootstrap's dropdown also allows you to hook into events that occur when the dropdown is shown or hidden.
              </p>

              <h3 style={{ paddingBottom: "6px" }}>Dropdown Events:</h3>
              <ul>
                <li><code>show.bs.dropdown</code>: Triggered just before the dropdown is shown.</li><br />
                <li><code>shown.bs.dropdown</code>: Triggered after the dropdown is fully shown.</li><br />
                <li><code>hide.bs.dropdown</code>: Triggered just before the dropdown is hidden.</li><br />
                <li><code>hidden.bs.dropdown</code>: Triggered after the dropdown is fully hidden.</li>
              </ul><br />

              <h3>Example: Using Events</h3>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<script>
          var myDropdownElement = document.getElementById('dropdownButton');

          myDropdownElement.addEventListener('show.bs.dropdown', function () {
            console.log('Dropdown is about to show!');
          });

          myDropdownElement.addEventListener('shown.bs.dropdown', function () {
            console.log('Dropdown has been shown!');
          });

          myDropdownElement.addEventListener('hide.bs.dropdown', function () {
            console.log('Dropdown is about to hide!');
          });

          myDropdownElement.addEventListener('hidden.bs.dropdown', function () {
            console.log('Dropdown has been hidden!');
          });
        </script>`}
                </code>
              </pre>

              <br />

              <h2>5. Dropdown Alignment and Customization</h2>
              <p style={{ paddingBottom: "6px" }}>
                You can align the dropdown menu in different ways using utility classes like <code>dropdown-menu-end</code> or <code>dropdown-menu-start</code>.
              </p>

              <h3>Example: Right-aligned Dropdown</h3>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
          <li><a class="dropdown-item" href="#">Action</a></li>
          <li><a class="dropdown-item" href="#">Another action</a></li>
          <li><a class="dropdown-item" href="#">Something else here</a></li>
        </ul>`}
                </code>
              </pre>

              <br />

              <h2>6. Disabled Dropdown Items</h2>
              <p style={{ paddingBottom: "6px" }}>
                You can disable dropdown items by adding the <code>disabled</code> attribute to the <code>&lt;a&gt;</code> tag or <code>&lt;button&gt;</code> tag.
              </p>

              <h3>Example: Disabled Item</h3>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<a class="dropdown-item disabled" href="#">Disabled Item</a>`}
                </code>
              </pre>

              <br />

              <h2>Conclusion</h2>
              <p>
                The Bootstrap Dropdown component is a versatile tool for adding interactive menus to your interface. By combining the HTML structure with JavaScript control, you can create simple or advanced dropdown menus as per your needs.
              </p>

              <p>
                Check out the <a href="https://getbootstrap.com/docs/5.3/components/dropdowns/" target="_blank" rel="noopener noreferrer">official Bootstrap documentation</a> for more information and examples.
              </p>
            </div>
          )}


          {selectedChapter === 'chapter66' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}> Modal </h1>

              <p>
                The Bootstrap <strong>Modal</strong> component is a flexible and customizable dialog box that can be used for displaying content such as forms, alerts, or confirmation messages. It can be triggered by JavaScript or manually by user interaction (like a button click).
              </p><br />

              <p style={{ paddingBottom: "6px" }}>Here’s a comprehensive guide to using the <strong>Bootstrap Modal</strong> with HTML and JavaScript:</p>

              <h3>Basic Structure of a Modal</h3>

              <p>To create a modal, you need two main parts:</p>
              <ul style={{ paddingBottom: "6px" }}>
                <li><strong>Modal Trigger</strong>: A button or link that opens the modal.</li><br />
                <li><strong>Modal</strong>: The actual dialog box containing content.</li>
              </ul>

              <h4>1. Basic Modal Structure</h4>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<!-- Modal Trigger (Button) -->
<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
  Launch Modal
</button>

<!-- Modal Structure -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      
      <!-- Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Modal Title</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        Content goes here. You can place anything you want, like text, forms, etc.
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div>
      
    </div>
  </div>
</div>`}
                </code>
              </pre><br />

              <h4 style={{ paddingBottom: "6px" }}>Key Components:</h4>
              <ul>
                <li><code>data-bs-toggle="modal"</code>: Triggers the modal when clicked.</li><br />
                <li><code>data-bs-target="#exampleModal"</code>: Specifies the target modal to show.</li><br />
                <li><code>class="modal fade"</code>: Applies the fade animation to the modal.</li><br />
                <li><code>tabindex="-1"</code>: Ensures the modal is focusable when opened.</li><br />
                <li><code>aria-labelledby</code>: Associates the modal with an accessible title.</li><br />
                <li><code>aria-hidden="true"</code>: Hides the modal by default.</li><br />
                <li><code>btn-close</code>: Button to close the modal.</li>
              </ul><br />

              <h4>2. Modal with JavaScript Control</h4>

              <p>You can programmatically control the modal using JavaScript. Here's an example of how to show and hide the modal using JavaScript:</p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<!-- Modal Trigger Button -->
<button type="button" class="btn btn-primary" id="showModalBtn">
  Show Modal with JavaScript
</button>

<!-- Modal Structure (Same as before) -->
<div class="modal fade" id="exampleModalWithJS" tabindex="-1" aria-labelledby="exampleModalLabelWithJS" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabelWithJS">Modal with JavaScript Control</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body">
        This modal was opened using JavaScript.
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div>
      
    </div>
  </div>
</div>

<!-- JavaScript to Control Modal -->
<script>
  var myModal = new bootstrap.Modal(document.getElementById('exampleModalWithJS'));
  var showModalBtn = document.getElementById('showModalBtn');
  
  showModalBtn.addEventListener('click', function() {
    myModal.show();  // Show the modal when the button is clicked
  });
</script>`}
                </code>
              </pre><br />

              <h4 style={{ paddingBottom: "6px" }}>JavaScript Methods:</h4>
              <ul>
                <li><code>show()</code>: Opens the modal.</li><br />
                <li><code>hide()</code>: Closes the modal.</li><br />
                <li><code>toggle()</code>: Opens or closes the modal based on its current state.</li><br />
                <li><code>dispose()</code>: Destroys the modal instance.</li>
              </ul><br />

              <h4>3. Modal Events</h4>

              <p>You can hook into the modal's lifecycle events to perform actions before or after it is shown or hidden. Below is a list of common modal events:</p>
              <ul>
                <li><code>show.bs.modal</code>: Fired just before the modal is shown.</li><br />
                <li><code>shown.bs.modal</code>: Fired when the modal has been fully shown.</li><br />
                <li><code>hide.bs.modal</code>: Fired just before the modal is hidden.</li><br />
                <li><code>hidden.bs.modal</code>: Fired when the modal has been completely hidden.</li>
              </ul><br />

              <p>Here’s how you can handle these events:</p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<script>
  var modalElement = document.getElementById('exampleModal');
  var modal = new bootstrap.Modal(modalElement);

  // Show event
  modalElement.addEventListener('show.bs.modal', function () {
    console.log('Modal is about to be shown');
  });

  // Shown event
  modalElement.addEventListener('shown.bs.modal', function () {
    console.log('Modal has been shown');
  });

  // Hide event
  modalElement.addEventListener('hide.bs.modal', function () {
    console.log('Modal is about to be hidden');
  });

  // Hidden event
  modalElement.addEventListener('hidden.bs.modal', function () {
    console.log('Modal has been hidden');
  });
</script>`}
                </code>
              </pre><br />

              <h4>4. Modifying Modal Size</h4>

              <p>Bootstrap modals can be customized in terms of their size. You can use the following classes to adjust the modal's width:</p>
              <ul>
                <li><code>modal-sm</code>: For a small modal.</li><br />
                <li><code>modal-lg</code>: For a large modal.</li><br />
                <li><code>modal-dialog-centered</code>: Centers the modal vertically in the viewport.</li>
              </ul><br />

              <p>Example of a large modal:</p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="modal-dialog modal-lg">
  <!-- Modal content goes here -->
</div>`}
                </code>
              </pre><br />

              <h4>5. Scrollable Modal</h4>

              <p>If you want a modal where the content is scrollable while the header and footer remain fixed, you can add the <code>modal-dialog-scrollable</code> class to the modal dialog:</p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<div class="modal-dialog modal-dialog-scrollable">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Scrollable Modal</h5>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <!-- Long content goes here -->
      <p>Content goes here...</p>
      <p>Content goes here...</p>
      <p>Content goes here...</p>
      <!-- More content -->
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      <button type="button" class="btn btn-primary">Save changes</button>
    </div>
  </div>
</div>`}
                </code>
              </pre><br />

              <h3>Conclusion</h3>
              <p>Bootstrap modals are a powerful component for building interactive and dynamic user interfaces. You can control the behavior using both HTML attributes and JavaScript, allowing you to trigger, customize, and manipulate modals as needed. For more advanced features and options, refer to the <a href="https://getbootstrap.com/docs/5.3/components/modal/" target="_blank" rel="noopener noreferrer">official Bootstrap Modal documentation</a>.</p>
            </div>
          )}

          {selectedChapter === 'chapter67' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Popover</h1>

              <div>
                <p>
                  The Bootstrap Popover component allows you to create interactive pop-up
                  boxes for displaying additional content when the user interacts with an
                  element. They are similar to tooltips but provide more robust
                  functionality.
                </p>

                <br />

                <h2>Basic Syntax</h2>
                <p>
                  To create a popover, you use the <code>data-bs-toggle="popover"</code>{' '}
                  attribute and provide the content using <code>title</code> and{' '}
                  <code>data-bs-content</code> attributes.
                </p>

                   <pre className={style.codeoverflow}>
                  <code>
                    {`<button type="button" class="btn btn-primary" 
    data-bs-toggle="popover" 
    title="Popover Title" 
    data-bs-content="This is the popover content.">
  Click me
</button>`}
                  </code>
                </pre>

                <br />

                <h2>Initialization</h2>
                <p style={{ paddingBottom: "6px" }}>Popovers require JavaScript to function. You can initialize them in two ways:</p>

                <h3>1. Via JavaScript</h3>
                   <pre className={style.codeoverflow}>
                  <code>
                    {`var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
  return new bootstrap.Popover(popoverTriggerEl)
})`}
                  </code>
                </pre><br />

                <h3>2. Via Data Attributes</h3>
                <p>No additional JavaScript code is required when using the <code>data-bs-*</code> attributes.</p>
                <br />

                <h2>Options</h2>
                <p>You can customize popovers using JavaScript by passing options while creating them:</p>
                   <pre className={style.codeoverflow}>
                  <code>
                    {`var popover = new bootstrap.Popover(document.querySelector('.popover-button'), {
  trigger: 'hover', // Options: 'click', 'hover', 'focus', 'manual'
  placement: 'top', // Options: 'top', 'bottom', 'left', 'right'
  content: 'Custom content here',
  title: 'Custom Title'
});`}
                  </code>
                </pre>
                <br />

                <h2>Methods</h2>
                <p>Bootstrap Popovers have methods for programmatic control:</p>
                <ul>
                  <li>
                    <code>.show()</code> – Show the popover.
                  </li>
                  <li>
                    <code>.hide()</code> – Hide the popover.
                  </li>
                  <li>
                    <code>.toggle()</code> – Toggle the popover visibility.
                  </li>
                  <li>
                    <code>.dispose()</code> – Destroy the popover instance.
                  </li>
                </ul>
                   <pre className={style.codeoverflow}>
                  <code>
                    {`var popoverInstance = new bootstrap.Popover(document.querySelector('.popover-button'));

// Show the popover
popoverInstance.show();

// Hide the popover
popoverInstance.hide();`}
                  </code>
                </pre>

                <br />

                <h2>Events</h2>
                <p>Bootstrap provides events for popovers to allow custom behaviors:</p>
                <table>
                  <thead>
                    <tr>
                      <th>Event</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><code>show.bs.popover</code></td>
                      <td>Triggered before the popover is shown.</td>
                    </tr>
                    <tr>
                      <td><code>shown.bs.popover</code></td>
                      <td>Triggered after the popover is shown.</td>
                    </tr>
                    <tr>
                      <td><code>hide.bs.popover</code></td>
                      <td>Triggered before the popover is hidden.</td>
                    </tr>
                    <tr>
                      <td><code>hidden.bs.popover</code></td>
                      <td>Triggered after the popover is hidden.</td>
                    </tr>
                  </tbody>
                </table>
                   <pre className={style.codeoverflow}>
                  <code>
                    {`var popoverEl = document.querySelector('.popover-button');

popoverEl.addEventListener('shown.bs.popover', function () {
  console.log('Popover is now visible!');
});`}
                  </code>
                </pre>

                <br />

                <h2>Example</h2>
                   <pre className={style.codeoverflow}>
                  <code>
                    {`<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Bootstrap Popover</title>
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha3/dist/css/bootstrap.min.css" rel="stylesheet">
</head>
<body>
  <div class="container mt-5">
    <button type="button" class="btn btn-secondary" 
      data-bs-toggle="popover" 
      title="Popover Example" 
      data-bs-content="This is a popover example.">
      Click for Popover
    </button>
  </div>

  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha3/dist/js/bootstrap.bundle.min.js"></script>
  <script>
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
      return new bootstrap.Popover(popoverTriggerEl);
    });
  </script>
</body>
</html>`}
                  </code>
                </pre>
              </div>
            </div>
          )}



          {selectedChapter === 'chapter68' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Scrollspy</h1>

              <p>
                The Bootstrap Scrollspy plugin automatically updates the active link in a navigation list based on the user's scroll position. It ensures smooth navigation, especially on pages with long content.
              </p>

              <br />

              <h2>Basic Syntax</h2>
              <p>
                To enable Scrollspy, add the <code>data-bs-spy="scroll"</code> attribute to the container you want to spy on, and specify a target navigation element using the <code>data-bs-target</code> attribute.
              </p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<nav id="navbar-example" class="navbar navbar-light bg-light">
  <ul class="nav nav-pills">
    <li class="nav-item">
      <a class="nav-link active" href="#section1">Section 1</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" href="#section2">Section 2</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" href="#section3">Section 3</a>
    </li>
  </ul>
</nav>

<div data-bs-spy="scroll" data-bs-target="#navbar-example" data-bs-offset="0" class="scrollspy-example">
  <h4 id="section1">Section 1</h4>
  <p>Content for section 1...</p>
  <h4 id="section2">Section 2</h4>
  <p>Content for section 2...</p>
  <h4 id="section3">Section 3</h4>
  <p>Content for section 3...</p>
</div>`}
                </code>
              </pre>

              <hr />

              <h2>Initialization</h2>
              <p>Scrollspy can be initialized via JavaScript or data attributes.</p>

              <h3>1. Via JavaScript</h3>
                 <pre className={style.codeoverflow}>
                <code>
                  {`var scrollSpy = new bootstrap.ScrollSpy(document.body, {
  target: '#navbar-example'
});`}
                </code>
              </pre>

              <h3>2. Via Data Attributes</h3>
              <p>
                No additional JavaScript code is required when using the{' '}
                <code>data-bs-spy</code> attribute in conjunction with{' '}
                <code>data-bs-target</code>.
              </p>

              <hr />

              <h2>Options</h2>
              <p>You can customize Scrollspy behavior using JavaScript options:</p>
              <ul>
                <li>
                  <code>offset</code>: Number of pixels to offset from the top when
                  calculating active links.
                </li>
                <li>
                  <code>target</code>: The target navigation element selector.
                </li>
                <li>
                  <code>method</code>: The method used to determine active links
                  (<code>'auto'</code> or <code>'position'</code>).
                </li>
              </ul>
                 <pre className={style.codeoverflow}>
                <code>
                  {`var scrollSpy = new bootstrap.ScrollSpy(document.body, {
  target: '#navbar-example',
  offset: 10
});`}
                </code>
              </pre>

              <hr />

              <h2>Methods</h2>
              <p>Bootstrap Scrollspy includes methods for programmatic control:</p>
              <ul>
                <li>
                  <code>.refresh()</code>: Recalculates active link positions.
                </li>
                <li>
                  <code>.dispose()</code>: Destroys the Scrollspy instance.
                </li>
              </ul>
                 <pre className={style.codeoverflow}>
                <code>
                  {`var scrollSpy = new bootstrap.ScrollSpy(document.body, {
  target: '#navbar-example'
});

// Recalculate positions
scrollSpy.refresh();

// Dispose of the Scrollspy instance
scrollSpy.dispose();`}
                </code>
              </pre>

              <hr />

              <h2>Example</h2>
              <p>Here's a full example of using Scrollspy:</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Bootstrap Scrollspy</title>
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha3/dist/css/bootstrap.min.css" rel="stylesheet">
</head>
<body>
  <nav id="navbar-example" class="navbar navbar-light bg-light fixed-top">
    <ul class="nav nav-pills">
      <li class="nav-item">
        <a class="nav-link active" href="#section1">Section 1</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#section2">Section 2</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#section3">Section 3</a>
      </li>
    </ul>
  </nav>

  <div data-bs-spy="scroll" data-bs-target="#navbar-example" data-bs-offset="0" class="scrollspy-example mt-5" tabindex="0">
    <h4 id="section1">Section 1</h4>
    <p>Content for section 1...</p>
    <h4 id="section2">Section 2</h4>
    <p>Content for section 2...</p>
    <h4 id="section3">Section 3</h4>
    <p>Content for section 3...</p>
  </div>

  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha3/dist/js/bootstrap.bundle.min.js"></script>
</body>
</html>`}
                </code>
              </pre>

              <p>
                Use this guide to easily integrate and customize Scrollspy in your
                projects!
              </p>



            </div>
          )}




          {selectedChapter === 'chapter69' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}> Tab </h1>

              <p>
                The Bootstrap Tab component allows you to create tabbed navigation,
                enabling users to toggle between sections of content while staying on the same page.
              </p>

              <br />

              <h2>Basic Syntax</h2>
              <p>
                To create a tabbed interface, use the <code>nav</code> class for the navigation and
                <code>tab-content</code> for the tabbed content.
              </p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<ul class="nav nav-tabs" id="myTab" role="tablist">
  <li class="nav-item" role="presentation">
    <button class="nav-link active" id="home-tab" data-bs-toggle="tab" 
            data-bs-target="#home" type="button" role="tab" 
            aria-controls="home" aria-selected="true">
      Home
    </button>
  </li>
  <li class="nav-item" role="presentation">
    <button class="nav-link" id="profile-tab" data-bs-toggle="tab" 
            data-bs-target="#profile" type="button" role="tab" 
            aria-controls="profile" aria-selected="false">
      Profile
    </button>
  </li>
</ul>
<div class="tab-content" id="myTabContent">
  <div class="tab-pane fade show active" id="home" role="tabpanel" 
       aria-labelledby="home-tab">
    Home content goes here...
  </div>
  <div class="tab-pane fade" id="profile" role="tabpanel" 
       aria-labelledby="profile-tab">
    Profile content goes here...
  </div>
</div>`}
                </code>
              </pre>


              <br />

              <h2>Initialization</h2>
              <p style={{ paddingBottom: "6px" }}>Tabs can be initialized via JavaScript or data attributes.</p>

              <h3>1. Via JavaScript</h3>
                 <pre className={style.codeoverflow}>
                <code>
                  {`var triggerTabList = [].slice.call(document.querySelectorAll('#myTab button'))
triggerTabList.forEach(function (triggerEl) {
  var tabTrigger = new bootstrap.Tab(triggerEl)

  triggerEl.addEventListener('click', function (event) {
    event.preventDefault()
    tabTrigger.show()
  })
})`}
                </code>
              </pre>

              <h3>2. Via Data Attributes</h3>
              <p>
                No additional JavaScript is required if you use the <code>data-bs-toggle</code>
                attribute on the tab buttons.
              </p>

              <br />

              <h2>Methods</h2>
              <p>Bootstrap Tabs provide several methods for programmatic control:</p>
              <ul>
                <li>
                  <code>.show()</code>: Activates the tab and displays the corresponding content.
                </li><br />
                <li>
                  <code>.dispose()</code>: Destroys the tab instance.
                </li>
              </ul><br />

                 <pre className={style.codeoverflow}>
                <code>
                  {`var myTab = new bootstrap.Tab(document.querySelector('#profile-tab'));

// Activate the tab programmatically
myTab.show();

// Dispose the tab instance
myTab.dispose();`}
                </code>
              </pre>

              <br />

              <h2>Events</h2>
              <p>
                Bootstrap provides events for handling tab interactions, such as showing or hiding tabs.
              </p>
              <table>
                <thead>
                  <tr>
                    <th>Event</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><code>show.bs.tab</code></td>
                    <td>Triggered when a tab is about to be shown.</td>
                  </tr>
                  <tr>
                    <td><code>shown.bs.tab</code></td>
                    <td>Triggered after a tab is shown.</td>
                  </tr>
                  <tr>
                    <td><code>hide.bs.tab</code></td>
                    <td>Triggered when a tab is about to be hidden.</td>
                  </tr>
                  <tr>
                    <td><code>hidden.bs.tab</code></td>
                    <td>Triggered after a tab is hidden.</td>
                  </tr>
                </tbody>
              </table>

                 <pre className={style.codeoverflow}>
                <code>
                  {`document.querySelector('#home-tab').addEventListener('shown.bs.tab', function (event) {
  console.log('The home tab is now active!');
})`}
                </code>
              </pre>

              <br />

              <h2>Example</h2>
              <p>Here's a complete example:</p>

                 <pre className={style.codeoverflow}>
                <code>
                  {`<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Bootstrap Tabs</title>
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha3/dist/css/bootstrap.min.css" rel="stylesheet">
</head>
<body>
  <div class="container mt-5">
    <ul class="nav nav-tabs" id="myTab" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link active" id="home-tab" data-bs-toggle="tab" 
                data-bs-target="#home" type="button" role="tab" 
                aria-controls="home" aria-selected="true">
          Home
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button class="nav-link" id="profile-tab" data-bs-toggle="tab" 
                data-bs-target="#profile" type="button" role="tab" 
                aria-controls="profile" aria-selected="false">
          Profile
        </button>
      </li>
    </ul>
    <div class="tab-content" id="myTabContent">
      <div class="tab-pane fade show active" id="home" role="tabpanel" 
           aria-labelledby="home-tab">
        Home content goes here...
      </div>
      <div class="tab-pane fade" id="profile" role="tabpanel" 
           aria-labelledby="profile-tab">
        Profile content goes here...
      </div>
    </div>
  </div>

  <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha3/dist/js/bootstrap.bundle.min.js"></script>
</body>
</html>`}
                </code>
              </pre>

              <p>
                Use this guide to seamlessly implement tabbed navigation in your projects!
              </p>



            </div>
          )}

          {selectedChapter === 'chapter70' && (
            <div className={style.chaptercontent}>
              <h1 className={style.heading}>Tooltip</h1>
              <p>
                The <strong>Tooltip</strong> component in Bootstrap is a small pop-up box that appears when the user moves the mouse pointer over an element. It's a powerful way to display additional information or guidance without cluttering the interface.
              </p><br />

              <h2>Basic Example of Bootstrap Tooltip</h2>
              <p>Here’s a basic example of how to implement a tooltip using Bootstrap:</p>
                 <pre className={style.codeoverflow}>
                <code>
                  {`<!-- Include Bootstrap CSS and JS -->`}
                  <br />
                  {`<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css" rel="stylesheet">`}
                  <br />
                  {`<script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/js/bootstrap.bundle.min.js"></script>`}
                  <br />
                  <br />
                  {`<!-- Tooltip Example -->`}
                  <br />
                  {`<button type="button" class="btn btn-secondary" data-bs-toggle="tooltip" data-bs-placement="top" title="Tooltip on top">`}
                  <br />
                  {`Hover over me`}
                  <br />
                  {`</button>`}
                </code>
              </pre><br />

              <h2>How Bootstrap Tooltips Work</h2>
              <ol>
                <li>
                  <strong>Triggering Tooltips</strong>: The <code>data-bs-toggle="tooltip"</code> attribute is added to the HTML element you want to attach the tooltip to. The <code>title</code> attribute contains the tooltip text.
                </li><br />
                <li>
                  <strong>Positioning Tooltips</strong>: You can use the <code>data-bs-placement</code> attribute to position the tooltip. Common options are <code>top</code>, <code>bottom</code>, <code>left</code>, and <code>right</code>.
                </li>
              </ol><br />

              <h2>Tooltip Initialization</h2>
              <p style={{ paddingBottom: "6px" }}>
                Tooltips require JavaScript to function. You can either initialize all tooltips on a page or specific ones.
              </p>

              <h3>Initialize all Tooltips:</h3>
                 <pre className={style.codeoverflow}>
                <code>
                  {`// Initialize tooltips globally`}
                  <br />
                  {`var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));`}
                  <br />
                  {`var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {`}
                  <br />
                  {`  return new bootstrap.Tooltip(tooltipTriggerEl);`}
                  <br />
                  {`});`}
                </code>
              </pre><br />

              <h3>Initialize a Specific Tooltip:</h3>
                 <pre className={style.codeoverflow}>
                <code>
                  {`// Initialize a single tooltip`}
                  <br />
                  {`var tooltipTriggerEl = document.querySelector('#exampleTooltip');`}
                  <br />
                  {`var tooltip = new bootstrap.Tooltip(tooltipTriggerEl);`}
                </code>
              </pre><br />

              <h2>Tooltip Options</h2>
              <p>
                You can customize tooltips using various options in Bootstrap:
              </p>
              <ul>
                <li><code>animation</code>: Boolean to enable/disable CSS fade effect (<code>true</code> by default).</li><br />
                <li><code>html</code>: Allows HTML inside the tooltip (<code>false</code> by default).</li><br />
                <li><code>placement</code>: Specifies the position (<code>top</code>, <code>bottom</code>, <code>left</code>, <code>right</code>, <code>auto</code>).</li><br />
                <li><code>delay</code>: Delay showing/hiding tooltip (in milliseconds).</li>
              </ul><br />

              <h3>Customized Tooltip Example:</h3>
                 <pre className={style.codeoverflow}>
                <code>
                  {`var tooltip = new bootstrap.Tooltip(tooltipTriggerEl, {`}
                  <br />
                  {`  animation: true,`}
                  <br />
                  {`  placement: 'bottom',`}
                  <br />
                  {`  delay: { "show": 500, "hide": 100 },`}
                  <br />
                  {`  html: true,`}
                  <br />
                  {`  title: '<strong>Bold Text!</strong> Tooltip with HTML'`}
                  <br />
                  {`});`}
                </code>
              </pre><br />

              <h2>Programmatically Showing or Hiding Tooltips</h2>
              <p style={{ paddingBottom: "6px" }}>You can programmatically control the visibility of tooltips with JavaScript:</p>

              <h3>Show Tooltip:</h3>
                 <pre className={style.codeoverflow}>
                <code>{`tooltip.show();`}</code>
              </pre><br />

              <h3>Hide Tooltip:</h3>
                 <pre className={style.codeoverflow}>
                <code>{`tooltip.hide();`}</code>
              </pre><br />

              <h3>Toggle Tooltip:</h3>
                 <pre className={style.codeoverflow}>
                <code>{`tooltip.toggle();`}</code>
              </pre><br />

              <h2>Tooltip Events</h2>
              <p>
                Bootstrap tooltips emit several events that you can listen for to handle behavior:
              </p>
              <ul>
                <li><code>show.bs.tooltip</code>: Fired when the tooltip is about to be shown.</li><br />
                <li><code>shown.bs.tooltip</code>: Fired when the tooltip has been fully shown.</li><br />
                <li><code>hide.bs.tooltip</code>: Fired when the tooltip is about to be hidden.</li><br />
                <li><code>hidden.bs.tooltip</code>: Fired when the tooltip has been fully hidden.</li>
              </ul><br />

              <h3>Listening to Tooltip Events:</h3>
                 <pre className={style.codeoverflow}>
                <code>
                  {`var myTooltipEl = document.getElementById('exampleTooltip');`}
                  <br />
                  {`myTooltipEl.addEventListener('shown.bs.tooltip', function () {`}
                  <br />
                  {`  console.log('Tooltip is fully visible!');`}
                  <br />
                  {`});`}
                </code>
              </pre><br />

              <h2>Conclusion</h2>
              <p>
                The Bootstrap Tooltip component is a versatile and user-friendly tool for providing additional context or information. Whether you are looking to enhance user experience or provide subtle hints, tooltips can easily be integrated into your Bootstrap-based project.
              </p>
            </div>
          )}





        </div>
      </div>
    </div>

  );

}


export default Bootstrapcourse;


